// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
  baseUrl: `${string}://apps` | (string & unknown);
};

export type AddressSearchResponse = {
  moreResultsAvailable: boolean;
  confidence: string;
  suggestions: Array<AddressSuggestion>;
};

export type AddressSuggestion = {
  globalAddressKey: string;
  text: string;
};

export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: unknown;
};

export type AddressDetailsResponse = {
  line1?: string | null;
  line2?: string | null;
  line3?: string | null;
  line4?: string | null;
  town?: string | null;
  county?: string | null;
  postCode?: string | null;
  country?: string | null;
};

export type AddressDetailsRequest = {
  globalAddressKey: string;
};

export type BaseRateResponse = {
  code: string;
  name: string;
  interestRates?: Array<InterestRate>;
  variabilityType: StringPair;
  rate?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  versionNumber?: number;
  lockedByActionId?: string | null;
};

export type InterestRate = {
  index?: number;
  amount?: number;
  startDate?: string;
  endDate?: string | null;
};

export type StringPair = {
  key: string;
  value: string;
};

export type OhpenValidationError = ProblemDetails & {
  'invalid-params'?: Array<InvalidParameter> | null;
  [key: string]: unknown;
};

export type InvalidParameter = {
  name?: string | null;
  reason?: string | null;
};

export type BaseRateCrudChangeResponse = {
  isValid?: boolean;
  actionId?: string | null;
  errors?: BaseRateValidationErrors | null;
};

export type BaseRateValidationErrors = {
  code?: Array<string>;
  name?: Array<string>;
  variabilityType?: Array<string>;
  amount?: Array<string>;
  startDate?: Array<string>;
  lockedByActionId?: Array<string>;
};

export type ChangeRequestOfBaseRateRequest = {
  data: BaseRateRequest;
  actionType: ActionType;
};

export type BaseRateRequest = ILockable & {
  code?: string;
  name?: string | null;
  variabilityType?: VariabilityType | null;
  amount?: number | null;
  startDate?: string | null;
  lockedByActionId?: string | null;
};

export enum VariabilityType {
  /**
   * FIXED
   */
  FIXED = 'FIXED',
  /**
   * VARIABLE
   */
  VARIABLE = 'VARIABLE',
}

export type ILockable = {
  lockedByActionId?: string | null;
};

export enum ActionType {
  /**
   * CREATE
   */
  CREATE = 'CREATE',
  /**
   * EDIT
   */
  EDIT = 'EDIT',
  /**
   * CLONE
   */
  CLONE = 'CLONE',
  /**
   * IMPORT
   */
  IMPORT = 'IMPORT',
  /**
   * REPLACE
   */
  REPLACE = 'REPLACE',
  /**
   * DELETE
   */
  DELETE = 'DELETE',
  /**
   * REORDER
   */
  REORDER = 'REORDER',
  /**
   * BULK_CLONE
   */
  BULK_CLONE = 'BULK_CLONE',
  /**
   * BULK_EDIT
   */
  BULK_EDIT = 'BULK_EDIT',
}

export type UsageResponse = {
  isUsed: boolean;
};

export type DeletePrecheckResult = {
  canDelete?: Array<string>;
  notFound?: Array<string>;
  blocked?: Array<DeletePrecheckItem>;
};

export type DeletePrecheckItem = {
  id: string;
  errors: Array<string>;
};

export type DeleteCrRequest = {
  ids?: Array<string>;
};

export type CreateDeleteCrResponse = {
  actionId?: string;
};

export type ChangeDataResponseOfBaseRateChangeDataRow = {
  actionId: string;
  rows: Array<BaseRateChangeDataRow>;
  originalRows: Array<BaseRateChangeDataRow>;
  reviewInfo: ReviewInfo;
  pageOptions: PageResponse;
  validationFeedback: {
    [key: string]: ChangeRequestRowFeedback;
  };
  isValid: boolean | null;
};

export type BaseRateChangeDataRow = BaseRateRequest & {
  rowNumber?: number;
  isUsed?: boolean;
};

export type ReviewInfo = {
  reviewedBy?: string;
  timeOfReview?: string;
  reviewComment?: string | null;
};

export type PageResponse = {
  /**
   * Number of elements per page
   */
  pageSize: number;
  /**
   * Token to retrieve the next page. Null when there are no more pages
   */
  paginationToken?: string | null;
};

export type ChangeRequestRowFeedback = {
  errors: Array<string>;
  cellsFeedback: {
    [key: string]: ChangeRequestCellFeedback;
  };
};

export type ChangeRequestCellFeedback = {
  errors: Array<string>;
  warnings: Array<string>;
  suggestions: Array<string>;
  modified: boolean;
};

export type ChangeRequestValidationResponse = {
  rowValidations: {
    [key: string]: ChangeRequestRowFeedback;
  };
  isValid: boolean;
  pageOptions: PageResponse;
};

export type AddRowsRequestOfBaseRateChangeDataRow = {
  data: Array<BaseRateChangeDataRow>;
};

export type BdmResponse = {
  id: string;
  name: string;
  description?: string | null;
  contactNumber: string;
  regionIds: Array<string>;
  assignedTradingAddresses?: Array<TradingAddressAssignmentResponse>;
};

export type TradingAddressAssignmentResponse = {
  firmName?: string;
  addressLabel?: string;
};

export type BdmRequest = {
  name: string;
  description?: string | null;
  contactNumber: string;
  regionIds: Array<string>;
};

export type BdmReplaceRequest = {
  replacementBdmId: string;
};

export type ChangeLogEntriesResponse = {
  items: Array<ChangeRequestResponse>;
  pageOptions: PageResponse;
};

export type ChangeRequestResponse = {
  actionId?: string;
  creationTime?: string | null;
  appliedAt?: string | null;
  createdBy?: string;
  createdByAssistant?: boolean;
  reviewInfo?: ReviewInfo | null;
  actionType: StringPair;
  actionEntityType: StringPair;
  status: StringPair;
  invalidationSource?: StringPair | null;
  processingError?: string | null;
  columns?: Array<ColumnMapping>;
  modifiedFields?: Array<string>;
};

export type ColumnMapping = {
  /**
   * Name of the field in PMP model
   */
  key?: string;
  /**
   * Name of the field in user/client file
   */
  clientKey?: string;
};

export enum ActionEntityType {
  /**
   * PRODUCTS
   */
  PRODUCTS = 'PRODUCTS',
  /**
   * BASE_RATES
   */
  BASE_RATES = 'BASE_RATES',
  /**
   * ERC_PROFILES
   */
  ERC_PROFILES = 'ERC_PROFILES',
  /**
   * FEE_PROFILES
   */
  FEE_PROFILES = 'FEE_PROFILES',
  /**
   * FEES
   */
  FEES = 'FEES',
  /**
   * LENDERS
   */
  LENDERS = 'LENDERS',
  /**
   * FIRMS
   */
  FIRMS = 'FIRMS',
  /**
   * PROCURATION_FEES
   */
  PROCURATION_FEES = 'PROCURATION_FEES',
  /**
   * PROCURATION_FEE_RULES
   */
  PROCURATION_FEE_RULES = 'PROCURATION_FEE_RULES',
  /**
   * EXCLUSIVITY_SETS
   */
  EXCLUSIVITY_SETS = 'EXCLUSIVITY_SETS',
  /**
   * EXCHANGE_RATES
   */
  EXCHANGE_RATES = 'EXCHANGE_RATES',
  /**
   * INTEREST_RATES
   */
  INTEREST_RATES = 'INTEREST_RATES',
  /**
   * BROKERS
   */
  BROKERS = 'BROKERS',
  /**
   * DEFAULT_PROCURATION_FEE_ASSIGNMENTS
   */
  DEFAULT_PROCURATION_FEE_ASSIGNMENTS = 'DEFAULT_PROCURATION_FEE_ASSIGNMENTS',
  /**
   * FIRM_PROCURATION_FEE_ASSIGNMENTS
   */
  FIRM_PROCURATION_FEE_ASSIGNMENTS = 'FIRM_PROCURATION_FEE_ASSIGNMENTS',
}

export type FieldChangeResponse = {
  fieldName: string;
  previousValue?: unknown;
  newValue?: unknown;
  rowKey?: string | null;
};

export type CreateDraftRequest = {
  actionType: ActionType;
  actionEntityType: ActionEntityType;
};

export type ChangeRequestComment = {
  comment?: string | null;
};

export type SetCloneTypeRequest = {
  actionType: ActionType;
};

export type ConfigurationResponse = {
  brands: Array<Brand>;
  additionalFields: Array<AdditionalField>;
  featureToggles: FeatureToggles;
  agentUrl?: string | null;
  defaultTechnicalProductCode?: string | null;
  versionNumber: number;
  notes: NotesConfiguration;
  groupPermissions: {
    [key: string]: {
      [key: string]: Array<PermissionAction>;
    };
  };
  pmpVersion: string;
  brsVersion: string;
  isFlexibleProcFeeActive: boolean;
  isBoSyncActive: boolean;
};

export type Brand = {
  code: string;
  name?: string | null;
};

export type AdditionalField = {
  code: string;
  name?: string | null;
};

export type FeatureToggles = {
  enableImports: boolean;
  enableFeesImport: boolean;
  enableFeeProfilesImport: boolean;
  enableFirmsImport: boolean;
  enableExports: boolean;
  enableSaveView: boolean;
  enableProductsCrud: boolean;
  enableProductsBulkCrud: boolean;
  enableErcProfilesCrud: boolean;
  enableFeeProfilesCrud: boolean;
  enableFeesCrud: boolean;
  enableAdditionalFields: boolean;
  enableExclusivesCrud: boolean;
  enableEditingLiveProducts: boolean;
  enableExchangeRates: boolean;
  enableForceStressRatesUpdates: boolean;
  enableLender: boolean;
  enableLenderProcurationFeesCrud: boolean;
  enableLenderCrud: boolean;
  enableFirms: boolean;
  enableFirmsCrud: boolean;
  enableLegacyFirmProcurationFeeAssignments: boolean;
  enableBrokers: boolean;
  enableBrokersCrud: boolean;
  enableProcurationFees: boolean;
  enableProcurationFeesCrud: boolean;
  enableProcurationFeeRulesCrud: boolean;
  enableFourEyes: boolean;
  enableDarkMode: boolean;
  enableProductGroups: boolean;
  enableChangeLog: boolean;
  enableAssistant: boolean;
  enableConfig: boolean;
  enableBankOfEnglandRateAutoUpdate: boolean;
};

export type NotesConfiguration = {
  defaultEditWindowDays?: number;
};

export enum PermissionResource {
  /**
   * PRODUCTS
   */
  PRODUCTS = 'PRODUCTS',
  /**
   * BASE_RATES
   */
  BASE_RATES = 'BASE_RATES',
  /**
   * EXCHANGE_RATES
   */
  EXCHANGE_RATES = 'EXCHANGE_RATES',
  /**
   * ERC_PROFILES
   */
  ERC_PROFILES = 'ERC_PROFILES',
  /**
   * FEES
   */
  FEES = 'FEES',
  /**
   * FEE_PROFILES
   */
  FEE_PROFILES = 'FEE_PROFILES',
  /**
   * EXCLUSIVITY_SETS
   */
  EXCLUSIVITY_SETS = 'EXCLUSIVITY_SETS',
  /**
   * IMPORT
   */
  IMPORT = 'IMPORT',
  /**
   * EXPORT_TEMPLATES
   */
  EXPORT_TEMPLATES = 'EXPORT_TEMPLATES',
  /**
   * CHANGE_REQUESTS
   */
  CHANGE_REQUESTS = 'CHANGE_REQUESTS',
  /**
   * LENDER
   */
  LENDER = 'LENDER',
  /**
   * FIRMS
   */
  FIRMS = 'FIRMS',
  /**
   * INTERMEDIARIES
   */
  INTERMEDIARIES = 'INTERMEDIARIES',
  /**
   * PROCURATION_FEES
   */
  PROCURATION_FEES = 'PROCURATION_FEES',
  /**
   * LENDER_USERS
   */
  LENDER_USERS = 'LENDER_USERS',
  /**
   * COMPLIANCE
   */
  COMPLIANCE = 'COMPLIANCE',
  /**
   * NOTES
   */
  NOTES = 'NOTES',
  /**
   * BROKER_PORTAL_CASES
   */
  BROKER_PORTAL_CASES = 'BROKER_PORTAL_CASES',
  /**
   * CONFIG_USERS
   */
  CONFIG_USERS = 'CONFIG_USERS',
  /**
   * CONFIG_ROLES
   */
  CONFIG_ROLES = 'CONFIG_ROLES',
  /**
   * CONFIG_PERMISSIONS
   */
  CONFIG_PERMISSIONS = 'CONFIG_PERMISSIONS',
  /**
   * CONFIG_FEATURE_FLAGS
   */
  CONFIG_FEATURE_FLAGS = 'CONFIG_FEATURE_FLAGS',
  /**
   * CONFIG_PARAMETERS
   */
  CONFIG_PARAMETERS = 'CONFIG_PARAMETERS',
  /**
   * CONFIG_VALUE_LISTS
   */
  CONFIG_VALUE_LISTS = 'CONFIG_VALUE_LISTS',
  /**
   * CONFIG_TRANSLATIONS
   */
  CONFIG_TRANSLATIONS = 'CONFIG_TRANSLATIONS',
  /**
   * CONFIG_CUSTOM_FIELDS
   */
  CONFIG_CUSTOM_FIELDS = 'CONFIG_CUSTOM_FIELDS',
  /**
   * CONFIG_AUDIT_LOG
   */
  CONFIG_AUDIT_LOG = 'CONFIG_AUDIT_LOG',
}

export enum PermissionAction {
  /**
   * VIEW
   */
  VIEW = 'VIEW',
  /**
   * CREATE
   */
  CREATE = 'CREATE',
  /**
   * UPDATE
   */
  UPDATE = 'UPDATE',
  /**
   * DELETE
   */
  DELETE = 'DELETE',
  /**
   * REVIEW
   */
  REVIEW = 'REVIEW',
  /**
   * SELF_REVIEW
   */
  SELF_REVIEW = 'SELF_REVIEW',
}

export type ErcProfile = {
  ercProfileId?: string;
  name?: string;
  penaltyTiers?: Array<PenaltyTier>;
  penaltyValues?: Array<number>;
  lockedByActionId?: string | null;
  linkedToActiveToday?: boolean | null;
};

export type PenaltyTier = {
  order?: number;
  durationInMonths?: number | null;
  penaltyPercentage?: number;
  endDate?: string | null;
};

export type ErcProfileCrudChangeResponse = {
  isValid?: boolean;
  errors?: ErcValidationErrors;
  actionId?: string | null;
};

export type ErcValidationErrors = {
  ercProfileId?: Array<string>;
  name?: Array<string>;
  penaltyTiers?: {
    [key: string]: ErcBandValidationErrors;
  };
  penaltyTiersErrors?: Array<string>;
};

export type ErcBandValidationErrors = {
  order?: Array<string>;
  durationInMonths?: Array<string>;
  penaltyPercentage?: Array<string>;
  endDate?: Array<string>;
};

export type ChangeRequestOfErcProfileCrudRequest = {
  data: ErcProfileCrudRequest;
  actionType: ActionType;
};

export type ErcProfileCrudRequest = ILockable & {
  ercProfileId?: string;
  name?: string;
  penaltyTiers?: Array<PenaltyTierRequest> | null;
};

export type PenaltyTierRequest = {
  order?: number | null;
  durationInMonths?: number | null;
  endDate?: string | null;
  penaltyPercentage?: number | null;
};

export type ChangeDataResponseOfErcProfileChangeDataRow = {
  actionId: string;
  rows: Array<ErcProfileChangeDataRow>;
  originalRows: Array<ErcProfileChangeDataRow>;
  reviewInfo: ReviewInfo;
  pageOptions: PageResponse;
  validationFeedback: {
    [key: string]: ChangeRequestRowFeedback;
  };
  isValid: boolean | null;
};

export type ErcProfileChangeDataRow = ErcProfileRequest & {
  rowNumber?: number;
  originalCode?: string | null;
  isUsed?: boolean;
};

export type ErcProfileRequest = ILockable & {
  ercProfileId?: string | null;
  name?: string | null;
  durationInMonths?: number | null;
  penaltyPercentage?: number | null;
  order?: number | null;
  endDate?: string | null;
  lockedByActionId?: string | null;
};

export type AddRowsRequestOfErcProfileChangeDataRow = {
  data: Array<ErcProfileChangeDataRow>;
};

export type GroupedExchangeRateResponse = {
  sourceCurrency?: string;
  targetCurrency?: string;
  description?: string;
  abbreviation?: string;
  symbol?: string;
  rate?: number | null;
  startDate?: string | null;
  rates?: Array<RateEntry>;
  lockedByActionId?: string | null;
};

export type RateEntry = {
  rate?: number;
  startDate?: string;
  endDate?: string | null;
  index?: number;
};

export type ExchangeRateChangeResponse = {
  isValid?: boolean;
  actionId?: string | null;
  errors?: {
    [key: string]: Array<string>;
  };
};

export type ChangeRequestOfExchangeRateCrudRequest = {
  data: ExchangeRateCrudRequest;
  actionType: ActionType;
};

export type ExchangeRateCrudRequest = {
  sourceCurrency?: SupportedCurrency | null;
  targetCurrency?: TargetCurrency;
  rate?: number | null;
  startDate?: string | null;
};

export enum SupportedCurrency {
  /**
   * CNY
   */
  CNY = 'CNY',
  /**
   * EUR
   */
  EUR = 'EUR',
  /**
   * GBP
   */
  GBP = 'GBP',
  /**
   * JPY
   */
  JPY = 'JPY',
  /**
   * USD
   */
  USD = 'USD',
  /**
   * AED
   */
  AED = 'AED',
  /**
   * AFN
   */
  AFN = 'AFN',
  /**
   * ALL
   */
  ALL = 'ALL',
  /**
   * AMD
   */
  AMD = 'AMD',
  /**
   * ANG
   */
  ANG = 'ANG',
  /**
   * AOA
   */
  AOA = 'AOA',
  /**
   * ARS
   */
  ARS = 'ARS',
  /**
   * AUD
   */
  AUD = 'AUD',
  /**
   * AWG
   */
  AWG = 'AWG',
  /**
   * AZN
   */
  AZN = 'AZN',
  /**
   * BAM
   */
  BAM = 'BAM',
  /**
   * BBD
   */
  BBD = 'BBD',
  /**
   * BDT
   */
  BDT = 'BDT',
  /**
   * BGN
   */
  BGN = 'BGN',
  /**
   * BHD
   */
  BHD = 'BHD',
  /**
   * BIF
   */
  BIF = 'BIF',
  /**
   * BMD
   */
  BMD = 'BMD',
  /**
   * BND
   */
  BND = 'BND',
  /**
   * BOB
   */
  BOB = 'BOB',
  /**
   * BRL
   */
  BRL = 'BRL',
  /**
   * BSD
   */
  BSD = 'BSD',
  /**
   * BTN
   */
  BTN = 'BTN',
  /**
   * BWP
   */
  BWP = 'BWP',
  /**
   * BYN
   */
  BYN = 'BYN',
  /**
   * BZD
   */
  BZD = 'BZD',
  /**
   * CAD
   */
  CAD = 'CAD',
  /**
   * CDF
   */
  CDF = 'CDF',
  /**
   * CHF
   */
  CHF = 'CHF',
  /**
   * CLP
   */
  CLP = 'CLP',
  /**
   * COP
   */
  COP = 'COP',
  /**
   * CRC
   */
  CRC = 'CRC',
  /**
   * CUC
   */
  CUC = 'CUC',
  /**
   * CUP
   */
  CUP = 'CUP',
  /**
   * CVE
   */
  CVE = 'CVE',
  /**
   * CZK
   */
  CZK = 'CZK',
  /**
   * DJF
   */
  DJF = 'DJF',
  /**
   * DKK
   */
  DKK = 'DKK',
  /**
   * DOP
   */
  DOP = 'DOP',
  /**
   * DZD
   */
  DZD = 'DZD',
  /**
   * EGP
   */
  EGP = 'EGP',
  /**
   * ERN
   */
  ERN = 'ERN',
  /**
   * ETB
   */
  ETB = 'ETB',
  /**
   * FJD
   */
  FJD = 'FJD',
  /**
   * FKP
   */
  FKP = 'FKP',
  /**
   * GEL
   */
  GEL = 'GEL',
  /**
   * GGP
   */
  GGP = 'GGP',
  /**
   * GHS
   */
  GHS = 'GHS',
  /**
   * GIP
   */
  GIP = 'GIP',
  /**
   * GMD
   */
  GMD = 'GMD',
  /**
   * GNF
   */
  GNF = 'GNF',
  /**
   * GTQ
   */
  GTQ = 'GTQ',
  /**
   * GYD
   */
  GYD = 'GYD',
  /**
   * HKD
   */
  HKD = 'HKD',
  /**
   * HNL
   */
  HNL = 'HNL',
  /**
   * HRK
   */
  HRK = 'HRK',
  /**
   * HTG
   */
  HTG = 'HTG',
  /**
   * HUF
   */
  HUF = 'HUF',
  /**
   * IDR
   */
  IDR = 'IDR',
  /**
   * ILS
   */
  ILS = 'ILS',
  /**
   * IMP
   */
  IMP = 'IMP',
  /**
   * INR
   */
  INR = 'INR',
  /**
   * IQD
   */
  IQD = 'IQD',
  /**
   * IRR
   */
  IRR = 'IRR',
  /**
   * ISK
   */
  ISK = 'ISK',
  /**
   * JEP
   */
  JEP = 'JEP',
  /**
   * JMD
   */
  JMD = 'JMD',
  /**
   * JOD
   */
  JOD = 'JOD',
  /**
   * KES
   */
  KES = 'KES',
  /**
   * KGS
   */
  KGS = 'KGS',
  /**
   * KHR
   */
  KHR = 'KHR',
  /**
   * KMF
   */
  KMF = 'KMF',
  /**
   * KPW
   */
  KPW = 'KPW',
  /**
   * KRW
   */
  KRW = 'KRW',
  /**
   * KWD
   */
  KWD = 'KWD',
  /**
   * KYD
   */
  KYD = 'KYD',
  /**
   * KZT
   */
  KZT = 'KZT',
  /**
   * LAK
   */
  LAK = 'LAK',
  /**
   * LBP
   */
  LBP = 'LBP',
  /**
   * LKR
   */
  LKR = 'LKR',
  /**
   * LRD
   */
  LRD = 'LRD',
  /**
   * LSL
   */
  LSL = 'LSL',
  /**
   * LYD
   */
  LYD = 'LYD',
  /**
   * MAD
   */
  MAD = 'MAD',
  /**
   * MDL
   */
  MDL = 'MDL',
  /**
   * MGA
   */
  MGA = 'MGA',
  /**
   * MKD
   */
  MKD = 'MKD',
  /**
   * MMK
   */
  MMK = 'MMK',
  /**
   * MNT
   */
  MNT = 'MNT',
  /**
   * MOP
   */
  MOP = 'MOP',
  /**
   * MRU
   */
  MRU = 'MRU',
  /**
   * MUR
   */
  MUR = 'MUR',
  /**
   * MVR
   */
  MVR = 'MVR',
  /**
   * MWK
   */
  MWK = 'MWK',
  /**
   * MXN
   */
  MXN = 'MXN',
  /**
   * MYR
   */
  MYR = 'MYR',
  /**
   * MZN
   */
  MZN = 'MZN',
  /**
   * NAD
   */
  NAD = 'NAD',
  /**
   * NGN
   */
  NGN = 'NGN',
  /**
   * NIO
   */
  NIO = 'NIO',
  /**
   * NOK
   */
  NOK = 'NOK',
  /**
   * NPR
   */
  NPR = 'NPR',
  /**
   * NZD
   */
  NZD = 'NZD',
  /**
   * OMR
   */
  OMR = 'OMR',
  /**
   * PAB
   */
  PAB = 'PAB',
  /**
   * PEN
   */
  PEN = 'PEN',
  /**
   * PGK
   */
  PGK = 'PGK',
  /**
   * PHP
   */
  PHP = 'PHP',
  /**
   * PKR
   */
  PKR = 'PKR',
  /**
   * PLN
   */
  PLN = 'PLN',
  /**
   * PYG
   */
  PYG = 'PYG',
  /**
   * QAR
   */
  QAR = 'QAR',
  /**
   * RON
   */
  RON = 'RON',
  /**
   * RSD
   */
  RSD = 'RSD',
  /**
   * RUB
   */
  RUB = 'RUB',
  /**
   * RWF
   */
  RWF = 'RWF',
  /**
   * SAR
   */
  SAR = 'SAR',
  /**
   * SBD
   */
  SBD = 'SBD',
  /**
   * SCR
   */
  SCR = 'SCR',
  /**
   * SDG
   */
  SDG = 'SDG',
  /**
   * SEK
   */
  SEK = 'SEK',
  /**
   * SGD
   */
  SGD = 'SGD',
  /**
   * SHP
   */
  SHP = 'SHP',
  /**
   * SLL
   */
  SLL = 'SLL',
  /**
   * SOS
   */
  SOS = 'SOS',
  /**
   * SPL
   */
  SPL = 'SPL',
  /**
   * SRD
   */
  SRD = 'SRD',
  /**
   * STN
   */
  STN = 'STN',
  /**
   * SVC
   */
  SVC = 'SVC',
  /**
   * SYP
   */
  SYP = 'SYP',
  /**
   * SZL
   */
  SZL = 'SZL',
  /**
   * THB
   */
  THB = 'THB',
  /**
   * TJS
   */
  TJS = 'TJS',
  /**
   * TMT
   */
  TMT = 'TMT',
  /**
   * TND
   */
  TND = 'TND',
  /**
   * TOP
   */
  TOP = 'TOP',
  /**
   * TRY
   */
  TRY = 'TRY',
  /**
   * TTD
   */
  TTD = 'TTD',
  /**
   * TVD
   */
  TVD = 'TVD',
  /**
   * TWD
   */
  TWD = 'TWD',
  /**
   * TZS
   */
  TZS = 'TZS',
  /**
   * UAH
   */
  UAH = 'UAH',
  /**
   * UGX
   */
  UGX = 'UGX',
  /**
   * UYU
   */
  UYU = 'UYU',
  /**
   * UZS
   */
  UZS = 'UZS',
  /**
   * VEF
   */
  VEF = 'VEF',
  /**
   * VES
   */
  VES = 'VES',
  /**
   * VND
   */
  VND = 'VND',
  /**
   * VUV
   */
  VUV = 'VUV',
  /**
   * WST
   */
  WST = 'WST',
  /**
   * XAF
   */
  XAF = 'XAF',
  /**
   * XAG
   */
  XAG = 'XAG',
  /**
   * XAU
   */
  XAU = 'XAU',
  /**
   * XCD
   */
  XCD = 'XCD',
  /**
   * XDR
   */
  XDR = 'XDR',
  /**
   * XOF
   */
  XOF = 'XOF',
  /**
   * XPD
   */
  XPD = 'XPD',
  /**
   * XPF
   */
  XPF = 'XPF',
  /**
   * XPT
   */
  XPT = 'XPT',
  /**
   * YER
   */
  YER = 'YER',
  /**
   * ZAR
   */
  ZAR = 'ZAR',
  /**
   * ZMW
   */
  ZMW = 'ZMW',
  /**
   * ZWD
   */
  ZWD = 'ZWD',
}

export enum TargetCurrency {
  /**
   * GBP
   */
  GBP = 'GBP',
}

export type ChangeDataResponseOfExchangeRateChangeDataRow = {
  actionId: string;
  rows: Array<ExchangeRateChangeDataRow>;
  originalRows: Array<ExchangeRateChangeDataRow>;
  reviewInfo: ReviewInfo;
  pageOptions: PageResponse;
  validationFeedback: {
    [key: string]: ChangeRequestRowFeedback;
  };
  isValid: boolean | null;
};

export type ExchangeRateChangeDataRow = ExchangeRateRequest & {
  rowNumber?: number;
  originalCode?: string | null;
  isUsed?: boolean;
};

export type ExchangeRateRequest = ILockable & {
  sourceCurrency?: SupportedCurrency | null;
  targetCurrency?: TargetCurrency | null;
  rate?: number | null;
  startDate?: string | null;
};

export type AddRowsRequestOfExchangeRateChangeDataRow = {
  data: Array<ExchangeRateChangeDataRow>;
};

export type ExportTemplateResponse = {
  id: string;
  name: string;
  description: string;
  columnOrder: Array<string>;
  columnMapping: {
    [key: string]: string;
  };
  columnVisibility: {
    [key: string]: boolean;
  };
  versionNumber: number;
  isDefaultTemplate: boolean;
  entityType: ActionEntityTypeKeyValuePair;
};

export type ActionEntityTypeKeyValuePair = {
  key: ActionEntityType;
  value: string;
};

export type CreateExportTemplateRequest = {
  name: string;
  description: string;
  columnOrder: Array<string>;
  columnMapping: {
    [key: string]: string;
  };
  columnVisibility: {
    [key: string]: boolean;
  };
  entityType: ActionEntityType;
};

export type FeeDefinition = {
  feeId: string;
  calculationType?: StringPair | null;
  feeType?: StringPair | null;
  feeName: string;
  amount?: number | null;
  percentage?: number | null;
  basedOn?: StringPair | null;
  bandParameter?: StringPair | null;
  bands?: Array<FeeBand> | null;
  description?: string | null;
  paymentStages?: Array<StringPair> | null;
  paymentMethods?: Array<StringPair> | null;
  accountCode?: string | null;
  costCentre?: string | null;
  refundable?: boolean | null;
  waivable?: boolean | null;
  estimated?: boolean | null;
  lockedByActionId?: string | null;
  feeProfiles?: Array<StringPair> | null;
  linkedToActiveToday?: boolean | null;
};

export type FeeBand = {
  index?: number;
  baseTopAmount?: number | null;
  baseBottomAmount?: number | null;
  amount?: number | null;
};

export type FeeDefinitionCrudChangeResponse = {
  isValid?: boolean;
  errors?: FeeValidationErrors;
  actionId?: string | null;
};

export type FeeValidationErrors = {
  feeId?: Array<string>;
  feeName?: Array<string>;
  feeType?: Array<string>;
  calculationType?: Array<string>;
  amount?: Array<string>;
  percentage?: Array<string>;
  basedOn?: Array<string>;
  bands?: {
    [key: string]: FeeBandValidationErrors;
  };
  description?: Array<string>;
  paymentStages?: Array<string>;
  paymentMethods?: Array<string>;
  accountCode?: Array<string>;
  costCentre?: Array<string>;
  refundable?: Array<string>;
  waivable?: Array<string>;
  estimated?: Array<string>;
  generalErrors?: Array<string>;
};

export type FeeBandValidationErrors = {
  baseBottomAmount?: Array<string>;
  baseTopAmount?: Array<string>;
  amount?: Array<string>;
};

export type ChangeRequestOfFeeDefinitionCrudRequest = {
  data: FeeDefinitionCrudRequest;
  actionType: ActionType;
};

export type FeeDefinitionCrudRequest = ILockable & {
  feeId?: string;
  feeName?: string;
  feeType?: FeeType | null;
  calculationType?: FeeCalculationType | null;
  amount?: number | null;
  percentage?: number | null;
  basedOn?: FeeBasedOn | null;
  bands?: Array<FeeBandRequest> | null;
  description?: string | null;
  paymentStages?: Array<PaymentStage> | null;
  paymentMethods?: Array<PaymentMethod> | null;
  accountCode?: string | null;
  costCentre?: string | null;
  refundable?: boolean | null;
  waivable?: boolean | null;
  estimated?: boolean | null;
};

export enum FeeType {
  /**
   * APPLICATIONFEE
   */
  APPLICATIONFEE = 'APPLICATIONFEE',
  /**
   * PRODUCTFEE
   */
  PRODUCTFEE = 'PRODUCTFEE',
  /**
   * VALUATIONFEE
   */
  VALUATIONFEE = 'VALUATIONFEE',
  /**
   * TRANSFERFEE
   */
  TRANSFERFEE = 'TRANSFERFEE',
  /**
   * DISCHARGEFEE
   */
  DISCHARGEFEE = 'DISCHARGEFEE',
  /**
   * HOMEBUYERSFEE
   */
  HOMEBUYERSFEE = 'HOMEBUYERSFEE',
  /**
   * TRANSCRIPTIONFEE
   */
  TRANSCRIPTIONFEE = 'TRANSCRIPTIONFEE',
  /**
   * UPGRADETOHOMEBUYERSFEE
   */
  UPGRADETOHOMEBUYERSFEE = 'UPGRADETOHOMEBUYERSFEE',
  /**
   * BUILDINGSURVEYFEE
   */
  BUILDINGSURVEYFEE = 'BUILDINGSURVEYFEE',
}

export enum FeeCalculationType {
  /**
   * FIXEDAMOUNT
   */
  FIXEDAMOUNT = 'FIXEDAMOUNT',
  /**
   * PERCENTAGE
   */
  PERCENTAGE = 'PERCENTAGE',
  /**
   * BANDEDFIXEDAMOUNT
   */
  BANDEDFIXEDAMOUNT = 'BANDEDFIXEDAMOUNT',
  /**
   * BANDEDPERCENTAGE
   */
  BANDEDPERCENTAGE = 'BANDEDPERCENTAGE',
}

export enum FeeBasedOn {
  /**
   * LOANAMOUNT
   */
  LOANAMOUNT = 'LOANAMOUNT',
  /**
   * PROPERTYVALUE
   */
  PROPERTYVALUE = 'PROPERTYVALUE',
}

export type FeeBandRequest = {
  baseTopAmount?: number | null;
  baseBottomAmount?: number | null;
  amount?: number | null;
};

export enum PaymentStage {
  /**
   * SUBMISSION
   */
  SUBMISSION = 'SUBMISSION',
  /**
   * OFFER
   */
  OFFER = 'OFFER',
  /**
   * COMPLETION
   */
  COMPLETION = 'COMPLETION',
  /**
   * REDEMPTION
   */
  REDEMPTION = 'REDEMPTION',
}

export enum PaymentMethod {
  /**
   * CREDIT_OR_DEBIT_CARD
   */
  CREDIT_OR_DEBIT_CARD = 'CREDIT_OR_DEBIT_CARD',
  /**
   * ADD_TO_LOAN
   */
  ADD_TO_LOAN = 'ADD_TO_LOAN',
  /**
   * DEDUCT_FROM_ADVANCE
   */
  DEDUCT_FROM_ADVANCE = 'DEDUCT_FROM_ADVANCE',
}

export type ChangeDataResponseOfFeeDefinitionChangeDataRow = {
  actionId: string;
  rows: Array<FeeDefinitionChangeDataRow>;
  originalRows: Array<FeeDefinitionChangeDataRow>;
  reviewInfo: ReviewInfo;
  pageOptions: PageResponse;
  validationFeedback: {
    [key: string]: ChangeRequestRowFeedback;
  };
  isValid: boolean | null;
};

export type FeeDefinitionChangeDataRow = FeeRequest & {
  rowNumber?: number;
  originalCode?: string | null;
  isUsed?: boolean;
};

export type FeeRequest = ILockable & {
  feeId?: string | null;
  feeName?: string | null;
  feeType?: FeeType | null;
  calculationType?: FeeCalculationType | null;
  amount?: number | null;
  percentage?: number | null;
  basedOn?: FeeBasedOn | null;
  baseBottomAmount?: number | null;
  baseTopAmount?: number | null;
  description?: string | null;
  paymentStages?: Array<PaymentStage> | null;
  paymentMethods?: Array<PaymentMethod> | null;
  accountCode?: string | null;
  costCentre?: string | null;
  refundable?: boolean | null;
  waivable?: boolean | null;
  estimated?: boolean | null;
  feeBands?: Array<FeeBand2> | null;
  lockedByActionId?: string | null;
};

export type FeeBand2 = {
  baseTopAmount: number;
  baseBottomAmount: number;
  amount: number;
};

export type AddRowsRequestOfFeeDefinitionChangeDataRow = {
  data: Array<FeeDefinitionChangeDataRow>;
};

export type FeeProfile = {
  feeProfileId: string;
  feeProfileName: string;
  feeIds: Array<string>;
  lockedByActionId?: string | null;
  linkedToActiveToday?: boolean | null;
};

export type FeeProfileCrudChangeResponse = {
  isValid?: boolean;
  errors?: FeeProfileValidationErrors;
  actionId?: string | null;
};

export type FeeProfileValidationErrors = {
  feeProfileId?: Array<string>;
  feeProfileName?: Array<string>;
  feeIds?: Array<string>;
};

export type ChangeRequestOfFeeProfileCrudRequest = {
  data: FeeProfileCrudRequest;
  actionType: ActionType;
};

export type FeeProfileCrudRequest = {
  feeProfileId?: string;
  feeProfileName?: string;
  feeIds?: Array<string>;
};

export type ChangeDataResponseOfFeeProfileChangeDataRow = {
  actionId: string;
  rows: Array<FeeProfileChangeDataRow>;
  originalRows: Array<FeeProfileChangeDataRow>;
  reviewInfo: ReviewInfo;
  pageOptions: PageResponse;
  validationFeedback: {
    [key: string]: ChangeRequestRowFeedback;
  };
  isValid: boolean | null;
};

export type FeeProfileChangeDataRow = FeeProfileRequest & {
  rowNumber?: number;
  originalCode?: string | null;
  isUsed?: boolean;
};

export type FeeProfileRequest = ILockable & {
  feeProfileId?: string | null;
  feeProfileName?: string | null;
  feeIds?: Array<string>;
};

export type AddRowsRequestOfFeeProfileChangeDataRow = {
  data: Array<FeeProfileChangeDataRow>;
};

export type FirmIntermediaryByRole = {
  id?: string | null;
  email?: string | null;
  displayName?: string | null;
  roles?: Array<KeyValue> | null;
};

export type KeyValue = {
  key?: string | null;
  value?: string | null;
};

export type FirmProcFeeAssignmentItemsResponse = {
  id?: string | null;
  order: number;
  procurationFeeRule: KeyValue;
  operationType?: OperationType | null;
  applicationType?: ApplicationType | null;
  propertyPurpose?: PropertyPurpose | null;
  procurationFee: KeyValue;
  lockedByActionId?: string | null;
  feeItems: Array<ProcurationFeeItem>;
};

export enum OperationType {
  /**
   * NETWORK
   */
  NETWORK = 'NETWORK',
  /**
   * ADVICE
   */
  ADVICE = 'ADVICE',
  /**
   * PACKAGE
   */
  PACKAGE = 'PACKAGE',
  /**
   * MORTGAGE_CLUB
   */
  MORTGAGE_CLUB = 'MORTGAGE_CLUB',
}

export enum ApplicationType {
  /**
   * NEW_LENDING
   */
  NEW_LENDING = 'NEW_LENDING',
  /**
   * REMORTGAGE
   */
  REMORTGAGE = 'REMORTGAGE',
}

export enum PropertyPurpose {
  /**
   * OWNER_OCCUPATION
   */
  OWNER_OCCUPATION = 'OWNER_OCCUPATION',
  /**
   * BUY_TO_LET
   */
  BUY_TO_LET = 'BUY_TO_LET',
  /**
   * PORTFOLIO_BUY_TO_LET
   */
  PORTFOLIO_BUY_TO_LET = 'PORTFOLIO_BUY_TO_LET',
  /**
   * SECOND_HOME
   */
  SECOND_HOME = 'SECOND_HOME',
  /**
   * COMPANY_BUY_TO_LET
   */
  COMPANY_BUY_TO_LET = 'COMPANY_BUY_TO_LET',
}

export type ProcurationFeeItem = {
  index?: number;
  value: number;
  unit: FeeUnit;
  basis?: FeeBasis | null;
  procurationFeeItemType: ProcurationFeeItemType;
  startingMonth?: number | null;
  intervalInMonths?: number | null;
  endingType?: EndingType | null;
};

export enum FeeUnit {
  /**
   * FLAT
   */
  FLAT = 'FLAT',
  /**
   * PERCENTAGE
   */
  PERCENTAGE = 'PERCENTAGE',
}

export enum FeeBasis {
  /**
   * LOAN_AMOUNT
   */
  LOAN_AMOUNT = 'LOAN_AMOUNT',
  /**
   * OUTSTANDING_BALANCE
   */
  OUTSTANDING_BALANCE = 'OUTSTANDING_BALANCE',
}

export enum ProcurationFeeItemType {
  /**
   * COMPLETION
   */
  COMPLETION = 'COMPLETION',
  /**
   * TRAIL
   */
  TRAIL = 'TRAIL',
}

export enum EndingType {
  /**
   * REDEMPTION
   */
  REDEMPTION = 'REDEMPTION',
  /**
   * INITIAL_TERM
   */
  INITIAL_TERM = 'INITIAL_TERM',
  /**
   * INITIAL_TERM_UNLESS_REDEEMED
   */
  INITIAL_TERM_UNLESS_REDEEMED = 'INITIAL_TERM_UNLESS_REDEEMED',
}

export type FirmProcFeeAssignmentsCrudChangeResponse = {
  isValid?: boolean;
  errors?: FirmProcFeeAssignmentValidationErrors;
  actionId?: string | null;
};

export type FirmProcFeeAssignmentValidationErrors = {
  id?: Array<string>;
  firmId?: Array<string>;
  index?: Array<string>;
  procurationFeeRuleId?: Array<string>;
  procurationFeeId?: Array<string>;
};

export type ChangeRequestOfDraftFirmProcFeeAssignment = {
  data: DraftFirmProcFeeAssignment;
  actionType: ActionType;
};

export type DraftFirmProcFeeAssignment = ILockable & {
  id?: string | null;
  pendingId?: string | null;
  firmId?: string | null;
  index?: number | null;
  procurationFeeRuleId?: string | null;
  procurationFeeId?: string | null;
};

export type DeleteGuidPrecheckResult = {
  canDelete?: Array<string>;
  notFound?: Array<string>;
  blocked?: Array<DeleteGuidPrecheckItem> | null;
};

export type DeleteGuidPrecheckItem = {
  id: string;
  errors: Array<string>;
};

export type DeleteGuidRequest = {
  ids?: Array<string>;
};

export type ChangeRequestOfListOfDraftFirmProcFeeAssignment = {
  data: Array<DraftFirmProcFeeAssignment>;
  actionType: ActionType;
};

export type ChangeDataResponseOfFirmProcFeeAssignmentDataRow = {
  actionId: string;
  rows: Array<FirmProcFeeAssignmentDataRow>;
  originalRows: Array<FirmProcFeeAssignmentDataRow>;
  reviewInfo: ReviewInfo;
  pageOptions: PageResponse;
  validationFeedback: {
    [key: string]: ChangeRequestRowFeedback;
  };
  isValid: boolean | null;
};

export type FirmProcFeeAssignmentDataRow = DraftFirmProcFeeAssignment & {
  rowNumber?: number;
};

export type AddRowsRequestOfFirmProcFeeAssignmentDataRow = {
  data: Array<FirmProcFeeAssignmentDataRow>;
};

export type FirmGetAllResponse = {
  ohpenId: string;
  id: string;
  isAuthorised: boolean;
  reference?: string | null;
  frn?: number | null;
  name: string;
  type: FirmType;
  nacfbNumber?: string | null;
  fcaStatus?: string | null;
  principalFirm: Array<FirmReference>;
  defaultPaymentRouteFirm?: StringPair | null;
  operationsWhitelist: Array<KeyValue>;
  btl: CasePermission;
  rbtl: CasePermission;
  rmc: CasePermission;
  procFeeBoost?: ProcFeeBoost | null;
  firmCompliance: KeyValue;
  isActive: boolean;
  activationDate?: string | null;
  deactivationDate?: string | null;
  lockedByActionId?: string | null;
};

export enum FirmType {
  /**
   * APPOINTED_REPRESENTATIVE
   */
  APPOINTED_REPRESENTATIVE = 'APPOINTED_REPRESENTATIVE',
  /**
   * DIRECTLY_AUTHORISED
   */
  DIRECTLY_AUTHORISED = 'DIRECTLY_AUTHORISED',
  /**
   * NOT_FCA_REGISTERED
   */
  NOT_FCA_REGISTERED = 'NOT_FCA_REGISTERED',
}

export type FirmReference = {
  id: string;
  name?: string | null;
  frn?: number | null;
};

export enum CasePermission {
  /**
   * MANAGE
   */
  MANAGE = 'MANAGE',
  /**
   * CREATE_AND_MANAGE
   */
  CREATE_AND_MANAGE = 'CREATE_AND_MANAGE',
}

export type ProcFeeBoost = {
  value?: number;
  unit: FeeUnit;
};

export type SqePageOfFirmGetAllResponse = {
  items: Array<FirmGetAllResponse>;
  page: number;
  pageSize: number;
  total: number;
  query: SqeRequest;
};

/**
 * The body of an SQE: a filter tree, an ordering and a page. Echoed as the page's query, as applied.
 */
export type SqeRequest = {
  filter?: FilterNode;
  /**
   * At most 3 terms, applied in order. The server appends its own tiebreak.
   */
  sort?: Array<SortTerm>;
  /**
   * The 1-based page number.
   */
  page?: number;
  /**
   * The number of rows on a page.
   */
  pageSize?: number;
};

/**
 * One node of a filter tree, told apart by its type.
 */
export type FilterNode =
  | ({
      type: 'group';
    } & GroupNode)
  | ({
      type: 'predicate';
    } & PredicateNode)
  | ({
      type: 'collection';
    } & CollectionNode);

/**
 * One term of the ordering, over a declared sortable field. NULLs sort last in both directions.
 */
export type SortTerm = {
  field: string;
  dir: SortDirection;
};

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}

export type ValidationErrorProblemDetails = ProblemDetails & {
  code?: ValidationErrorCode;
  errors?: Array<ValidationError>;
  [key: string]: unknown;
};

export enum ValidationErrorCode {
  /**
   * VALIDATION_FAILED
   */
  VALIDATION_FAILED = 'VALIDATION_FAILED',
  /**
   * REQUIRED_MEMBER_MISSING
   */
  REQUIRED_MEMBER_MISSING = 'REQUIRED_MEMBER_MISSING',
  /**
   * INVALID_FORMAT
   */
  INVALID_FORMAT = 'INVALID_FORMAT',
  /**
   * INVALID_VALUE
   */
  INVALID_VALUE = 'INVALID_VALUE',
  /**
   * MEMBER_NOT_WRITABLE
   */
  MEMBER_NOT_WRITABLE = 'MEMBER_NOT_WRITABLE',
  /**
   * UNRESOLVED_REFERENCE
   */
  UNRESOLVED_REFERENCE = 'UNRESOLVED_REFERENCE',
  /**
   * LIMIT_EXCEEDED
   */
  LIMIT_EXCEEDED = 'LIMIT_EXCEEDED',
}

export type ValidationError = {
  member?: string;
  code?: ValidationErrorCode;
  reason?: string;
};

export type FirmGetById = {
  firmId: string;
  oldBrsFirmId?: string | null;
  registrationDetails?: FirmRegistrationDetails | null;
  procFeeBoost?: ProcFeeBoost | null;
  contactDetails: PmpFirmContactDetails;
  status: FirmStatus;
  payments: FirmPayments;
  packaging: FirmPackaging;
  exclusives: Array<string>;
  tradingNames: Array<TradingAddress>;
  notes: Array<unknown>;
  lockedByActionId?: string | null;
};

export type FirmRegistrationDetails = {
  ohpenId?: string | null;
  isActive?: boolean | null;
  frn?: number | null;
  name: string;
  reference?: string | null;
  type: FirmType;
  fcaStatus?: string | null;
  nacfbNumber?: string | null;
  companiesHouseNumber?: string | null;
  principalIds: Array<string>;
  btl: CasePermission;
  rbtl: CasePermission;
  rmc: CasePermission;
  operations: Array<OperationType>;
};

export type PmpFirmContactDetails = {
  email?: string | null;
  mobilePhone?: string | null;
  workPhone?: string | null;
  website?: string | null;
  complaintsWebsite?: string | null;
  qualifiedDomains?: Array<string> | null;
  firmAddress?: Address | null;
};

export type Address = {
  name?: string | null;
  numberOrBuilding?: string | null;
  postCode?: string | null;
  city?: string | null;
  country?: string | null;
  lineItems?: Array<string> | null;
};

export type FirmStatus = {
  complianceStatus?: ComplianceStatus | null;
  onTheWatchlist?: boolean | null;
  activationDate?: string | null;
  deactivationDate?: string | null;
  addedToPanel?: string | null;
  addedBy?: string | null;
  lastUpdate?: string | null;
  updatedBy?: string | null;
};

export enum ComplianceStatus {
  /**
   * PENDING
   */
  PENDING = 'PENDING',
  /**
   * FAILED
   */
  FAILED = 'FAILED',
  /**
   * PASSED
   */
  PASSED = 'PASSED',
  /**
   * RE_REVIEW_REQUIRED
   */
  RE_REVIEW_REQUIRED = 'RE_REVIEW_REQUIRED',
}

export type FirmPayments = {
  defaultPaymentRouteFirmId?: string | null;
  paymentRouteFirmIds?: Array<string> | null;
  operations: {
    [key: string]: BankAccountResponse;
  };
};

export type BankAccountResponse = {
  accountName: string;
  accountNumber: string;
  sortCode: string;
  bankName?: string | null;
};

export type FirmPackaging = {
  packagerFirmIds?: Array<string> | null;
  packagerForFirmIds?: Array<string> | null;
};

export type TradingAddress = {
  id?: string | null;
  name?: string | null;
  numberOrBuilding?: string | null;
  postCode?: string | null;
  city?: string | null;
  country?: string | null;
  lineItems?: Array<string> | null;
  regionId?: string | null;
  region?: string | null;
  bdmId?: string | null;
  businessDevelopmentManager?: string | null;
  isActive?: boolean | null;
  isUsed?: boolean | null;
};

export type FirmFcaData = {
  result?: FcaResponseResult | null;
  registrationDetails?: FirmFcaRegistrationDetails | null;
  contactDetails?: FirmFcaContactDetails | null;
  tradingNames?: Array<TradingAddress> | null;
};

export enum FcaResponseResult {
  /**
   * OK
   */
  OK = 'OK',
  /**
   * REFERENCE_NOT_FOUND
   */
  REFERENCE_NOT_FOUND = 'REFERENCE_NOT_FOUND',
  /**
   * FCA_ERROR
   */
  FCA_ERROR = 'FCA_ERROR',
  /**
   * PARTIAL_DATA
   */
  PARTIAL_DATA = 'PARTIAL_DATA',
}

export type FirmFcaRegistrationDetails = {
  frn?: number;
  name?: string | null;
  type?: FirmType | null;
  fcaStatus?: string | null;
  companiesHouseNumber?: string | null;
  disabledOperations: Array<OperationType>;
};

export type FirmFcaContactDetails = {
  mobilePhone?: string | null;
  website?: string | null;
  firmAddress?: Address | null;
};

export type TradingAddressResponse = {
  id?: string | null;
  name?: string | null;
  numberOrBuilding?: string | null;
  postCode: string;
  city?: string | null;
  country?: string | null;
  lineItems?: Array<string> | null;
  regionId?: string | null;
  region?: string | null;
  bdmId?: string | null;
  businessDevelopmentManager?: string | null;
  lastUpdated?: string | null;
  deleted?: boolean | null;
  isActive?: boolean | null;
  isUsed?: boolean | null;
};

export type FirmCrudChangeResponse = {
  isValid?: boolean;
  errors?: FirmValidationErrors;
  actionId?: string | null;
};

export type FirmValidationErrors = {
  firmId?: Array<string>;
  tradingAddresses?: Array<string>;
  tradingAddressesByIndex?: {
    [key: string]: TradingAddressValidationErrors;
  };
  exclusives?: Array<string>;
  registrationDetails?: FirmRegistrationValidationErrors;
  procFeeBoost?: FirmProcFeeBoostValidationErrors;
  contactDetails?: FirmContactValidationErrors;
  payments?: FirmPaymentsValidationErrors;
  packaging?: FirmPackagingValidationErrors;
};

export type TradingAddressValidationErrors = {
  name?: Array<string>;
  postCode?: Array<string>;
  city?: Array<string>;
  numberOrBuilding?: Array<string>;
  country?: Array<string>;
  regionId?: Array<string>;
  bdmId?: Array<string>;
  isActive?: Array<string>;
  lineItems?: {
    [key: string]: Array<string>;
  };
};

export type FirmRegistrationValidationErrors = {
  name?: Array<string>;
  type?: Array<string>;
  frn?: Array<string>;
  ohpenId?: Array<string>;
  principalIds?: Array<string>;
  isActive?: Array<string>;
  nacfbNumber?: Array<string>;
  companiesHouseNumber?: Array<string>;
  reference?: Array<string>;
  operations?: Array<string>;
};

export type FirmProcFeeBoostValidationErrors = {
  value?: Array<string>;
  unit?: Array<string>;
};

export type FirmContactValidationErrors = {
  email?: Array<string>;
  mobilePhone?: Array<string>;
  workPhone?: Array<string>;
  website?: Array<string>;
  complaintsWebsite?: Array<string>;
  qualifiedDomains?: Array<string>;
  firmAddressPostCode?: Array<string>;
};

export type FirmPaymentsValidationErrors = {
  defaultPaymentRouteFirmId?: Array<string>;
  paymentRouteFirmIds?: Array<string>;
  bankAccountsByOperation?: {
    [key: string]: Array<string>;
  };
};

export type FirmPackagingValidationErrors = {
  packagerFirmIds?: Array<string>;
  packagerForFirmIds?: Array<string>;
};

export type ChangeRequestOfFirmDraftDto = {
  data: FirmDraftDto;
  actionType: ActionType;
};

export type FirmDraftDto = ILockable & {
  id?: string | null;
  ohpenId?: string | null;
  name?: string | null;
  type?: FirmType | null;
  frn?: number | null;
  principalFirmIds?: Array<string> | null;
  packagerFirmIds?: Array<string> | null;
  packagerForFirmIds?: Array<string> | null;
  defaultPaymentRouteFirmId?: string | null;
  paymentRouteFirmIds?: Array<string> | null;
  operationsWhitelist?: Array<DraftFirmOperation> | null;
  btl?: CasePermission;
  rbtl?: CasePermission;
  rmc?: CasePermission;
  procFeeBoost?: DraftProcFeeBoost | null;
  idsOfExclusivitySets?: Array<string> | null;
  isActive?: boolean | null;
  nacfbNumber?: string | null;
  companiesHouseNumber?: string | null;
  reference?: string | null;
  qualifiedDomains?: Array<string> | null;
  email?: string | null;
  mobilePhone?: string | null;
  workPhone?: string | null;
  website?: string | null;
  complaintsWebsite?: string | null;
  complianceStatus?: ComplianceStatus | null;
  onTheWatchlist?: boolean | null;
  firmAddress?: DraftAddress | null;
  tradingAddresses?: Array<DraftTradingAddress> | null;
};

export type DraftFirmOperation = {
  type?: OperationType | null;
  bankAccountDetails?: DraftBankAccountDetails | null;
};

export type DraftBankAccountDetails = {
  accountName?: string | null;
  accountNumber?: string | null;
  sortCode?: string | null;
  bankName?: string | null;
};

export type DraftProcFeeBoost = {
  value?: number | null;
  unit?: FeeUnit | null;
};

export type DraftAddress = {
  name?: string | null;
  numberOrBuilding?: string | null;
  postCode?: string | null;
  city?: string | null;
  country?: string | null;
  lineItems?: Array<string | null> | null;
};

export type DraftTradingAddress = {
  id?: string | null;
  name?: string | null;
  numberOrBuilding?: string | null;
  postCode?: string | null;
  city?: string | null;
  country?: string | null;
  lineItems?: Array<string | null> | null;
  regionId?: string | null;
  region?: string | null;
  bdmId?: string | null;
  businessDevelopmentManager?: string | null;
  isActive?: boolean | null;
};

export type ChangeDataResponseOfFirmDraftDataRow = {
  actionId: string;
  rows: Array<FirmDraftDataRow>;
  originalRows: Array<FirmDraftDataRow>;
  reviewInfo: ReviewInfo;
  pageOptions: PageResponse;
  validationFeedback: {
    [key: string]: ChangeRequestRowFeedback;
  };
  isValid: boolean | null;
};

export type FirmDraftDataRow = FirmDraftDto & {
  rowNumber?: number;
};

export type AddRowsRequestOfFirmDraftDataRow = {
  data: Array<FirmDraftDataRow>;
};

export type ImportMatchResponse = {
  key: string;
  defaultKey: string;
  customKeys: Array<CustomKey>;
};

export type CustomKey = {
  customKey?: string;
};

export type ImportMatchingRequest = {
  customKeysToKeyMappings: Array<CustomKeysToKeyMapping>;
  type?: ActionEntityType;
};

export type CustomKeysToKeyMapping = {
  key: string;
  customKeys: Array<CustomKey>;
};

export type ImportSchemaResponse = {
  entity: ActionEntityType;
  columns: Array<ImportSchemaColumn>;
  additionalFields?: {
    [key: string]: string;
  } | null;
};

export type ImportSchemaColumn = {
  /**
   * Name of the field in PMP model
   */
  key: string;
  /**
   * Default name of the field
   */
  defaultClientKey: string;
  /**
   * Names of the field in user/client file
   */
  customClientKeys?: Array<string>;
  /**
   * Display Name of the field
   */
  label: string;
  type: ImportColumnType;
  required: boolean;
  order: number;
  listName?: string | null;
};

export enum ImportColumnType {
  /**
   * STRING
   */
  STRING = 'string',
  /**
   * NUMBER
   */
  NUMBER = 'number',
  /**
   * DATE
   */
  DATE = 'date',
  /**
   * BOOLEAN
   */
  BOOLEAN = 'boolean',
  /**
   * ENUMERATION
   */
  ENUMERATION = 'enumeration',
  /**
   * MULTI_VALUE_ENUMERATION
   */
  MULTI_VALUE_ENUMERATION = 'multiValueEnumeration',
  /**
   * MULTI_VALUE_STRING
   */
  MULTI_VALUE_STRING = 'multiValueString',
}

export type ImportResult = {
  importId: string;
  status: StringPair;
  importEntityType: StringPair;
  createdBy: string;
  creationTime: string;
  columns: Array<ImportColumnMapping>;
};

export type ImportColumnMapping = {
  /**
   * Name of the field in PMP model
   */
  key: string;
  /**
   * Name of the field in user/client file
   */
  clientKey: string;
};

export type ImportCreateRequest = {
  type: ActionEntityType;
  columns: Array<ImportColumnMapping>;
};

export type ImportDataResponse = {
  importId: string;
  rows: Array<ImportDataRowResponse>;
  pageOptions: PageResponse;
};

export type ImportDataRowResponse = {
  rowNumber: number;
  fields: unknown;
};

export type ImportAddRowsRequest = {
  data: Array<ImportDataRowRequest>;
};

export type ImportDataRowRequest = {
  rowNumber: number;
  fields: unknown;
};

export type ImportUpdateCellRequest = {
  rowNumbers: Array<number>;
  columnKey: string;
  value?: unknown;
};

export type InterestRateCrudChangeResponse = {
  isValid?: boolean;
  actionId?: string | null;
  errors?: InterestRateValidationErrors | null;
};

export type InterestRateValidationErrors = {
  baseRateCode?: Array<string> | null;
  amount?: Array<string> | null;
  startDate?: Array<string> | null;
  lockedByActionId?: Array<string> | null;
};

export type ChangeRequestOfInterestRateRequest = {
  data: InterestRateRequest;
  actionType: ActionType;
};

export type InterestRateRequest = ILockable & {
  baseRateCode?: string;
  amount?: number | null;
  startDate?: string | null;
  index?: number | null;
  lockedByActionId?: string | null;
};

export type ChangeDataResponseOfInterestRateChangeDataRow = {
  actionId: string;
  rows: Array<InterestRateChangeDataRow>;
  originalRows: Array<InterestRateChangeDataRow>;
  reviewInfo: ReviewInfo;
  pageOptions: PageResponse;
  validationFeedback: {
    [key: string]: ChangeRequestRowFeedback;
  };
  isValid: boolean | null;
};

export type InterestRateChangeDataRow = InterestRateRequest & {
  rowNumber?: number;
  isUsed?: boolean;
};

export type AddRowsRequestOfInterestRateChangeDataRow = {
  data: Array<InterestRateChangeDataRow>;
};

export type IntermediaryGetAllResponse = {
  id?: string;
  ohpenId?: string | null;
  firmName?: string | null;
  firmOhpenId?: string | null;
  tradingAddress?: string | null;
  roles?: Array<KeyValue>;
  userStatus?: string | null;
  compliance?: KeyValue | null;
  firmFRN?: number | null;
  irn?: string | null;
  email?: string | null;
  displayName?: string | null;
  activationDate?: string | null;
  deactivationDate?: string | null;
  lockedByActionId?: string | null;
};

export type SqePageOfIntermediaryGetAllResponse = {
  items: Array<IntermediaryGetAllResponse>;
  page: number;
  pageSize: number;
  total: number;
  query: SqeRequest;
};

export type PmpIntermediaryResponse = {
  id: string;
  managerId?: string | null;
  subordinateIds?: Array<string> | null;
  assistants?: Array<AssistantCollaboration> | null;
  advisers?: Array<AdviserCollaboration> | null;
  firmId: string;
  oldFirmId?: string | null;
  tradingAddressId?: string | null;
  tradingAddress?: TradingAddress | null;
  roles: Array<UserRoleType>;
  userStatus: UserStatus;
  cognitoUserStatus: CognitoUserStatus;
  notes: Array<string>;
  compliance: Compliance;
  firmFRN?: number | null;
  firmName?: string | null;
  irn?: string | null;
  fcaStatus?: string | null;
  email: string;
  personalData?: PersonalData | null;
  receiveMarketingMaterials?: boolean;
  agreedToTermsAndConditions?: boolean;
  isAuthorised?: boolean;
  ohpenId?: string | null;
  lockedByActionId?: string | null;
  activationDate?: string | null;
  deactivationDate?: string | null;
  addedToPanel?: string | null;
  addedBy?: string | null;
  lastUpdate?: string | null;
  updatedBy?: string | null;
};

export type AssistantCollaboration = {
  assistantId?: string | null;
  permissionType?: AssistantPermissionType | null;
  displayName?: string | null;
};

export enum AssistantPermissionType {
  /**
   * VIEW
   */
  VIEW = 'VIEW',
  /**
   * ILLUSTRATION
   */
  ILLUSTRATION = 'ILLUSTRATION',
  /**
   * DECISION_IN_PRINCIPLE
   */
  DECISION_IN_PRINCIPLE = 'DECISION_IN_PRINCIPLE',
  /**
   * FULL_MORTGAGE_APPLICATION
   */
  FULL_MORTGAGE_APPLICATION = 'FULL_MORTGAGE_APPLICATION',
}

export type AdviserCollaboration = {
  adviserId?: string | null;
  permissionType?: AssistantPermissionType | null;
  displayName?: string | null;
};

export enum UserRoleType {
  /**
   * VIEWER
   */
  VIEWER = 'VIEWER',
  /**
   * ADVISOR
   */
  ADVISOR = 'ADVISOR',
  /**
   * ASSISTANT
   */
  ASSISTANT = 'ASSISTANT',
  /**
   * SUPERVISOR
   */
  SUPERVISOR = 'SUPERVISOR',
  /**
   * ADMIN
   */
  ADMIN = 'ADMIN',
  /**
   * COMPLIANCE
   */
  COMPLIANCE = 'COMPLIANCE',
  /**
   * SUPPORT
   */
  SUPPORT = 'SUPPORT',
}

export enum UserStatus {
  /**
   * INACTIVE
   */
  INACTIVE = 'INACTIVE',
  /**
   * PENDING
   */
  PENDING = 'PENDING',
  /**
   * ACTIVE
   */
  ACTIVE = 'ACTIVE',
}

export enum CognitoUserStatus {
  /**
   * NOT_CREATED
   */
  NOT_CREATED = 'NOT_CREATED',
  /**
   * CONFIRMED
   */
  CONFIRMED = 'CONFIRMED',
  /**
   * RESET_REQUIRED
   */
  RESET_REQUIRED = 'RESET_REQUIRED',
  /**
   * FORCE_CHANGE_PASSWORD
   */
  FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD',
}

export type Compliance = {
  lastComplianceCheck?: string | null;
  whoDidLastComplianceCheckUserId?: string | null;
  complianceStatus?: ComplianceStatus | null;
  onTheWatchlist?: boolean | null;
};

export type PersonalData = {
  title?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  birthDate?: string | null;
  homeAddress?: Address | null;
  mobilePhoneNumber: string;
  workPhoneNumber?: string | null;
  previousName?: string | null;
  regionalOfficeAddress?: Address | null;
};

export type IntermediaryFcaData = {
  result?: FcaResponseResult | null;
  registrationDetails?: IntermediaryFcaRegistrationDetails | null;
  personalDetails?: IntermediaryFcaPersonalDetails | null;
};

export type IntermediaryFcaRegistrationDetails = {
  irn: string;
  fcaStatus?: string | null;
};

export type IntermediaryFcaPersonalDetails = {
  firstName?: string | null;
  lastName?: string | null;
  preferredName?: string | null;
};

export type IntermediaryCrudChangeResponse = {
  isValid?: boolean;
  errors?: IntermediaryValidationErrors;
  actionId?: string | null;
};

export type IntermediaryValidationErrors = {
  intermediaryId?: Array<string>;
  firmId?: Array<string>;
  email?: Array<string>;
  ohpenId?: Array<string>;
  irn?: Array<string>;
  userStatus?: Array<string>;
  tradingAddressId?: Array<string>;
  roles?: Array<string>;
  personalData?: IntermediaryPersonalDataValidationErrors;
  compliance?: IntermediaryComplianceValidationErrors;
};

export type IntermediaryPersonalDataValidationErrors = {
  mobilePhoneNumber?: Array<string>;
  workPhoneNumber?: Array<string>;
  birthDate?: Array<string>;
  firstName?: Array<string>;
  lastName?: Array<string>;
  middleName?: Array<string>;
  title?: Array<string>;
  preferredName?: Array<string>;
  previousName?: Array<string>;
};

export type IntermediaryComplianceValidationErrors = {
  complianceStatus?: Array<string>;
  onTheWatchlist?: Array<string>;
};

export type ChangeRequestOfIntermediaryDraftDto = {
  data: IntermediaryDraftDto;
  actionType: ActionType;
};

export type IntermediaryDraftDto = ILockable & {
  id?: string | null;
  firmId?: string | null;
  email?: string | null;
  title?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  birthDate?: string | null;
  mobilePhoneNumber?: string | null;
  workPhoneNumber?: string | null;
  previousName?: string | null;
  lastComplianceCheck?: string | null;
  whoDidLastComplianceCheckUserId?: string | null;
  complianceStatus?: ComplianceStatus | null;
  onTheWatchlist?: boolean | null;
  roles?: Array<UserRoleType> | null;
  managerId?: string | null;
  subordinateIds?: Array<string> | null;
  assistants?: Array<AssistantCollaboration> | null;
  advisers?: Array<AdviserCollaboration> | null;
  tradingAddressId?: string | null;
  irn?: string | null;
  fcaStatus?: string | null;
  receiveMarketingMaterials?: boolean | null;
  agreedToTermsAndConditions?: boolean | null;
  isAuthorised?: boolean | null;
  userStatus?: UserStatus | null;
};

export type ChangeDataResponseOfIntermediaryDraftDataRow = {
  actionId: string;
  rows: Array<IntermediaryDraftDataRow>;
  originalRows: Array<IntermediaryDraftDataRow>;
  reviewInfo: ReviewInfo;
  pageOptions: PageResponse;
  validationFeedback: {
    [key: string]: ChangeRequestRowFeedback;
  };
  isValid: boolean | null;
};

export type IntermediaryDraftDataRow = IntermediaryDraftDto & {
  rowNumber?: number;
};

export type AddRowsRequestOfIntermediaryDraftDataRow = {
  data: Array<IntermediaryDraftDataRow>;
};

export type LenderResponse = PmpLenderResponse & {
  complianceCheckConfiguration?: ComplianceSettings;
};

export type ComplianceSettings = {
  defaultFirmStatus?: ComplianceStatus | null;
  defaultIntermediaryStatus?: ComplianceStatus | null;
  firmToReviewPermissionLevel?: CompliancePermissionLevel | null;
  intermediaryToReviewPermissionLevel?: CompliancePermissionLevel | null;
  firmPermissionLevelPerStatus?: Array<ComplianceStatusPermissionLevel> | null;
  intermediaryPermissionLevelPerStatus?: Array<ComplianceStatusPermissionLevel> | null;
  resetReviewRequiredFlagAfterMonths?: number | null;
  reviewOnBmpChangesEnabled?: boolean;
  periodicCheckEnabled?: boolean;
};

export enum CompliancePermissionLevel {
  /**
   * BLOCK
   */
  BLOCK = 'BLOCK',
  /**
   * VIEW
   */
  VIEW = 'VIEW',
  /**
   * ILLUSTRATION
   */
  ILLUSTRATION = 'ILLUSTRATION',
  /**
   * DIP
   */
  DIP = 'DIP',
  /**
   * FMA
   */
  FMA = 'FMA',
  /**
   * FULL_ACCESS
   */
  FULL_ACCESS = 'FULL_ACCESS',
}

export type ComplianceStatusPermissionLevel = {
  permissionLevel?: CompliancePermissionLevel;
  complianceStatus?: string;
};

export type PmpLenderResponse = {
  id: string;
  name: string;
  acronym: string;
  reference: string;
  lockedByActionId?: string | null;
  complianceCheckConfiguration: ComplianceCheckConfiguration;
};

export type ComplianceCheckConfiguration = {
  defaultFirmStatus?: ComplianceStatus | null;
  defaultIntermediaryStatus?: ComplianceStatus | null;
  firmToReviewPermissionLevel?: CompliancePermissionLevel | null;
  intermediaryToReviewPermissionLevel?: CompliancePermissionLevel | null;
  firmPermissionLevelPerStatus?: Array<CompliancePermissionLevelPerStatus> | null;
  intermediaryPermissionLevelPerStatus?: Array<CompliancePermissionLevelPerStatus> | null;
  resetReviewRequiredFlagAfterMonths?: number | null;
  reviewOnBmpChangesEnabled?: boolean | null;
  periodicCheckEnabled?: boolean | null;
};

export type CompliancePermissionLevelPerStatus = {
  complianceStatus?: ComplianceStatus | null;
  permissionLevel?: CompliancePermissionLevel | null;
};

export type LenderCrudChangeResponse = {
  isValid?: boolean;
  errors?: LenderValidationErrors;
  actionId?: string | null;
};

export type LenderValidationErrors = {
  id?: Array<string>;
  defaultFirmStatus?: Array<string>;
  defaultIntermediaryStatus?: Array<string>;
  firmToReviewPermissionLevel?: Array<string>;
  intermediaryToReviewPermissionLevel?: Array<string>;
  firmPermissionLevelPerStatus?: Array<string>;
  intermediaryPermissionLevelPerStatus?: Array<string>;
  resetReviewRequiredFlagAfterMonths?: Array<string>;
  reviewOnBmpChangesEnabled?: Array<string>;
  periodicCheckEnabled?: Array<string>;
  complianceCheckConfiguration?: Array<string>;
};

export type ChangeRequestOfLenderDraftDto = {
  data: LenderDraftDto;
  actionType: ActionType;
};

export type LenderDraftDto = ILockable & {
  id?: string | null;
  defaultFirmStatus?: ComplianceStatus | null;
  defaultIntermediaryStatus?: ComplianceStatus | null;
  firmToReviewPermissionLevel?: CompliancePermissionLevel | null;
  intermediaryToReviewPermissionLevel?: CompliancePermissionLevel | null;
  firmPermissionLevelPerStatus?: Array<CompliancePermissionLevelPerStatus> | null;
  intermediaryPermissionLevelPerStatus?: Array<CompliancePermissionLevelPerStatus> | null;
  resetReviewRequiredFlagAfterMonths?: number | null;
  reviewOnBmpChangesEnabled?: boolean | null;
  periodicCheckEnabled?: boolean | null;
  lockedByActionId?: string | null;
};

export type ChangeDataResponseOfLenderDraftDataRow = {
  actionId: string;
  rows: Array<LenderDraftDataRow>;
  originalRows: Array<LenderDraftDataRow>;
  reviewInfo: ReviewInfo;
  pageOptions: PageResponse;
  validationFeedback: {
    [key: string]: ChangeRequestRowFeedback;
  };
  isValid: boolean | null;
};

export type LenderDraftDataRow = LenderDraftDto & {
  rowNumber?: number;
};

export type AddRowsRequestOfLenderDraftDataRow = {
  data: Array<LenderDraftDataRow>;
};

export type NoteResponse = {
  id: string;
  text: string;
  category: NoteCategory;
  date: string;
  user: string;
  entityType: EntityType;
  entityId: string;
};

export enum NoteCategory {
  /**
   * COMPLIANCE
   */
  COMPLIANCE = 'COMPLIANCE',
  /**
   * ONBOARDING
   */
  ONBOARDING = 'ONBOARDING',
  /**
   * OTHER
   */
  OTHER = 'OTHER',
}

export enum EntityType {
  /**
   * FIRMS
   */
  FIRMS = 'FIRMS',
  /**
   * INTERMEDIARIES
   */
  INTERMEDIARIES = 'INTERMEDIARIES',
}

export type DraftNote = {
  entityId?: string | null;
  entityType?: ActionEntityType | null;
  text?: string | null;
  category?: NoteCategory | null;
  user?: string | null;
};

export type OptionsResponse = {
  fields?: {
    [key: string]: {
      [key: string]: string;
    };
  };
};

export enum FieldType {
  /**
   * UNKNOWN
   */
  UNKNOWN = 'UNKNOWN',
  /**
   * YES_NO
   */
  YES_NO = 'YES_NO',
  /**
   * APPLICATION_REQUEST_TYPE
   */
  APPLICATION_REQUEST_TYPE = 'APPLICATION_REQUEST_TYPE',
  /**
   * CALCULATION_TYPE
   */
  CALCULATION_TYPE = 'CALCULATION_TYPE',
  /**
   * FEE_CALCULATION_TYPE
   */
  FEE_CALCULATION_TYPE = 'FEE_CALCULATION_TYPE',
  /**
   * FEE_TYPE
   */
  FEE_TYPE = 'FEE_TYPE',
  /**
   * PROPERTY_PURPOSE
   */
  PROPERTY_PURPOSE = 'PROPERTY_PURPOSE',
  /**
   * REPAYMENT_TYPE
   */
  REPAYMENT_TYPE = 'REPAYMENT_TYPE',
  /**
   * VARIABILITY_TYPE
   */
  VARIABILITY_TYPE = 'VARIABILITY_TYPE',
  /**
   * INITIAL_RATE_TYPE
   */
  INITIAL_RATE_TYPE = 'INITIAL_RATE_TYPE',
  /**
   * EMPLOYMENT_TYPE
   */
  EMPLOYMENT_TYPE = 'EMPLOYMENT_TYPE',
  /**
   * OCCUPANCY_TYPE
   */
  OCCUPANCY_TYPE = 'OCCUPANCY_TYPE',
  /**
   * SCHEME
   */
  SCHEME = 'SCHEME',
  /**
   * APPLICANT_TYPES
   */
  APPLICANT_TYPES = 'APPLICANT_TYPES',
  /**
   * PRODUCT_FEE_BASED_ON
   */
  PRODUCT_FEE_BASED_ON = 'PRODUCT_FEE_BASED_ON',
  /**
   * BUILDING_TYPE
   */
  BUILDING_TYPE = 'BUILDING_TYPE',
  /**
   * PROJECT_TYPE
   */
  PROJECT_TYPE = 'PROJECT_TYPE',
  /**
   * PROPERTY_TYPE
   */
  PROPERTY_TYPE = 'PROPERTY_TYPE',
  /**
   * ACTION_ENTITY_TYPE
   */
  ACTION_ENTITY_TYPE = 'ACTION_ENTITY_TYPE',
  /**
   * ACTION_TYPE
   */
  ACTION_TYPE = 'ACTION_TYPE',
  /**
   * ACTION_STATUS
   */
  ACTION_STATUS = 'ACTION_STATUS',
  /**
   * REGULATORY_TYPE
   */
  REGULATORY_TYPE = 'REGULATORY_TYPE',
  /**
   * CASE_PERMISSION_TYPE
   */
  CASE_PERMISSION_TYPE = 'CASE_PERMISSION_TYPE',
  /**
   * ASSISTANT_PERMISSION_TYPE
   */
  ASSISTANT_PERMISSION_TYPE = 'ASSISTANT_PERMISSION_TYPE',
  /**
   * OPERATION_TYPE
   */
  OPERATION_TYPE = 'OPERATION_TYPE',
  /**
   * PROCURATION_FEE_UNIT
   */
  PROCURATION_FEE_UNIT = 'PROCURATION_FEE_UNIT',
  /**
   * PROCURATION_FEE_BASIS
   */
  PROCURATION_FEE_BASIS = 'PROCURATION_FEE_BASIS',
  /**
   * ENDING_TYPE
   */
  ENDING_TYPE = 'ENDING_TYPE',
  /**
   * SOURCE_CURRENCY
   */
  SOURCE_CURRENCY = 'SOURCE_CURRENCY',
  /**
   * TARGET_CURRENCY
   */
  TARGET_CURRENCY = 'TARGET_CURRENCY',
  /**
   * PROCURATION_FEE_ITEM_TYPE
   */
  PROCURATION_FEE_ITEM_TYPE = 'PROCURATION_FEE_ITEM_TYPE',
  /**
   * FIRM_TYPE
   */
  FIRM_TYPE = 'FIRM_TYPE',
  /**
   * USER_ROLE_TYPE
   */
  USER_ROLE_TYPE = 'USER_ROLE_TYPE',
  /**
   * PAYMENT_METHOD
   */
  PAYMENT_METHOD = 'PAYMENT_METHOD',
  /**
   * PAYMENT_STAGE
   */
  PAYMENT_STAGE = 'PAYMENT_STAGE',
  /**
   * COMPLIANCE_STATUS
   */
  COMPLIANCE_STATUS = 'COMPLIANCE_STATUS',
  /**
   * USER_STATUS
   */
  USER_STATUS = 'USER_STATUS',
  /**
   * PROCURATION_FEES
   */
  PROCURATION_FEES = 'PROCURATION_FEES',
  /**
   * PROCURATION_FEE_RULES
   */
  PROCURATION_FEE_RULES = 'PROCURATION_FEE_RULES',
  /**
   * PRODUCT_TERM
   */
  PRODUCT_TERM = 'PRODUCT_TERM',
  /**
   * APPLICATION_TYPE
   */
  APPLICATION_TYPE = 'APPLICATION_TYPE',
  /**
   * NOTE_CATEGORY
   */
  NOTE_CATEGORY = 'NOTE_CATEGORY',
  /**
   * ROLES
   */
  ROLES = 'ROLES',
  /**
   * TITLES
   */
  TITLES = 'TITLES',
  /**
   * TEAMS
   */
  TEAMS = 'TEAMS',
  /**
   * TRADING_NAMES
   */
  TRADING_NAMES = 'TRADING_NAMES',
  /**
   * CONTROLLED_FUNCTION
   */
  CONTROLLED_FUNCTION = 'CONTROLLED_FUNCTION',
  /**
   * BASE_RATES
   */
  BASE_RATES = 'BASE_RATES',
  /**
   * ERC_PROFILES
   */
  ERC_PROFILES = 'ERC_PROFILES',
  /**
   * FEE_PROFILES
   */
  FEE_PROFILES = 'FEE_PROFILES',
  /**
   * FEES
   */
  FEES = 'FEES',
  /**
   * CURRENT_PRODUCTS
   */
  CURRENT_PRODUCTS = 'CURRENT_PRODUCTS',
  /**
   * BRANDS
   */
  BRANDS = 'BRANDS',
  /**
   * ADDITIONAL_FIELDS
   */
  ADDITIONAL_FIELDS = 'ADDITIONAL_FIELDS',
  /**
   * EXCLUSIVITY_SETS
   */
  EXCLUSIVITY_SETS = 'EXCLUSIVITY_SETS',
  /**
   * FIRMS
   */
  FIRMS = 'FIRMS',
  /**
   * REGIONS
   */
  REGIONS = 'REGIONS',
  /**
   * BDMS
   */
  BDMS = 'BDMS',
  /**
   * PRINCIPALS
   */
  PRINCIPALS = 'PRINCIPALS',
  /**
   * ADVISORS
   */
  ADVISORS = 'ADVISORS',
  /**
   * MORTGAGE_CLUBS
   */
  MORTGAGE_CLUBS = 'MORTGAGE_CLUBS',
  /**
   * PACKAGERS
   */
  PACKAGERS = 'PACKAGERS',
  /**
   * PAYMENT_ROUTE_FIRMS
   */
  PAYMENT_ROUTE_FIRMS = 'PAYMENT_ROUTE_FIRMS',
  /**
   * PRINCIPALS_OHPEN_ID
   */
  PRINCIPALS_OHPEN_ID = 'PRINCIPALS_OHPEN_ID',
  /**
   * PACKAGERS_OHPEN_ID
   */
  PACKAGERS_OHPEN_ID = 'PACKAGERS_OHPEN_ID',
  /**
   * PAYMENT_ROUTE_FIRMS_OHPEN_ID
   */
  PAYMENT_ROUTE_FIRMS_OHPEN_ID = 'PAYMENT_ROUTE_FIRMS_OHPEN_ID',
}

export type ProcFeeAssignmentFeResponse = {
  id?: string | null;
  order?: number;
  procurationFeeRule?: KeyValue;
  operationType?: OperationType | null;
  applicationType?: ApplicationType | null;
  propertyPurpose?: PropertyPurpose | null;
  procurationFee?: KeyValue;
  lockedByActionId?: string | null;
  feeItems?: Array<ProcurationFeeItem>;
};

export type ProcFeeAssignmentsCrudChangeResponse = {
  isValid?: boolean;
  errors?: ProcFeeAssignmentsValidationErrors;
  actionId?: string | null;
};

export type ProcFeeAssignmentsValidationErrors = {
  procurationFeeRuleId?: Array<string>;
  procurationFeeId?: Array<string>;
  index?: Array<string>;
  id?: Array<string>;
};

export type ProblemDetails2 = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: unknown;
};

export type ChangeRequestOfDraftProcFeeAssignmentFe = {
  data: DraftProcFeeAssignmentFe;
  actionType: ActionType;
};

export type DraftProcFeeAssignmentFe = {
  id?: string | null;
  procurationFeeRuleId?: string;
  procurationFeeId?: string;
  order?: number | null;
  lockedByActionId?: string | null;
};

export type ChangeRequestOfListOfDraftProcFeeAssignmentFe = {
  data: Array<DraftProcFeeAssignmentFe>;
  actionType: ActionType;
};

export type ChangeDataResponseOfProcFeeAssignmentFeDataRow = {
  actionId: string;
  rows: Array<ProcFeeAssignmentFeDataRow>;
  originalRows: Array<ProcFeeAssignmentFeDataRow>;
  reviewInfo: ReviewInfo;
  pageOptions: PageResponse;
  validationFeedback: {
    [key: string]: ChangeRequestRowFeedback;
  };
  isValid: boolean | null;
};

export type ProcFeeAssignmentFeDataRow = {
  rowNumber?: number;
  id?: string | null;
  procurationFeeRuleId?: string;
  procurationFeeId?: string;
  order?: number | null;
  lockedByActionId?: string | null;
};

export type AddRowsRequestOfProcFeeAssignmentFeDataRow = {
  data: Array<ProcFeeAssignmentFeDataRow>;
};

export type GetProcurationFeeResponse = {
  completionFee: GetFeeDto;
  trailFees?: Array<GetTrailFeeDto> | null;
  isDefault?: boolean | null;
  feeName?: string | null;
  firmBoosts?: Array<GetFirmBoostDto> | null;
};

export type GetFeeDto = {
  value?: number;
  unit: GetFeeUnit;
  basis?: FeeBasis | null;
};

export enum GetFeeUnit {
  /**
   * BasisPoints
   */
  BASIS_POINTS = 'BasisPoints',
  /**
   * Currency
   */
  CURRENCY = 'Currency',
}

export type GetTrailFeeDto = {
  startingMonth?: number;
  intervalInMonths?: number;
  endingType: EndingType;
  value?: number;
  unit: GetFeeUnit;
  basis?: FeeBasis | null;
};

export type GetFirmBoostDto = {
  firmId: string;
  value?: number;
  unit: GetFeeUnit;
};

export type GetProcurationFeeRequest = {
  ownerFirmId?: string | null;
  submissionRouteId?: string | null;
  packagerFirmId?: string | null;
  applicationType?: ApplicationType | null;
  propertyPurpose?: PropertyPurpose | null;
  loanParts?: Array<LoanPart> | null;
};

export type LoanPart = {
  loanAmount?: number | null;
  productCode?: string | null;
};

export type GetProcurationFeeResponseV2 = {
  completionFee: GetFeeDto;
  trailFees?: Array<GetTrailFeeDto> | null;
  baseFee: GetNamedFeeDto;
  firmBoosts?: Array<GetFirmBoostDto> | null;
};

export type GetNamedFeeDto = {
  name: string;
  value?: number;
  unit: GetFeeUnit;
  basis?: FeeBasis | null;
};

export type GetProcurationFeeRequestV2 = {
  advisorFirmId: string;
  submissionRouteId: string;
  applicationType?: ApplicationType | null;
  propertyPurpose?: PropertyPurpose | null;
  loanParts?: Array<LoanPart> | null;
};

export type ProcurationFeeRuleResponse = {
  id: string;
  name: string;
  operationType?: OperationType | null;
  applicationType?: ApplicationType | null;
  propertyPurpose?: PropertyPurpose | null;
  lockedByActionId?: string | null;
};

export type UsageBatchResponse = {
  items?: Array<UsageItem> | null;
  notFound?: Array<string> | null;
};

export type UsageItem = {
  id?: string | null;
  isUsed?: boolean | null;
};

export type ProcurationFeeRulesCrudChangeResponse = {
  isValid?: boolean;
  errors?: ProcurationFeeRuleValidationErrors;
  actionId?: string | null;
};

export type ProcurationFeeRuleValidationErrors = {
  name?: Array<string>;
  operationType?: Array<string>;
  applicationType?: Array<string>;
  propertyPurpose?: Array<string>;
};

export type ChangeRequestOfDraftProcurationFeeRule = {
  data: DraftProcurationFeeRule;
  actionType: ActionType;
};

export type DraftProcurationFeeRule = ILockable & {
  id?: string | null;
  pendingId?: string | null;
  name?: string | null;
  operationType?: OperationType | null;
  applicationType?: ApplicationType | null;
  propertyPurpose?: PropertyPurpose | null;
};

export type ChangeDataResponseOfProcurationFeeRuleDataRow = {
  actionId: string;
  rows: Array<ProcurationFeeRuleDataRow>;
  originalRows: Array<ProcurationFeeRuleDataRow>;
  reviewInfo: ReviewInfo;
  pageOptions: PageResponse;
  validationFeedback: {
    [key: string]: ChangeRequestRowFeedback;
  };
  isValid: boolean | null;
};

export type ProcurationFeeRuleDataRow = DraftProcurationFeeRule & {
  rowNumber?: number;
};

export type AddRowsRequestOfProcurationFeeRuleDataRow = {
  data: Array<ProcurationFeeRuleDataRow>;
};

export type ProcurationFeeItemsResponse = {
  id: string;
  name: string;
  lockedByActionId?: string | null;
  feeItems: Array<ProcurationFeeItem>;
};

export type ProcurationFeeCrudChangeResponse = {
  isValid?: boolean;
  errors?: ProcurationFeeValidationErrors;
  actionId?: string | null;
};

export type ProcurationFeeValidationErrors = {
  id?: Array<string> | null;
  name?: Array<string> | null;
  items?: Array<string> | null;
  itemErrors?: {
    [key: string]: ProcurationFeeItemValidationErrors;
  };
};

export type ProcurationFeeItemValidationErrors = {
  value?: Array<string> | null;
  unit?: Array<string> | null;
  basis?: Array<string> | null;
  procurationFeeItemType?: Array<string> | null;
  startingMonth?: Array<string> | null;
  intervalInMonths?: Array<string> | null;
  endingType?: Array<string> | null;
  index?: Array<string> | null;
};

export type ChangeRequestOfNormalizedDraftProcurationFee = {
  data: NormalizedDraftProcurationFee;
  actionType: ActionType;
};

export type NormalizedDraftProcurationFee = ILockable & {
  id?: string | null;
  name?: string | null;
  trailFees?: Array<DraftTrailFee> | null;
  completionFee?: DraftFee | null;
};

export type DraftTrailFee = DraftFee & {
  startingMonth?: number | null;
  intervalInMonths?: number | null;
  endingType?: EndingType | null;
};

export type DraftFee = {
  value?: number | null;
  unit?: FeeUnit | null;
  basis?: FeeBasis | null;
};

export type ChangeDataResponseOfProcurationFeeDataRow = {
  actionId: string;
  rows: Array<ProcurationFeeDataRow>;
  originalRows: Array<ProcurationFeeDataRow>;
  reviewInfo: ReviewInfo;
  pageOptions: PageResponse;
  validationFeedback: {
    [key: string]: ChangeRequestRowFeedback;
  };
  isValid: boolean | null;
};

export type ProcurationFeeDataRow = DraftProcurationFeeItem & {
  rowNumber?: number;
};

export type DraftProcurationFeeItem = ILockable & {
  id?: string | null;
  pendingId?: string | null;
  name?: string | null;
  index?: number;
  value?: number;
  unit?: FeeUnit;
  basis?: FeeBasis | null;
  procurationFeeItemType?: ProcurationFeeItemType;
  startingMonth?: number | null;
  intervalInMonths?: number | null;
  endingType?: EndingType | null;
};

export type AddRowsRequestOfProcurationFeeDataRow = {
  data: Array<ProcurationFeeDataRow>;
};

export type ProductChangeDataResponse = {
  actionId: string;
  rows: Array<ProductChangeDataRow>;
  originalRows: Array<ProductChangeDataRow>;
  reviewInfo: ReviewInfo;
  pageOptions: PageResponse;
  validationFeedback: {
    [key: string]: ChangeRequestRowFeedback;
  };
  isValid: boolean | null;
};

export type ProductChangeDataRow = ProductRequest & {
  rowNumber: number;
  originalCode?: string | null;
};

export type ProductRequest = ILockable & {
  code?: string | null;
  name?: string | null;
  group?: string | null;
  followingProductCode?: string | null;
  replacesCode?: string | null;
  replacedByCode?: string | null;
  applicationTypes?: Array<ApplicationRequestType> | null;
  applicantTypes?: Array<ApplicantTypes> | null;
  baseRate?: string | null;
  ercProfile?: string | null;
  feeProfile?: string | null;
  initialRateType?: InitialRateType | null;
  propertyPurposes?: Array<PropertyPurpose2> | null;
  employmentType?: EmploymentType | null;
  repaymentTypes?: Array<RepaymentType> | null;
  expat?: boolean | null;
  portable?: boolean | null;
  overpaymentsAllowed?: number | null;
  paymentsHoliday?: boolean | null;
  initialPeriodUntil?: string | null;
  initialPeriodInMonths?: number | null;
  minTotalLoanAmount?: number | null;
  maxTotalLoanAmount?: number | null;
  minDurationInMonths?: number | null;
  maxDurationInMonths?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  gracePeriodEndDate?: string | null;
  productCutoffDate?: string | null;
  minLtv?: number | null;
  maxLtv?: number | null;
  surcharge?: number | null;
  baseRateAmount?: number | null;
  rate?: number | null;
  stressRate?: number | null;
  margin?: number | null;
  maxLti?: number | null;
  maxNumberOfApplicants?: number | null;
  brands?: Array<string> | null;
  productFeePercentOverride?: number | null;
  productFeeBasedOnOverride?: FeeBasedOn | null;
  productFeePoundsOverride?: number | null;
  applicationFeeOverride?: number | null;
  occupancyTypes?: Array<OccupancyType> | null;
  schemes?: Array<Scheme> | null;
  green?: boolean | null;
  energyPerformanceCertificateSaver?: boolean | null;
  feesAssisted?: boolean | null;
  freeValuation?: boolean | null;
  cashback?: number | null;
  regulatoryTypes?: Array<RegulatoryType> | null;
  projectTypes?: Array<ProjectType> | null;
  propertyTypes?: Array<PropertyType> | null;
  buildingTypes?: Array<BuildingType> | null;
  region?: string | null;
  additionalFields?: {
    [key: string]: string;
  } | null;
  lockedByActionId?: string | null;
  belongsToExclusivitySets?: Array<string>;
  productTerm?: ProductTerm | null;
};

export enum ApplicationRequestType {
  /**
   * PURCHASE
   */
  PURCHASE = 'PURCHASE',
  /**
   * REMORTGAGE
   */
  REMORTGAGE = 'REMORTGAGE',
}

export enum ApplicantTypes {
  /**
   * FIRST_TIME_BUYER
   */
  FIRST_TIME_BUYER = 'FIRST_TIME_BUYER',
  /**
   * FIRST_TIME_LANDLORD
   */
  FIRST_TIME_LANDLORD = 'FIRST_TIME_LANDLORD',
  /**
   * EXISTING_CUSTOMER
   */
  EXISTING_CUSTOMER = 'EXISTING_CUSTOMER',
  /**
   * BORROWER_WITH_OTHER_LENDER
   */
  BORROWER_WITH_OTHER_LENDER = 'BORROWER_WITH_OTHER_LENDER',
  /**
   * NO_CURRENT_MORTGAGE
   */
  NO_CURRENT_MORTGAGE = 'NO_CURRENT_MORTGAGE',
}

export enum InitialRateType {
  /**
   * FIXED
   */
  FIXED = 'FIXED',
  /**
   * VARIABLE
   */
  VARIABLE = 'VARIABLE',
  /**
   * DISCOUNTED
   */
  DISCOUNTED = 'DISCOUNTED',
}

export enum PropertyPurpose2 {
  /**
   * OWNER_OCCUPATION
   */
  OWNER_OCCUPATION = 'OWNER_OCCUPATION',
  /**
   * BUY_TO_LET
   */
  BUY_TO_LET = 'BUY_TO_LET',
  /**
   * SECOND_HOME
   */
  SECOND_HOME = 'SECOND_HOME',
  /**
   * PORTFOLIO_BUY_TO_LET
   */
  PORTFOLIO_BUY_TO_LET = 'PORTFOLIO_BUY_TO_LET',
  /**
   * COMPANY_BUY_TO_LET
   */
  COMPANY_BUY_TO_LET = 'COMPANY_BUY_TO_LET',
}

export enum EmploymentType {
  /**
   * PROFESSIONAL
   */
  PROFESSIONAL = 'PROFESSIONAL',
  /**
   * KEY_WORKER
   */
  KEY_WORKER = 'KEY_WORKER',
}

export enum RepaymentType {
  /**
   * CAPITALANDINTEREST
   */
  CAPITALANDINTEREST = 'CAPITALANDINTEREST',
  /**
   * INTERESTONLY
   */
  INTERESTONLY = 'INTERESTONLY',
  /**
   * PARTANDPART
   */
  PARTANDPART = 'PARTANDPART',
}

export enum OccupancyType {
  /**
   * STANDARD
   */
  STANDARD = 'STANDARD',
  /**
   * HMO_SMALL
   */
  HMO_SMALL = 'HMO_SMALL',
  /**
   * HMO_LARGE
   */
  HMO_LARGE = 'HMO_LARGE',
  /**
   * SHORT_TERM_LET
   */
  SHORT_TERM_LET = 'SHORT_TERM_LET',
  /**
   * HOLIDAY_LET
   */
  HOLIDAY_LET = 'HOLIDAY_LET',
  /**
   * MULTIPLE_UNIT_FREEHOLD_BLOCK
   */
  MULTIPLE_UNIT_FREEHOLD_BLOCK = 'MULTIPLE_UNIT_FREEHOLD_BLOCK',
  /**
   * MULTIPLE_PROPERTIES_ONE_TITLE
   */
  MULTIPLE_PROPERTIES_ONE_TITLE = 'MULTIPLE_PROPERTIES_ONE_TITLE',
  /**
   * MIXED_USE
   */
  MIXED_USE = 'MIXED_USE',
}

export enum Scheme {
  /**
   * STANDARD
   */
  STANDARD = 'STANDARD',
  /**
   * DISCOUNTED
   */
  DISCOUNTED = 'DISCOUNTED',
  /**
   * EQUITY_SHARE
   */
  EQUITY_SHARE = 'EQUITY_SHARE',
  /**
   * SHARED_OWNERSHIP
   */
  SHARED_OWNERSHIP = 'SHARED_OWNERSHIP',
  /**
   * JBSP
   */
  JBSP = 'JBSP',
}

export enum RegulatoryType {
  /**
   * REGULATED
   */
  REGULATED = 'REGULATED',
  /**
   * NON_REGULATED
   */
  NON_REGULATED = 'NON_REGULATED',
  /**
   * CBTL
   */
  CBTL = 'CBTL',
}

export enum ProjectType {
  /**
   * STANDARD
   */
  STANDARD = 'STANDARD',
  /**
   * SELFBUILD
   */
  SELFBUILD = 'SELFBUILD',
  /**
   * RENOVATION
   */
  RENOVATION = 'RENOVATION',
  /**
   * CONVERSION
   */
  CONVERSION = 'CONVERSION',
  /**
   * OFFSITEBUILD
   */
  OFFSITEBUILD = 'OFFSITEBUILD',
}

export enum PropertyType {
  /**
   * EXISTINGBUILD
   */
  EXISTINGBUILD = 'EXISTINGBUILD',
  /**
   * NEWBUILD
   */
  NEWBUILD = 'NEWBUILD',
  /**
   * EXTENSIVERENOVATION
   */
  EXTENSIVERENOVATION = 'EXTENSIVERENOVATION',
}

export enum BuildingType {
  /**
   * HOUSE
   */
  HOUSE = 'HOUSE',
  /**
   * BUNGALOW
   */
  BUNGALOW = 'BUNGALOW',
  /**
   * FLAT
   */
  FLAT = 'FLAT',
  /**
   * MAISONETTE
   */
  MAISONETTE = 'MAISONETTE',
  /**
   * STUDIO_FLAT
   */
  STUDIO_FLAT = 'STUDIO_FLAT',
  /**
   * COACH_HOUSE
   */
  COACH_HOUSE = 'COACH_HOUSE',
  /**
   * TERRACED_HOUSE
   */
  TERRACED_HOUSE = 'TERRACED_HOUSE',
  /**
   * SEMI_DETACHED_HOUSE
   */
  SEMI_DETACHED_HOUSE = 'SEMI_DETACHED_HOUSE',
  /**
   * DETACHED_HOUSE
   */
  DETACHED_HOUSE = 'DETACHED_HOUSE',
  /**
   * OTHER
   */
  OTHER = 'OTHER',
}

export enum ProductTerm {
  /**
   * TWO_YEARS
   */
  TWO_YEARS = 'TWO_YEARS',
  /**
   * THREE_YEARS
   */
  THREE_YEARS = 'THREE_YEARS',
  /**
   * FIVE_YEARS
   */
  FIVE_YEARS = 'FIVE_YEARS',
  /**
   * SEVEN_YEARS
   */
  SEVEN_YEARS = 'SEVEN_YEARS',
  /**
   * TEN_YEARS
   */
  TEN_YEARS = 'TEN_YEARS',
  /**
   * FIFTEEN_YEARS
   */
  FIFTEEN_YEARS = 'FIFTEEN_YEARS',
  /**
   * TWENTY_YEARS
   */
  TWENTY_YEARS = 'TWENTY_YEARS',
  /**
   * LIFETIME
   */
  LIFETIME = 'LIFETIME',
}

export type ProductChangeAddRowsRequest = {
  data: Array<ProductChangeDataRow>;
};

export type ProductChangeResultResponse = {
  actionId: string;
  rows: Array<ProductChangeDataRow>;
  originalRows: Array<ProductChangeDataRow>;
  validationFeedback: {
    [key: string]: ChangeRequestRowFeedback;
  };
  pageOptions: PageResponse;
};

export type ColumnDeltaUpdateRequest = {
  columnName: string;
  delta: number;
};

export type ExclusivitySetResponse = ILockable & {
  id: string;
  name: string;
  description?: string | null;
  startDate: string;
  endDate?: string | null;
  firms?: Array<StringPair>;
};

export type ExclusivitySetsCrudChangeResponse = {
  isValid?: boolean;
  errors?: ExclusivitySetValidationErrors;
  actionId?: string | null;
};

export type ExclusivitySetValidationErrors = {
  name?: Array<string>;
  description?: Array<string>;
  firms?: Array<string>;
  startDate?: Array<string>;
  endDate?: Array<string>;
};

export type ChangeRequestOfExclusivitySetRequest = {
  data: ExclusivitySetRequest;
  actionType: ActionType;
};

export type ExclusivitySetRequest = ILockable & {
  id?: string | null;
  pendingId?: string | null;
  name?: string | null;
  description?: string | null;
  firms?: Array<string> | null;
  startDate?: string | null;
  endDate?: string | null;
  lockedByActionId?: string | null;
};

export type ChangeDataResponseOfExclusivitySetDataRow = {
  actionId: string;
  rows: Array<ExclusivitySetDataRow>;
  originalRows: Array<ExclusivitySetDataRow>;
  reviewInfo: ReviewInfo;
  pageOptions: PageResponse;
  validationFeedback: {
    [key: string]: ChangeRequestRowFeedback;
  };
  isValid: boolean | null;
};

export type ExclusivitySetDataRow = ExclusivitySetRequest & {
  rowNumber?: number;
};

export type AddRowsRequestOfExclusivitySetDataRow = {
  data: Array<ExclusivitySetDataRow>;
};

export type ProductResponse = {
  technicalProductCode?: string;
  code?: string;
  name?: string;
  group?: string | null;
  followingProductCode?: string | null;
  followingProductGroup?: string | null;
  replacesCode?: string | null;
  replacedByCode?: string | null;
  applicationTypes?: Array<StringPair>;
  applicantTypes?: Array<StringPair>;
  baseRateAmount?: number;
  baseRate?: StringPair | null;
  ercProfile?: StringPair | null;
  feeProfile?: StringPair | null;
  initialRateType?: StringPair | null;
  propertyPurposes?: Array<StringPair>;
  employmentType?: StringPair | null;
  regulatoryTypes?: Array<StringPair>;
  repaymentTypes?: Array<StringPair>;
  expat?: boolean | null;
  initialPeriodUntil?: string | null;
  initialPeriodInMonths?: number | null;
  minTotalLoanAmount?: number | null;
  maxTotalLoanAmount?: number | null;
  minDurationInMonths?: number | null;
  maxDurationInMonths?: number | null;
  startDate?: string | null;
  endDate?: string | null;
  gracePeriodEndDate?: string | null;
  productCutoffDate?: string | null;
  aprc?: number | null;
  minLtv?: number | null;
  maxLtv?: number | null;
  rate?: number;
  surcharge?: number | null;
  stressRate?: number | null;
  margin?: number | null;
  maxLti?: number | null;
  maxNumberOfApplicants?: number | null;
  brands?: Array<StringPair>;
  productFeePercentOverride?: number | null;
  productFeeBasedOnOverride?: StringPair | null;
  productFeePoundsOverride?: number | null;
  applicationFeeOverride?: number | null;
  occupancyTypes?: Array<StringPair>;
  schemes?: Array<StringPair>;
  green?: boolean | null;
  energyPerformanceCertificateSaver?: boolean | null;
  feesAssisted?: boolean | null;
  portable?: boolean | null;
  overpaymentsAllowed?: number | null;
  paymentsHoliday?: boolean | null;
  freeValuation?: boolean | null;
  cashback?: number | null;
  region?: string | null;
  projectTypes?: Array<StringPair>;
  propertyTypes?: Array<StringPair>;
  buildingTypes?: Array<StringPair>;
  additionalFields?: {
    [key: string]: string;
  };
  lockedByActionId?: string | null;
  belongsToExclusivitySets?: Array<string>;
  productTerm?: StringPair | null;
};

export type SqePageOfProductResponse = {
  items: Array<ProductResponse>;
  page: number;
  pageSize: number;
  total: number;
  query: SqeRequest;
};

export type ProductCodesResponse = {
  code?: string;
  name?: string;
};

export type BoSyncStatusResponse = {
  status: StringPair;
};

export type RegionResponse = {
  id: string;
  name: string;
  bdmIds: Array<string>;
};

export type RegionRequest = {
  name: string;
};

export type RegionReplaceRequest = {
  replacementRegionId: string;
};

export type PmpStaffResponse = {
  id: string;
  lenderId: string;
  email: string;
  personalData?: PersonalData | null;
  userStatus: UserStatus;
  roles?: Array<UserRoleType> | null;
  notes?: Array<string> | null;
  firstUsedTheSystem?: string | null;
  lastUsedTheSystem?: string | null;
  activationDate?: string | null;
  roleAssignments?: {
    [key: string]: UserRoleType;
  } | null;
};

export type TableViewResponse = {
  id: string;
  name: string;
  entityType: ActionEntityType;
  selected: Array<string>;
  order: Array<string>;
  fixedTableColumns: {
    [key: string]: FixedColumnPosition;
  };
  tableColumnSizes: {
    [key: string]: number;
  };
  versionNumber: number;
};

export enum FixedColumnPosition {
  /**
   * FIXEDLEFT
   */
  FIXEDLEFT = 'left',
  /**
   * FIXEDRIGHT
   */
  FIXEDRIGHT = 'right',
  /**
   * NONE
   */
  NONE = 'none',
}

export type CreateTableViewRequest = {
  name: string;
  entityType: ActionEntityType;
  selected: Array<string>;
  order: Array<string>;
  fixedTableColumns: {
    [key: string]: FixedColumnPosition;
  };
  tableColumnSizes?: {
    [key: string]: number;
  };
};

export type Translation = {
  term: string;
  language: string;
  translationText?: string | null;
  versionNumber?: number | null;
};

export type UserResponse = {
  username: string;
  email?: string | null;
  name?: string | null;
  status?: string | null;
  enabled: boolean;
  createdAt?: string | null;
  groups: Array<string>;
  signInMethod: SignInMethod;
  identityProvider?: string | null;
};

export enum SignInMethod {
  /**
   * CREDENTIALS
   */
  CREDENTIALS = 'CREDENTIALS',
  /**
   * SSO
   */
  SSO = 'SSO',
}

export enum ActionStatus {
  /**
   * DRAFT
   */
  DRAFT = 'DRAFT',
  /**
   * PENDING_REVIEW
   */
  PENDING_REVIEW = 'PENDING_REVIEW',
  /**
   * PENDING_RESUBMISSION
   */
  PENDING_RESUBMISSION = 'PENDING_RESUBMISSION',
  /**
   * APPROVED
   */
  APPROVED = 'APPROVED',
  /**
   * PENDING_PROCESSING
   */
  PENDING_PROCESSING = 'PENDING_PROCESSING',
  /**
   * PROCESSING
   */
  PROCESSING = 'PROCESSING',
  /**
   * APPLIED
   */
  APPLIED = 'APPLIED',
  /**
   * PARTIALLY_APPLIED
   */
  PARTIALLY_APPLIED = 'PARTIALLY_APPLIED',
  /**
   * NOT_APPLIED
   */
  NOT_APPLIED = 'NOT_APPLIED',
  /**
   * REJECTED
   */
  REJECTED = 'REJECTED',
  /**
   * INVALIDATED
   */
  INVALIDATED = 'INVALIDATED',
  /**
   * DELETED
   */
  DELETED = 'DELETED',
}

/**
 * Combines its nodes with and, or or not. not takes exactly one node; an empty and or or is true.
 */
export type GroupNode = {
  type: 'group';
  op: GroupOperator;
  nodes: Array<FilterNode>;
};

/**
 * Compares one declared field with a literal value: a scalar, or an array of 1 to 100 values for the list operators. isNull, isNotNull and isEmpty take no value. A date is yyyy-MM-dd; an instant is ISO 8601 UTC ending in Z with at most six fractional digits.
 */
export type PredicateNode = {
  type: 'predicate';
  field: string;
  op: FilterOperator;
  /**
   * A string, number, boolean or array, by the field and the operator.
   */
  value?: unknown;
};

/**
 * Holds when any, all or none of a row's elements in a declared collection meet its node, which names only the collection's fields. all holds for a row with no elements.
 */
export type CollectionNode = {
  type: 'collection';
  collection: string;
  op: CollectionOperator;
  node: FilterNode;
};

export enum GroupOperator {
  AND = 'and',
  OR = 'or',
  NOT = 'not',
}

export enum FilterOperator {
  EQ = 'eq',
  NEQ = 'neq',
  IN = 'in',
  NOT_IN = 'notIn',
  LT = 'lt',
  LTE = 'lte',
  GT = 'gt',
  GTE = 'gte',
  CONTAINS = 'contains',
  STARTS_WITH = 'startsWith',
  IS_NULL = 'isNull',
  IS_NOT_NULL = 'isNotNull',
  ANY_OF = 'anyOf',
  SUBSET_OF = 'subsetOf',
  SUPERSET_OF = 'supersetOf',
  EXACT_SET = 'exactSet',
  IS_EMPTY = 'isEmpty',
}

export enum CollectionOperator {
  ANY = 'any',
  ALL = 'all',
  NONE = 'none',
}

/**
 * The body of an SQE: a filter tree, an ordering and a page. Echoed as the page's query, as applied.
 */
export type FirmsSqeRequest = {
  filter?: FirmsSqeFilterNode;
  /**
   * At most 3 terms, applied in order. The server appends its own tiebreak.
   */
  sort?: Array<FirmsSqeSortTerm>;
  /**
   * The 1-based page number.
   */
  page?: number;
  /**
   * The number of rows on a page.
   */
  pageSize?: number;
};

/**
 * One node of a filter tree over the declared fields and collections.
 */
export type FirmsSqeFilterNode =
  | {
      type: 'group';
      op: GroupOperator;
      nodes: Array<FirmsSqeFilterNode>;
    }
  | {
      type: 'predicate';
      field: 'ohpenId';
      op: 'eq' | 'neq' | 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'ohpenId';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'id';
      op: 'eq' | 'neq';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'id';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'isAuthorised';
      op: 'eq' | 'neq';
      value: boolean;
    }
  | {
      type: 'predicate';
      field: 'reference';
      op: 'eq' | 'neq' | 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'reference';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'reference';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'frn';
      op: 'eq' | 'neq';
      value: number;
    }
  | {
      type: 'predicate';
      field: 'frn';
      op: 'in' | 'notIn';
      value: Array<number>;
    }
  | {
      type: 'predicate';
      field: 'frn';
      op: 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'frn';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'name';
      op: 'eq' | 'neq' | 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'name';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'type';
      op: 'eq' | 'neq';
      value: 'APPOINTED_REPRESENTATIVE' | 'DIRECTLY_AUTHORISED' | 'NOT_FCA_REGISTERED';
    }
  | {
      type: 'predicate';
      field: 'type';
      op: 'in' | 'notIn';
      value: Array<'APPOINTED_REPRESENTATIVE' | 'DIRECTLY_AUTHORISED' | 'NOT_FCA_REGISTERED'>;
    }
  | {
      type: 'predicate';
      field: 'nacfbNumber';
      op: 'eq' | 'neq' | 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'nacfbNumber';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'nacfbNumber';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'fcaStatus';
      op: 'eq' | 'neq' | 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'fcaStatus';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'fcaStatus';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'defaultPaymentRouteFirm';
      op: 'eq' | 'neq';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'defaultPaymentRouteFirm';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'defaultPaymentRouteFirm';
      op: 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'defaultPaymentRouteFirm';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'btl';
      op: 'eq' | 'neq';
      value: 'MANAGE' | 'CREATE_AND_MANAGE';
    }
  | {
      type: 'predicate';
      field: 'btl';
      op: 'in' | 'notIn';
      value: Array<'MANAGE' | 'CREATE_AND_MANAGE'>;
    }
  | {
      type: 'predicate';
      field: 'rbtl';
      op: 'eq' | 'neq';
      value: 'MANAGE' | 'CREATE_AND_MANAGE';
    }
  | {
      type: 'predicate';
      field: 'rbtl';
      op: 'in' | 'notIn';
      value: Array<'MANAGE' | 'CREATE_AND_MANAGE'>;
    }
  | {
      type: 'predicate';
      field: 'rmc';
      op: 'eq' | 'neq';
      value: 'MANAGE' | 'CREATE_AND_MANAGE';
    }
  | {
      type: 'predicate';
      field: 'rmc';
      op: 'in' | 'notIn';
      value: Array<'MANAGE' | 'CREATE_AND_MANAGE'>;
    }
  | {
      type: 'predicate';
      field: 'firmCompliance';
      op: 'eq' | 'neq';
      value: 'PENDING' | 'FAILED' | 'PASSED' | 'RE_REVIEW_REQUIRED';
    }
  | {
      type: 'predicate';
      field: 'firmCompliance';
      op: 'in' | 'notIn';
      value: Array<'PENDING' | 'FAILED' | 'PASSED' | 'RE_REVIEW_REQUIRED'>;
    }
  | {
      type: 'predicate';
      field: 'isActive';
      op: 'eq' | 'neq';
      value: boolean;
    }
  | {
      type: 'predicate';
      field: 'activationDate';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'activationDate';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'deactivationDate';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'deactivationDate';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'lockedByActionId';
      op: 'eq' | 'neq' | 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'lockedByActionId';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'lockedByActionId';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'collection';
      collection: 'principalFirm';
      op: CollectionOperator;
      node: FirmsSqePrincipalFirmFilterNode;
    }
  | {
      type: 'collection';
      collection: 'operationsWhitelist';
      op: CollectionOperator;
      node: FirmsSqeOperationsWhitelistFilterNode;
    };

/**
 * One term of the ordering, over a sortable field. NULLs sort last in both directions.
 */
export type FirmsSqeSortTerm = {
  field:
    | 'ohpenId'
    | 'id'
    | 'isAuthorised'
    | 'reference'
    | 'frn'
    | 'name'
    | 'type'
    | 'nacfbNumber'
    | 'fcaStatus'
    | 'defaultPaymentRouteFirm'
    | 'btl'
    | 'rbtl'
    | 'rmc'
    | 'firmCompliance'
    | 'isActive'
    | 'activationDate'
    | 'deactivationDate'
    | 'lockedByActionId';
  dir: SortDirection;
};

/**
 * One node of a condition on one element of 'principalFirm'.
 */
export type FirmsSqePrincipalFirmFilterNode =
  | {
      type: 'group';
      op: GroupOperator;
      nodes: Array<FirmsSqePrincipalFirmFilterNode>;
    }
  | {
      type: 'predicate';
      field: 'id';
      op: 'eq' | 'neq';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'id';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'name';
      op: 'eq' | 'neq' | 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'name';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'name';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'frn';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: number;
    }
  | {
      type: 'predicate';
      field: 'frn';
      op: 'in' | 'notIn';
      value: Array<number>;
    }
  | {
      type: 'predicate';
      field: 'frn';
      op: 'isNull' | 'isNotNull';
    };

/**
 * One node of a condition on one element of 'operationsWhitelist'.
 */
export type FirmsSqeOperationsWhitelistFilterNode =
  | {
      type: 'group';
      op: GroupOperator;
      nodes: Array<FirmsSqeOperationsWhitelistFilterNode>;
    }
  | {
      type: 'predicate';
      field: 'key';
      op: 'eq' | 'neq';
      value: 'NETWORK' | 'ADVICE' | 'PACKAGE' | 'MORTGAGE_CLUB';
    }
  | {
      type: 'predicate';
      field: 'key';
      op: 'in' | 'notIn';
      value: Array<'NETWORK' | 'ADVICE' | 'PACKAGE' | 'MORTGAGE_CLUB'>;
    }
  | {
      type: 'predicate';
      field: 'value';
      op: 'eq' | 'neq';
      value: 'NETWORK' | 'ADVICE' | 'PACKAGE' | 'MORTGAGE_CLUB';
    }
  | {
      type: 'predicate';
      field: 'value';
      op: 'in' | 'notIn';
      value: Array<'NETWORK' | 'ADVICE' | 'PACKAGE' | 'MORTGAGE_CLUB'>;
    };

/**
 * The body of an SQE: a filter tree, an ordering and a page. Echoed as the page's query, as applied.
 */
export type IntermediariesSqeRequest = {
  filter?: IntermediariesSqeFilterNode;
  /**
   * At most 3 terms, applied in order. The server appends its own tiebreak.
   */
  sort?: Array<IntermediariesSqeSortTerm>;
  /**
   * The 1-based page number.
   */
  page?: number;
  /**
   * The number of rows on a page.
   */
  pageSize?: number;
};

/**
 * One node of a filter tree over the declared fields and collections.
 */
export type IntermediariesSqeFilterNode =
  | {
      type: 'group';
      op: GroupOperator;
      nodes: Array<IntermediariesSqeFilterNode>;
    }
  | {
      type: 'predicate';
      field: 'id';
      op: 'eq' | 'neq';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'id';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'ohpenId';
      op: 'eq' | 'neq' | 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'ohpenId';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'ohpenId';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'firmName';
      op: 'eq' | 'neq' | 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'firmName';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'firmOhpenId';
      op: 'eq' | 'neq' | 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'firmOhpenId';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'firmOhpenId';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'tradingAddress';
      op: 'eq' | 'neq' | 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'tradingAddress';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'tradingAddress';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'roles';
      op: 'anyOf' | 'subsetOf' | 'supersetOf' | 'exactSet';
      value: Array<'VIEWER' | 'ADVISOR' | 'ASSISTANT' | 'SUPERVISOR' | 'ADMIN' | 'COMPLIANCE' | 'SUPPORT'>;
    }
  | {
      type: 'predicate';
      field: 'roles';
      op: 'isEmpty';
    }
  | {
      type: 'predicate';
      field: 'userStatus';
      op: 'eq' | 'neq';
      value: 'INACTIVE' | 'PENDING' | 'ACTIVE';
    }
  | {
      type: 'predicate';
      field: 'userStatus';
      op: 'in' | 'notIn';
      value: Array<'INACTIVE' | 'PENDING' | 'ACTIVE'>;
    }
  | {
      type: 'predicate';
      field: 'compliance';
      op: 'eq' | 'neq';
      value: 'PENDING' | 'FAILED' | 'PASSED' | 'RE_REVIEW_REQUIRED';
    }
  | {
      type: 'predicate';
      field: 'compliance';
      op: 'in' | 'notIn';
      value: Array<'PENDING' | 'FAILED' | 'PASSED' | 'RE_REVIEW_REQUIRED'>;
    }
  | {
      type: 'predicate';
      field: 'firmFRN';
      op: 'eq' | 'neq';
      value: number;
    }
  | {
      type: 'predicate';
      field: 'firmFRN';
      op: 'in' | 'notIn';
      value: Array<number>;
    }
  | {
      type: 'predicate';
      field: 'firmFRN';
      op: 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'firmFRN';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'irn';
      op: 'eq' | 'neq' | 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'irn';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'irn';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'email';
      op: 'eq' | 'neq' | 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'email';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'displayName';
      op: 'eq' | 'neq' | 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'displayName';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'displayName';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'activationDate';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'activationDate';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'deactivationDate';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'deactivationDate';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'lockedByActionId';
      op: 'eq' | 'neq' | 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'lockedByActionId';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'lockedByActionId';
      op: 'isNull' | 'isNotNull';
    };

/**
 * One term of the ordering, over a sortable field. NULLs sort last in both directions.
 */
export type IntermediariesSqeSortTerm = {
  field:
    | 'id'
    | 'ohpenId'
    | 'firmName'
    | 'firmOhpenId'
    | 'tradingAddress'
    | 'userStatus'
    | 'compliance'
    | 'firmFRN'
    | 'irn'
    | 'email'
    | 'displayName'
    | 'activationDate'
    | 'deactivationDate'
    | 'lockedByActionId';
  dir: SortDirection;
};

/**
 * The body of an SQE: a filter tree, an ordering and a page. Echoed as the page's query, as applied.
 */
export type ProductsSqeRequest = {
  filter?: ProductsSqeFilterNode;
  /**
   * At most 3 terms, applied in order. The server appends its own tiebreak.
   */
  sort?: Array<ProductsSqeSortTerm>;
  /**
   * The 1-based page number.
   */
  page?: number;
  /**
   * The number of rows on a page.
   */
  pageSize?: number;
};

/**
 * One node of a filter tree over the declared fields and collections.
 */
export type ProductsSqeFilterNode =
  | {
      type: 'group';
      op: GroupOperator;
      nodes: Array<ProductsSqeFilterNode>;
    }
  | {
      type: 'predicate';
      field: 'code';
      op: 'eq' | 'neq' | 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'code';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'name';
      op: 'eq' | 'neq' | 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'name';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'group';
      op: 'eq' | 'neq' | 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'group';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'group';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'followingProductCode';
      op: 'eq' | 'neq' | 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'followingProductCode';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'followingProductCode';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'followingProductGroup';
      op: 'eq' | 'neq' | 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'followingProductGroup';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'followingProductGroup';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'replacesCode';
      op: 'eq' | 'neq' | 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'replacesCode';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'replacesCode';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'replacedByCode';
      op: 'eq' | 'neq' | 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'replacedByCode';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'replacedByCode';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'applicationTypes';
      op: 'anyOf' | 'subsetOf' | 'supersetOf' | 'exactSet';
      value: Array<'PURCHASE' | 'REMORTGAGE'>;
    }
  | {
      type: 'predicate';
      field: 'applicationTypes';
      op: 'isEmpty';
    }
  | {
      type: 'predicate';
      field: 'applicantTypes';
      op: 'anyOf' | 'subsetOf' | 'supersetOf' | 'exactSet';
      value: Array<'FIRST_TIME_BUYER' | 'FIRST_TIME_LANDLORD' | 'EXISTING_CUSTOMER' | 'BORROWER_WITH_OTHER_LENDER' | 'NO_CURRENT_MORTGAGE'>;
    }
  | {
      type: 'predicate';
      field: 'applicantTypes';
      op: 'isEmpty';
    }
  | {
      type: 'predicate';
      field: 'baseRateAmount';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: number;
    }
  | {
      type: 'predicate';
      field: 'baseRateAmount';
      op: 'in' | 'notIn';
      value: Array<number>;
    }
  | {
      type: 'predicate';
      field: 'baseRate';
      op: 'eq' | 'neq';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'baseRate';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'baseRate';
      op: 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'baseRate';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'ercProfile';
      op: 'eq' | 'neq';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'ercProfile';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'ercProfile';
      op: 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'ercProfile';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'feeProfile';
      op: 'eq' | 'neq';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'feeProfile';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'feeProfile';
      op: 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'feeProfile';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'initialRateType';
      op: 'eq' | 'neq';
      value: 'FIXED' | 'VARIABLE' | 'DISCOUNTED';
    }
  | {
      type: 'predicate';
      field: 'initialRateType';
      op: 'in' | 'notIn';
      value: Array<'FIXED' | 'VARIABLE' | 'DISCOUNTED'>;
    }
  | {
      type: 'predicate';
      field: 'initialRateType';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'propertyPurposes';
      op: 'anyOf' | 'subsetOf' | 'supersetOf' | 'exactSet';
      value: Array<'OWNER_OCCUPATION' | 'BUY_TO_LET' | 'SECOND_HOME' | 'PORTFOLIO_BUY_TO_LET' | 'COMPANY_BUY_TO_LET'>;
    }
  | {
      type: 'predicate';
      field: 'propertyPurposes';
      op: 'isEmpty';
    }
  | {
      type: 'predicate';
      field: 'employmentType';
      op: 'eq' | 'neq';
      value: 'PROFESSIONAL' | 'KEY_WORKER';
    }
  | {
      type: 'predicate';
      field: 'employmentType';
      op: 'in' | 'notIn';
      value: Array<'PROFESSIONAL' | 'KEY_WORKER'>;
    }
  | {
      type: 'predicate';
      field: 'employmentType';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'regulatoryTypes';
      op: 'anyOf' | 'subsetOf' | 'supersetOf' | 'exactSet';
      value: Array<'REGULATED' | 'NON_REGULATED' | 'CBTL'>;
    }
  | {
      type: 'predicate';
      field: 'regulatoryTypes';
      op: 'isEmpty';
    }
  | {
      type: 'predicate';
      field: 'repaymentTypes';
      op: 'anyOf' | 'subsetOf' | 'supersetOf' | 'exactSet';
      value: Array<'CAPITALANDINTEREST' | 'INTERESTONLY' | 'PARTANDPART'>;
    }
  | {
      type: 'predicate';
      field: 'repaymentTypes';
      op: 'isEmpty';
    }
  | {
      type: 'predicate';
      field: 'expat';
      op: 'eq' | 'neq';
      value: boolean;
    }
  | {
      type: 'predicate';
      field: 'expat';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'initialPeriodUntil';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'initialPeriodUntil';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'initialPeriodInMonths';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: number;
    }
  | {
      type: 'predicate';
      field: 'initialPeriodInMonths';
      op: 'in' | 'notIn';
      value: Array<number>;
    }
  | {
      type: 'predicate';
      field: 'initialPeriodInMonths';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'minTotalLoanAmount';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: number;
    }
  | {
      type: 'predicate';
      field: 'minTotalLoanAmount';
      op: 'in' | 'notIn';
      value: Array<number>;
    }
  | {
      type: 'predicate';
      field: 'minTotalLoanAmount';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'maxTotalLoanAmount';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: number;
    }
  | {
      type: 'predicate';
      field: 'maxTotalLoanAmount';
      op: 'in' | 'notIn';
      value: Array<number>;
    }
  | {
      type: 'predicate';
      field: 'maxTotalLoanAmount';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'minDurationInMonths';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: number;
    }
  | {
      type: 'predicate';
      field: 'minDurationInMonths';
      op: 'in' | 'notIn';
      value: Array<number>;
    }
  | {
      type: 'predicate';
      field: 'minDurationInMonths';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'maxDurationInMonths';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: number;
    }
  | {
      type: 'predicate';
      field: 'maxDurationInMonths';
      op: 'in' | 'notIn';
      value: Array<number>;
    }
  | {
      type: 'predicate';
      field: 'maxDurationInMonths';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'startDate';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'startDate';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'endDate';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'endDate';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'gracePeriodEndDate';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'gracePeriodEndDate';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'productCutoffDate';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'productCutoffDate';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'minLtv';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: number;
    }
  | {
      type: 'predicate';
      field: 'minLtv';
      op: 'in' | 'notIn';
      value: Array<number>;
    }
  | {
      type: 'predicate';
      field: 'minLtv';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'maxLtv';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: number;
    }
  | {
      type: 'predicate';
      field: 'maxLtv';
      op: 'in' | 'notIn';
      value: Array<number>;
    }
  | {
      type: 'predicate';
      field: 'maxLtv';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'rate';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: number;
    }
  | {
      type: 'predicate';
      field: 'rate';
      op: 'in' | 'notIn';
      value: Array<number>;
    }
  | {
      type: 'predicate';
      field: 'surcharge';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: number;
    }
  | {
      type: 'predicate';
      field: 'surcharge';
      op: 'in' | 'notIn';
      value: Array<number>;
    }
  | {
      type: 'predicate';
      field: 'surcharge';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'stressRate';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: number;
    }
  | {
      type: 'predicate';
      field: 'stressRate';
      op: 'in' | 'notIn';
      value: Array<number>;
    }
  | {
      type: 'predicate';
      field: 'stressRate';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'margin';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: number;
    }
  | {
      type: 'predicate';
      field: 'margin';
      op: 'in' | 'notIn';
      value: Array<number>;
    }
  | {
      type: 'predicate';
      field: 'margin';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'maxLti';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: number;
    }
  | {
      type: 'predicate';
      field: 'maxLti';
      op: 'in' | 'notIn';
      value: Array<number>;
    }
  | {
      type: 'predicate';
      field: 'maxLti';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'maxNumberOfApplicants';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: number;
    }
  | {
      type: 'predicate';
      field: 'maxNumberOfApplicants';
      op: 'in' | 'notIn';
      value: Array<number>;
    }
  | {
      type: 'predicate';
      field: 'maxNumberOfApplicants';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'brands';
      op: 'anyOf' | 'subsetOf' | 'supersetOf' | 'exactSet';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'brands';
      op: 'isEmpty';
    }
  | {
      type: 'predicate';
      field: 'productFeePercentOverride';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: number;
    }
  | {
      type: 'predicate';
      field: 'productFeePercentOverride';
      op: 'in' | 'notIn';
      value: Array<number>;
    }
  | {
      type: 'predicate';
      field: 'productFeePercentOverride';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'productFeeBasedOnOverride';
      op: 'eq' | 'neq';
      value: 'LOANAMOUNT' | 'PROPERTYVALUE';
    }
  | {
      type: 'predicate';
      field: 'productFeeBasedOnOverride';
      op: 'in' | 'notIn';
      value: Array<'LOANAMOUNT' | 'PROPERTYVALUE'>;
    }
  | {
      type: 'predicate';
      field: 'productFeeBasedOnOverride';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'productFeePoundsOverride';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: number;
    }
  | {
      type: 'predicate';
      field: 'productFeePoundsOverride';
      op: 'in' | 'notIn';
      value: Array<number>;
    }
  | {
      type: 'predicate';
      field: 'productFeePoundsOverride';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'applicationFeeOverride';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: number;
    }
  | {
      type: 'predicate';
      field: 'applicationFeeOverride';
      op: 'in' | 'notIn';
      value: Array<number>;
    }
  | {
      type: 'predicate';
      field: 'applicationFeeOverride';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'occupancyTypes';
      op: 'anyOf' | 'subsetOf' | 'supersetOf' | 'exactSet';
      value: Array<
        | 'STANDARD'
        | 'HMO_SMALL'
        | 'HMO_LARGE'
        | 'SHORT_TERM_LET'
        | 'HOLIDAY_LET'
        | 'MULTIPLE_UNIT_FREEHOLD_BLOCK'
        | 'MULTIPLE_PROPERTIES_ONE_TITLE'
        | 'MIXED_USE'
      >;
    }
  | {
      type: 'predicate';
      field: 'occupancyTypes';
      op: 'isEmpty';
    }
  | {
      type: 'predicate';
      field: 'schemes';
      op: 'anyOf' | 'subsetOf' | 'supersetOf' | 'exactSet';
      value: Array<'STANDARD' | 'DISCOUNTED' | 'EQUITY_SHARE' | 'SHARED_OWNERSHIP' | 'JBSP'>;
    }
  | {
      type: 'predicate';
      field: 'schemes';
      op: 'isEmpty';
    }
  | {
      type: 'predicate';
      field: 'green';
      op: 'eq' | 'neq';
      value: boolean;
    }
  | {
      type: 'predicate';
      field: 'green';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'energyPerformanceCertificateSaver';
      op: 'eq' | 'neq';
      value: boolean;
    }
  | {
      type: 'predicate';
      field: 'energyPerformanceCertificateSaver';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'feesAssisted';
      op: 'eq' | 'neq';
      value: boolean;
    }
  | {
      type: 'predicate';
      field: 'feesAssisted';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'portable';
      op: 'eq' | 'neq';
      value: boolean;
    }
  | {
      type: 'predicate';
      field: 'portable';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'overpaymentsAllowed';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: number;
    }
  | {
      type: 'predicate';
      field: 'overpaymentsAllowed';
      op: 'in' | 'notIn';
      value: Array<number>;
    }
  | {
      type: 'predicate';
      field: 'overpaymentsAllowed';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'paymentsHoliday';
      op: 'eq' | 'neq';
      value: boolean;
    }
  | {
      type: 'predicate';
      field: 'paymentsHoliday';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'freeValuation';
      op: 'eq' | 'neq';
      value: boolean;
    }
  | {
      type: 'predicate';
      field: 'freeValuation';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'cashback';
      op: 'eq' | 'neq' | 'lt' | 'lte' | 'gt' | 'gte';
      value: number;
    }
  | {
      type: 'predicate';
      field: 'cashback';
      op: 'in' | 'notIn';
      value: Array<number>;
    }
  | {
      type: 'predicate';
      field: 'cashback';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'region';
      op: 'eq' | 'neq' | 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'region';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'region';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'projectTypes';
      op: 'anyOf' | 'subsetOf' | 'supersetOf' | 'exactSet';
      value: Array<'STANDARD' | 'SELFBUILD' | 'RENOVATION' | 'CONVERSION' | 'OFFSITEBUILD'>;
    }
  | {
      type: 'predicate';
      field: 'projectTypes';
      op: 'isEmpty';
    }
  | {
      type: 'predicate';
      field: 'propertyTypes';
      op: 'anyOf' | 'subsetOf' | 'supersetOf' | 'exactSet';
      value: Array<'EXISTINGBUILD' | 'NEWBUILD' | 'EXTENSIVERENOVATION'>;
    }
  | {
      type: 'predicate';
      field: 'propertyTypes';
      op: 'isEmpty';
    }
  | {
      type: 'predicate';
      field: 'buildingTypes';
      op: 'anyOf' | 'subsetOf' | 'supersetOf' | 'exactSet';
      value: Array<
        | 'HOUSE'
        | 'BUNGALOW'
        | 'FLAT'
        | 'MAISONETTE'
        | 'STUDIO_FLAT'
        | 'COACH_HOUSE'
        | 'TERRACED_HOUSE'
        | 'SEMI_DETACHED_HOUSE'
        | 'DETACHED_HOUSE'
        | 'OTHER'
      >;
    }
  | {
      type: 'predicate';
      field: 'buildingTypes';
      op: 'isEmpty';
    }
  | {
      type: 'predicate';
      field: 'lockedByActionId';
      op: 'eq' | 'neq' | 'contains' | 'startsWith';
      value: string;
    }
  | {
      type: 'predicate';
      field: 'lockedByActionId';
      op: 'in' | 'notIn';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'lockedByActionId';
      op: 'isNull' | 'isNotNull';
    }
  | {
      type: 'predicate';
      field: 'belongsToExclusivitySets';
      op: 'anyOf' | 'subsetOf' | 'supersetOf' | 'exactSet';
      value: Array<string>;
    }
  | {
      type: 'predicate';
      field: 'belongsToExclusivitySets';
      op: 'isEmpty';
    }
  | {
      type: 'predicate';
      field: 'productTerm';
      op: 'eq' | 'neq';
      value: 'TWO_YEARS' | 'THREE_YEARS' | 'FIVE_YEARS' | 'SEVEN_YEARS' | 'TEN_YEARS' | 'FIFTEEN_YEARS' | 'TWENTY_YEARS' | 'LIFETIME';
    }
  | {
      type: 'predicate';
      field: 'productTerm';
      op: 'in' | 'notIn';
      value: Array<
        'TWO_YEARS' | 'THREE_YEARS' | 'FIVE_YEARS' | 'SEVEN_YEARS' | 'TEN_YEARS' | 'FIFTEEN_YEARS' | 'TWENTY_YEARS' | 'LIFETIME'
      >;
    }
  | {
      type: 'predicate';
      field: 'productTerm';
      op: 'isNull' | 'isNotNull';
    };

/**
 * One term of the ordering, over a sortable field. NULLs sort last in both directions.
 */
export type ProductsSqeSortTerm = {
  field:
    | 'code'
    | 'name'
    | 'group'
    | 'followingProductCode'
    | 'followingProductGroup'
    | 'replacesCode'
    | 'replacedByCode'
    | 'baseRateAmount'
    | 'baseRate'
    | 'ercProfile'
    | 'feeProfile'
    | 'initialRateType'
    | 'employmentType'
    | 'expat'
    | 'initialPeriodUntil'
    | 'initialPeriodInMonths'
    | 'minTotalLoanAmount'
    | 'maxTotalLoanAmount'
    | 'minDurationInMonths'
    | 'maxDurationInMonths'
    | 'startDate'
    | 'endDate'
    | 'gracePeriodEndDate'
    | 'productCutoffDate'
    | 'minLtv'
    | 'maxLtv'
    | 'rate'
    | 'surcharge'
    | 'stressRate'
    | 'margin'
    | 'maxLti'
    | 'maxNumberOfApplicants'
    | 'productFeePercentOverride'
    | 'productFeeBasedOnOverride'
    | 'productFeePoundsOverride'
    | 'applicationFeeOverride'
    | 'green'
    | 'energyPerformanceCertificateSaver'
    | 'feesAssisted'
    | 'portable'
    | 'overpaymentsAllowed'
    | 'paymentsHoliday'
    | 'freeValuation'
    | 'cashback'
    | 'region'
    | 'lockedByActionId'
    | 'productTerm';
  dir: SortDirection;
};

export type AddressesSearchData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: {
    query?: string;
    maxSuggestions?: number;
  };
  url: '/addresses/search';
};

export type AddressesSearchErrors = {
  /**
   * Invalid query
   */
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type AddressesSearchError = AddressesSearchErrors[keyof AddressesSearchErrors];

export type AddressesSearchResponses = {
  /**
   * Success
   */
  200: AddressSearchResponse;
};

export type AddressesSearchResponse = AddressesSearchResponses[keyof AddressesSearchResponses];

export type AddressesGetDetailsData = {
  body: AddressDetailsRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/addresses/details';
};

export type AddressesGetDetailsErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Address not found
   */
  404: ProblemDetails;
};

export type AddressesGetDetailsError = AddressesGetDetailsErrors[keyof AddressesGetDetailsErrors];

export type AddressesGetDetailsResponses = {
  /**
   * Success
   */
  200: AddressDetailsResponse;
};

export type AddressesGetDetailsResponse = AddressesGetDetailsResponses[keyof AddressesGetDetailsResponses];

export type BaseRatesGetAllBaseRatesData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/baserates';
};

export type BaseRatesGetAllBaseRatesErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type BaseRatesGetAllBaseRatesError = BaseRatesGetAllBaseRatesErrors[keyof BaseRatesGetAllBaseRatesErrors];

export type BaseRatesGetAllBaseRatesResponses = {
  /**
   * Success
   */
  200: Array<BaseRateResponse>;
};

export type BaseRatesGetAllBaseRatesResponse = BaseRatesGetAllBaseRatesResponses[keyof BaseRatesGetAllBaseRatesResponses];

export type GetBaseRateData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    baseRateCode: string;
  };
  query?: never;
  url: '/baserates/{baseRateCode}';
};

export type GetBaseRateErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not Found
   */
  404: ProblemDetails;
};

export type GetBaseRateError = GetBaseRateErrors[keyof GetBaseRateErrors];

export type GetBaseRateResponses = {
  /**
   * Success
   */
  200: BaseRateResponse;
};

export type GetBaseRateResponse = GetBaseRateResponses[keyof GetBaseRateResponses];

export type BaseRatesCreateChangeRequestData = {
  body: ChangeRequestOfBaseRateRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/baserates/create';
};

export type BaseRatesCreateChangeRequestErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type BaseRatesCreateChangeRequestError = BaseRatesCreateChangeRequestErrors[keyof BaseRatesCreateChangeRequestErrors];

export type BaseRatesCreateChangeRequestResponses = {
  /**
   * Validation or creation result
   */
  200: BaseRateCrudChangeResponse;
};

export type BaseRatesCreateChangeRequestResponse = BaseRatesCreateChangeRequestResponses[keyof BaseRatesCreateChangeRequestResponses];

export type BaseRatesCheckBaseRateUsageData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    baseRateCode: string;
  };
  query?: never;
  url: '/baserates/{baseRateCode}/usage';
};

export type BaseRatesCheckBaseRateUsageErrors = {
  /**
   * Invalid Base Rate Code
   */
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Base Rate not found
   */
  404: ProblemDetails;
};

export type BaseRatesCheckBaseRateUsageError = BaseRatesCheckBaseRateUsageErrors[keyof BaseRatesCheckBaseRateUsageErrors];

export type BaseRatesCheckBaseRateUsageResponses = {
  /**
   * Returns usage status
   */
  200: UsageResponse;
};

export type BaseRatesCheckBaseRateUsageResponse = BaseRatesCheckBaseRateUsageResponses[keyof BaseRatesCheckBaseRateUsageResponses];

export type BaseRatesValidateDeleteData = {
  body: DeleteCrRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/baserates/validate-delete';
};

export type BaseRatesValidateDeleteErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type BaseRatesValidateDeleteError = BaseRatesValidateDeleteErrors[keyof BaseRatesValidateDeleteErrors];

export type BaseRatesValidateDeleteResponses = {
  /**
   * Per-ID validation result
   */
  200: DeletePrecheckResult;
};

export type BaseRatesValidateDeleteResponse = BaseRatesValidateDeleteResponses[keyof BaseRatesValidateDeleteResponses];

export type BaseRatesCreateDeleteCrData = {
  body: DeleteCrRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/baserates/delete-cr';
};

export type BaseRatesCreateDeleteCrErrors = {
  /**
   * Nothing to delete
   */
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type BaseRatesCreateDeleteCrError = BaseRatesCreateDeleteCrErrors[keyof BaseRatesCreateDeleteCrErrors];

export type BaseRatesCreateDeleteCrResponses = {
  /**
   * Delete CR created
   */
  201: CreateDeleteCrResponse;
};

export type BaseRatesCreateDeleteCrResponse = BaseRatesCreateDeleteCrResponses[keyof BaseRatesCreateDeleteCrResponses];

export type BaseRatesGetDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/baserates/{actionId}/data';
};

export type BaseRatesGetDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type BaseRatesGetDataError = BaseRatesGetDataErrors[keyof BaseRatesGetDataErrors];

export type BaseRatesGetDataResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfBaseRateChangeDataRow;
};

export type BaseRatesGetDataResponse = BaseRatesGetDataResponses[keyof BaseRatesGetDataResponses];

export type BaseRatesAddOrUpdateDataData = {
  body: AddRowsRequestOfBaseRateChangeDataRow;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: never;
  url: '/baserates/{actionId}/data';
};

export type BaseRatesAddOrUpdateDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type BaseRatesAddOrUpdateDataError = BaseRatesAddOrUpdateDataErrors[keyof BaseRatesAddOrUpdateDataErrors];

export type BaseRatesAddOrUpdateDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type BaseRatesAddOrUpdateDataResponse = BaseRatesAddOrUpdateDataResponses[keyof BaseRatesAddOrUpdateDataResponses];

export type BaseRatesDeleteDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
    rowNumbers: Array<number>;
  };
  query?: never;
  url: '/baserates/{actionId}/data/{rowNumbers}';
};

export type BaseRatesDeleteDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type BaseRatesDeleteDataResponse = BaseRatesDeleteDataResponses[keyof BaseRatesDeleteDataResponses];

export type BaseRatesGetResultData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/baserates/{actionId}/result';
};

export type BaseRatesGetResultErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Import not finished
   */
  409: ProblemDetails;
};

export type BaseRatesGetResultError = BaseRatesGetResultErrors[keyof BaseRatesGetResultErrors];

export type BaseRatesGetResultResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfBaseRateChangeDataRow;
};

export type BaseRatesGetResultResponse = BaseRatesGetResultResponses[keyof BaseRatesGetResultResponses];

export type BdmGetAllData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/bdms';
};

export type BdmGetAllErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type BdmGetAllError = BdmGetAllErrors[keyof BdmGetAllErrors];

export type BdmGetAllResponses = {
  /**
   * Success
   */
  200: Array<BdmResponse>;
};

export type BdmGetAllResponse = BdmGetAllResponses[keyof BdmGetAllResponses];

export type BdmCreateData = {
  body: BdmRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/bdms';
};

export type BdmCreateErrors = {
  /**
   * Invalid or missing region IDs, or duplicate BDM name
   */
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * BDM name already exists
   */
  409: ProblemDetails;
};

export type BdmCreateError = BdmCreateErrors[keyof BdmCreateErrors];

export type BdmCreateResponses = {
  /**
   * Created
   */
  201: BdmResponse;
};

export type BdmCreateResponse = BdmCreateResponses[keyof BdmCreateResponses];

export type BdmDeleteData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    id: string;
  };
  query?: never;
  url: '/bdms/{id}';
};

export type BdmDeleteErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not Found
   */
  404: ProblemDetails;
  /**
   * BDM in use
   */
  409: ProblemDetails;
};

export type BdmDeleteError = BdmDeleteErrors[keyof BdmDeleteErrors];

export type BdmDeleteResponses = {
  /**
   * No Content
   */
  204: void;
};

export type BdmDeleteResponse = BdmDeleteResponses[keyof BdmDeleteResponses];

export type BdmGetByIdData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    id: string;
  };
  query?: never;
  url: '/bdms/{id}';
};

export type BdmGetByIdErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not Found
   */
  404: ProblemDetails;
};

export type BdmGetByIdError = BdmGetByIdErrors[keyof BdmGetByIdErrors];

export type BdmGetByIdResponses = {
  /**
   * Success
   */
  200: BdmResponse;
};

export type BdmGetByIdResponse = BdmGetByIdResponses[keyof BdmGetByIdResponses];

export type BdmUpdateData = {
  body: BdmRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    id: string;
  };
  query?: never;
  url: '/bdms/{id}';
};

export type BdmUpdateErrors = {
  /**
   * Invalid or missing region IDs, or duplicate BDM name
   */
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not Found
   */
  404: ProblemDetails;
  /**
   * BDM name already exists or a removed region still has assigned addresses
   */
  409: ProblemDetails;
};

export type BdmUpdateError = BdmUpdateErrors[keyof BdmUpdateErrors];

export type BdmUpdateResponses = {
  /**
   * Success
   */
  200: BdmResponse;
};

export type BdmUpdateResponse = BdmUpdateResponses[keyof BdmUpdateResponses];

export type BdmReplaceData = {
  body: BdmReplaceRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    id: string;
  };
  query?: never;
  url: '/bdms/{id}/replace';
};

export type BdmReplaceErrors = {
  /**
   * Invalid replacement
   */
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not Found
   */
  404: ProblemDetails;
  /**
   * Conflict
   */
  409: ProblemDetails;
};

export type BdmReplaceError = BdmReplaceErrors[keyof BdmReplaceErrors];

export type BdmReplaceResponses = {
  /**
   * No Content
   */
  204: void;
};

export type BdmReplaceResponse = BdmReplaceResponses[keyof BdmReplaceResponses];

export type ChangeLogGetEntityChangeLogData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: {
    entityType?: Array<ActionEntityType>;
    entityId?: string;
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/change-log';
};

export type ChangeLogGetEntityChangeLogErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ChangeLogGetEntityChangeLogError = ChangeLogGetEntityChangeLogErrors[keyof ChangeLogGetEntityChangeLogErrors];

export type ChangeLogGetEntityChangeLogResponses = {
  /**
   * Success
   */
  200: ChangeLogEntriesResponse;
};

export type ChangeLogGetEntityChangeLogResponse = ChangeLogGetEntityChangeLogResponses[keyof ChangeLogGetEntityChangeLogResponses];

export type ChangeLogGetEntityChangesData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    entityId?: string;
  };
  url: '/change-log/{actionId}/changes';
};

export type ChangeLogGetEntityChangesErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type ChangeLogGetEntityChangesError = ChangeLogGetEntityChangesErrors[keyof ChangeLogGetEntityChangesErrors];

export type ChangeLogGetEntityChangesResponses = {
  /**
   * Success
   */
  200: Array<FieldChangeResponse>;
};

export type ChangeLogGetEntityChangesResponse = ChangeLogGetEntityChangesResponses[keyof ChangeLogGetEntityChangesResponses];

export type ChangeRequestCreateDraftData = {
  body: CreateDraftRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/changeRequests';
};

export type ChangeRequestCreateDraftErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ChangeRequestCreateDraftError = ChangeRequestCreateDraftErrors[keyof ChangeRequestCreateDraftErrors];

export type ChangeRequestCreateDraftResponses = {
  /**
   * Success
   */
  200: ChangeRequestResponse;
};

export type ChangeRequestCreateDraftResponse = ChangeRequestCreateDraftResponses[keyof ChangeRequestCreateDraftResponses];

export type ChangeRequestGetData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: never;
  url: '/changeRequests/{actionId}';
};

export type ChangeRequestGetErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type ChangeRequestGetError = ChangeRequestGetErrors[keyof ChangeRequestGetErrors];

export type ChangeRequestGetResponses = {
  /**
   * Success
   */
  200: ChangeRequestResponse;
};

export type ChangeRequestGetResponse = ChangeRequestGetResponses[keyof ChangeRequestGetResponses];

export type ChangeRequestGetLatestChangeRequestsData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: {
    entityType?: ActionEntityType | null;
    limit?: number | null;
  };
  url: '/changeRequests/list';
};

export type ChangeRequestGetLatestChangeRequestsErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ChangeRequestGetLatestChangeRequestsError =
  ChangeRequestGetLatestChangeRequestsErrors[keyof ChangeRequestGetLatestChangeRequestsErrors];

export type ChangeRequestGetLatestChangeRequestsResponses = {
  /**
   * Success
   */
  200: Array<ChangeRequestResponse>;
};

export type ChangeRequestGetLatestChangeRequestsResponse =
  ChangeRequestGetLatestChangeRequestsResponses[keyof ChangeRequestGetLatestChangeRequestsResponses];

export type ChangeRequestGetValidationsData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    changeRequestId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/changeRequests/{changeRequestId}/validations';
};

export type ChangeRequestGetValidationsErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type ChangeRequestGetValidationsError = ChangeRequestGetValidationsErrors[keyof ChangeRequestGetValidationsErrors];

export type ChangeRequestGetValidationsResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type ChangeRequestGetValidationsResponse = ChangeRequestGetValidationsResponses[keyof ChangeRequestGetValidationsResponses];

export type ChangeRequestApproveData = {
  body: ChangeRequestComment;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    changeRequestId: string;
  };
  query?: never;
  url: '/changeRequests/{changeRequestId}/approve';
};

export type ChangeRequestApproveErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Change request already started
   */
  409: ProblemDetails;
  /**
   * Unprocessable entity
   */
  422: OhpenValidationError;
};

export type ChangeRequestApproveError = ChangeRequestApproveErrors[keyof ChangeRequestApproveErrors];

export type ChangeRequestApproveResponses = {
  /**
   * Success
   */
  200: unknown;
};

export type ChangeRequestRejectData = {
  body: ChangeRequestComment;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    changeRequestId: string;
  };
  query?: never;
  url: '/changeRequests/{changeRequestId}/reject';
};

export type ChangeRequestRejectErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized or rejecting own change request
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Change request not active
   */
  409: ProblemDetails;
  /**
   * Unprocessable entity
   */
  422: OhpenValidationError;
};

export type ChangeRequestRejectError = ChangeRequestRejectErrors[keyof ChangeRequestRejectErrors];

export type ChangeRequestRejectResponses = {
  /**
   * Success
   */
  200: unknown;
};

export type ChangeRequestResubmissionRequiredData = {
  body: ChangeRequestComment;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    changeRequestId: string;
  };
  query?: never;
  url: '/changeRequests/{changeRequestId}/resubmission-required';
};

export type ChangeRequestResubmissionRequiredErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Unprocessable entity
   */
  422: OhpenValidationError;
};

export type ChangeRequestResubmissionRequiredError = ChangeRequestResubmissionRequiredErrors[keyof ChangeRequestResubmissionRequiredErrors];

export type ChangeRequestResubmissionRequiredResponses = {
  /**
   * Success
   */
  200: ChangeRequestResponse;
};

export type ChangeRequestResubmissionRequiredResponse =
  ChangeRequestResubmissionRequiredResponses[keyof ChangeRequestResubmissionRequiredResponses];

export type ChangeRequestApplyChangeRequestData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    changeRequestId: string;
  };
  query?: never;
  url: '/changeRequests/{changeRequestId}/apply';
};

export type ChangeRequestApplyChangeRequestErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Change request already started
   */
  409: ProblemDetails;
  /**
   * Unprocessable entity
   */
  422: OhpenValidationError;
};

export type ChangeRequestApplyChangeRequestError = ChangeRequestApplyChangeRequestErrors[keyof ChangeRequestApplyChangeRequestErrors];

export type ChangeRequestApplyChangeRequestResponses = {
  /**
   * Success
   */
  202: unknown;
};

export type ChangeRequestSetCloneTypeData = {
  body: SetCloneTypeRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    changeRequestId: string;
  };
  query?: never;
  url: '/changeRequests/{changeRequestId}/cloneType';
};

export type ChangeRequestSetCloneTypeErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type ChangeRequestSetCloneTypeError = ChangeRequestSetCloneTypeErrors[keyof ChangeRequestSetCloneTypeErrors];

export type ChangeRequestSetCloneTypeResponses = {
  /**
   * Success
   */
  204: void;
};

export type ChangeRequestSetCloneTypeResponse = ChangeRequestSetCloneTypeResponses[keyof ChangeRequestSetCloneTypeResponses];

export type ChangeRequestDeleteData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    changeRequestId: string;
  };
  query?: never;
  url: '/changeRequests/{changeRequestId}/delete';
};

export type ChangeRequestDeleteErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Change request not active
   */
  409: ProblemDetails;
  /**
   * Unprocessable entity
   */
  422: OhpenValidationError;
};

export type ChangeRequestDeleteError = ChangeRequestDeleteErrors[keyof ChangeRequestDeleteErrors];

export type ChangeRequestDeleteResponses = {
  /**
   * Success
   */
  202: unknown;
};

export type ConfigurationsGetConfigurationData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/configuration/configuration';
};

export type ConfigurationsGetConfigurationResponses = {
  /**
   * Success
   */
  200: ConfigurationResponse;
};

export type ConfigurationsGetConfigurationResponse = ConfigurationsGetConfigurationResponses[keyof ConfigurationsGetConfigurationResponses];

export type GetAllBrandsData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/configuration/brands';
};

export type GetAllBrandsResponses = {
  /**
   * Success
   */
  200: {
    [key: string]: string;
  };
};

export type GetAllBrandsResponse = GetAllBrandsResponses[keyof GetAllBrandsResponses];

export type GetAllAdditionalFieldsData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: {
    entityType?: ActionEntityType | null;
  };
  url: '/configuration/additionalFields';
};

export type GetAllAdditionalFieldsResponses = {
  /**
   * Success
   */
  200: {
    [key: string]: string;
  };
};

export type GetAllAdditionalFieldsResponse = GetAllAdditionalFieldsResponses[keyof GetAllAdditionalFieldsResponses];

export type ErcProfilesGetAllErcProfilesData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/ercprofiles';
};

export type ErcProfilesGetAllErcProfilesErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ErcProfilesGetAllErcProfilesError = ErcProfilesGetAllErcProfilesErrors[keyof ErcProfilesGetAllErcProfilesErrors];

export type ErcProfilesGetAllErcProfilesResponses = {
  /**
   * Success
   */
  200: Array<ErcProfile>;
};

export type ErcProfilesGetAllErcProfilesResponse = ErcProfilesGetAllErcProfilesResponses[keyof ErcProfilesGetAllErcProfilesResponses];

export type ErcProfilesCheckUsageData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    ercProfileId: string;
  };
  query?: never;
  url: '/ercprofiles/{ercProfileId}/usage';
};

export type ErcProfilesCheckUsageErrors = {
  /**
   * Invalid ERC Profile ID
   */
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * ERC Profile not found
   */
  404: ProblemDetails;
};

export type ErcProfilesCheckUsageError = ErcProfilesCheckUsageErrors[keyof ErcProfilesCheckUsageErrors];

export type ErcProfilesCheckUsageResponses = {
  /**
   * Returns usage status
   */
  200: UsageResponse;
};

export type ErcProfilesCheckUsageResponse = ErcProfilesCheckUsageResponses[keyof ErcProfilesCheckUsageResponses];

export type ErcProfilesCreateChangeRequestData = {
  body: ChangeRequestOfErcProfileCrudRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/ercprofiles/create';
};

export type ErcProfilesCreateChangeRequestErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type ErcProfilesCreateChangeRequestError = ErcProfilesCreateChangeRequestErrors[keyof ErcProfilesCreateChangeRequestErrors];

export type ErcProfilesCreateChangeRequestResponses = {
  /**
   * Validation or creation result
   */
  200: ErcProfileCrudChangeResponse;
};

export type ErcProfilesCreateChangeRequestResponse = ErcProfilesCreateChangeRequestResponses[keyof ErcProfilesCreateChangeRequestResponses];

export type ErcProfilesValidateDeleteData = {
  body: DeleteCrRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/ercprofiles/validate-delete';
};

export type ErcProfilesValidateDeleteErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ErcProfilesValidateDeleteError = ErcProfilesValidateDeleteErrors[keyof ErcProfilesValidateDeleteErrors];

export type ErcProfilesValidateDeleteResponses = {
  /**
   * Per-ID validation result
   */
  200: DeletePrecheckResult;
};

export type ErcProfilesValidateDeleteResponse = ErcProfilesValidateDeleteResponses[keyof ErcProfilesValidateDeleteResponses];

export type ErcProfilesCreateDeleteCrData = {
  body: DeleteCrRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/ercprofiles/delete-cr';
};

export type ErcProfilesCreateDeleteCrErrors = {
  /**
   * Nothing to delete
   */
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ErcProfilesCreateDeleteCrError = ErcProfilesCreateDeleteCrErrors[keyof ErcProfilesCreateDeleteCrErrors];

export type ErcProfilesCreateDeleteCrResponses = {
  /**
   * Delete CR created
   */
  201: CreateDeleteCrResponse;
};

export type ErcProfilesCreateDeleteCrResponse = ErcProfilesCreateDeleteCrResponses[keyof ErcProfilesCreateDeleteCrResponses];

export type ErcProfilesGetDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/ercprofiles/{actionId}/data';
};

export type ErcProfilesGetDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type ErcProfilesGetDataError = ErcProfilesGetDataErrors[keyof ErcProfilesGetDataErrors];

export type ErcProfilesGetDataResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfErcProfileChangeDataRow;
};

export type ErcProfilesGetDataResponse = ErcProfilesGetDataResponses[keyof ErcProfilesGetDataResponses];

export type ErcProfilesAddOrUpdateDataData = {
  body: AddRowsRequestOfErcProfileChangeDataRow;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: never;
  url: '/ercprofiles/{actionId}/data';
};

export type ErcProfilesAddOrUpdateDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type ErcProfilesAddOrUpdateDataError = ErcProfilesAddOrUpdateDataErrors[keyof ErcProfilesAddOrUpdateDataErrors];

export type ErcProfilesAddOrUpdateDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type ErcProfilesAddOrUpdateDataResponse = ErcProfilesAddOrUpdateDataResponses[keyof ErcProfilesAddOrUpdateDataResponses];

export type ErcProfilesDeleteDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
    rowNumbers: Array<number>;
  };
  query?: never;
  url: '/ercprofiles/{actionId}/data/{rowNumbers}';
};

export type ErcProfilesDeleteDataErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ErcProfilesDeleteDataError = ErcProfilesDeleteDataErrors[keyof ErcProfilesDeleteDataErrors];

export type ErcProfilesDeleteDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type ErcProfilesDeleteDataResponse = ErcProfilesDeleteDataResponses[keyof ErcProfilesDeleteDataResponses];

export type ErcProfilesGetResultData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/ercprofiles/{actionId}/result';
};

export type ErcProfilesGetResultErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Import not finished
   */
  409: ProblemDetails;
};

export type ErcProfilesGetResultError = ErcProfilesGetResultErrors[keyof ErcProfilesGetResultErrors];

export type ErcProfilesGetResultResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfErcProfileChangeDataRow;
};

export type ErcProfilesGetResultResponse = ErcProfilesGetResultResponses[keyof ErcProfilesGetResultResponses];

export type ExchangeRatesGetAllExchangeRatesData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/exchange-rates';
};

export type ExchangeRatesGetAllExchangeRatesErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ExchangeRatesGetAllExchangeRatesError = ExchangeRatesGetAllExchangeRatesErrors[keyof ExchangeRatesGetAllExchangeRatesErrors];

export type ExchangeRatesGetAllExchangeRatesResponses = {
  /**
   * Success
   */
  200: Array<GroupedExchangeRateResponse>;
};

export type ExchangeRatesGetAllExchangeRatesResponse =
  ExchangeRatesGetAllExchangeRatesResponses[keyof ExchangeRatesGetAllExchangeRatesResponses];

export type ExchangeRatesCreateChangeRequestData = {
  body: ChangeRequestOfExchangeRateCrudRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/exchange-rates/create';
};

export type ExchangeRatesCreateChangeRequestErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ExchangeRatesCreateChangeRequestError = ExchangeRatesCreateChangeRequestErrors[keyof ExchangeRatesCreateChangeRequestErrors];

export type ExchangeRatesCreateChangeRequestResponses = {
  /**
   * Validation or creation result
   */
  200: ExchangeRateChangeResponse;
};

export type ExchangeRatesCreateChangeRequestResponse =
  ExchangeRatesCreateChangeRequestResponses[keyof ExchangeRatesCreateChangeRequestResponses];

export type ExchangeRatesValidateDeleteData = {
  body: DeleteCrRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/exchange-rates/validate-delete';
};

export type ExchangeRatesValidateDeleteErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ExchangeRatesValidateDeleteError = ExchangeRatesValidateDeleteErrors[keyof ExchangeRatesValidateDeleteErrors];

export type ExchangeRatesValidateDeleteResponses = {
  200: DeletePrecheckResult;
};

export type ExchangeRatesValidateDeleteResponse = ExchangeRatesValidateDeleteResponses[keyof ExchangeRatesValidateDeleteResponses];

export type ExchangeRatesCreateDeleteCrData = {
  body: DeleteCrRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/exchange-rates/delete-cr';
};

export type ExchangeRatesCreateDeleteCrErrors = {
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ExchangeRatesCreateDeleteCrError = ExchangeRatesCreateDeleteCrErrors[keyof ExchangeRatesCreateDeleteCrErrors];

export type ExchangeRatesCreateDeleteCrResponses = {
  201: CreateDeleteCrResponse;
};

export type ExchangeRatesCreateDeleteCrResponse = ExchangeRatesCreateDeleteCrResponses[keyof ExchangeRatesCreateDeleteCrResponses];

export type ExchangeRatesGetDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/exchange-rates/{actionId}/data';
};

export type ExchangeRatesGetDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type ExchangeRatesGetDataError = ExchangeRatesGetDataErrors[keyof ExchangeRatesGetDataErrors];

export type ExchangeRatesGetDataResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfExchangeRateChangeDataRow;
};

export type ExchangeRatesGetDataResponse = ExchangeRatesGetDataResponses[keyof ExchangeRatesGetDataResponses];

export type ExchangeRatesAddOrUpdateDataData = {
  body: AddRowsRequestOfExchangeRateChangeDataRow;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: never;
  url: '/exchange-rates/{actionId}/data';
};

export type ExchangeRatesAddOrUpdateDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type ExchangeRatesAddOrUpdateDataError = ExchangeRatesAddOrUpdateDataErrors[keyof ExchangeRatesAddOrUpdateDataErrors];

export type ExchangeRatesAddOrUpdateDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type ExchangeRatesAddOrUpdateDataResponse = ExchangeRatesAddOrUpdateDataResponses[keyof ExchangeRatesAddOrUpdateDataResponses];

export type ExchangeRatesDeleteDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
    rowNumbers: Array<number>;
  };
  query?: never;
  url: '/exchange-rates/{actionId}/data/{rowNumbers}';
};

export type ExchangeRatesDeleteDataErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ExchangeRatesDeleteDataError = ExchangeRatesDeleteDataErrors[keyof ExchangeRatesDeleteDataErrors];

export type ExchangeRatesDeleteDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type ExchangeRatesDeleteDataResponse = ExchangeRatesDeleteDataResponses[keyof ExchangeRatesDeleteDataResponses];

export type ExchangeRatesGetResultData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/exchange-rates/{actionId}/result';
};

export type ExchangeRatesGetResultErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Import not finished
   */
  409: ProblemDetails;
};

export type ExchangeRatesGetResultError = ExchangeRatesGetResultErrors[keyof ExchangeRatesGetResultErrors];

export type ExchangeRatesGetResultResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfExchangeRateChangeDataRow;
};

export type ExchangeRatesGetResultResponse = ExchangeRatesGetResultResponses[keyof ExchangeRatesGetResultResponses];

export type GetAllExportTemplatesData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: {
    entityType?: ActionEntityType | null;
  };
  url: '/exportTemplates';
};

export type GetAllExportTemplatesResponses = {
  /**
   * Success
   */
  200: Array<ExportTemplateResponse>;
};

export type GetAllExportTemplatesResponse = GetAllExportTemplatesResponses[keyof GetAllExportTemplatesResponses];

export type CreateExportTemplateData = {
  body: CreateExportTemplateRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/exportTemplates';
};

export type CreateExportTemplateErrors = {
  /**
   * Failure
   */
  400: OhpenValidationError;
};

export type CreateExportTemplateError = CreateExportTemplateErrors[keyof CreateExportTemplateErrors];

export type CreateExportTemplateResponses = {
  /**
   * Success
   */
  200: ExportTemplateResponse;
};

export type CreateExportTemplateResponse = CreateExportTemplateResponses[keyof CreateExportTemplateResponses];

export type DeleteExportTemplateData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    templateId: string;
  };
  query?: never;
  url: '/exportTemplates/{templateId}';
};

export type DeleteExportTemplateErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Export Template Not Found
   */
  404: ProblemDetails;
  /**
   * Concurrent Update
   */
  409: ProblemDetails;
};

export type DeleteExportTemplateError = DeleteExportTemplateErrors[keyof DeleteExportTemplateErrors];

export type DeleteExportTemplateResponses = {
  /**
   * Success
   */
  204: void;
};

export type DeleteExportTemplateResponse = DeleteExportTemplateResponses[keyof DeleteExportTemplateResponses];

export type UpdateExportTemplateData = {
  body: CreateExportTemplateRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    templateId: string;
  };
  query?: {
    version?: number;
  };
  url: '/exportTemplates/{templateId}';
};

export type UpdateExportTemplateErrors = {
  /**
   * Failure
   */
  400: OhpenValidationError;
  /**
   * Export template Not Found
   */
  404: ProblemDetails;
  /**
   * Concurrent Update
   */
  409: ProblemDetails;
};

export type UpdateExportTemplateError = UpdateExportTemplateErrors[keyof UpdateExportTemplateErrors];

export type UpdateExportTemplateResponses = {
  /**
   * Success
   */
  200: ExportTemplateResponse;
};

export type UpdateExportTemplateResponse = UpdateExportTemplateResponses[keyof UpdateExportTemplateResponses];

export type FeeDefinitionsGetAllFeeDefinitionsData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/feedefinitions';
};

export type FeeDefinitionsGetAllFeeDefinitionsErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type FeeDefinitionsGetAllFeeDefinitionsError =
  FeeDefinitionsGetAllFeeDefinitionsErrors[keyof FeeDefinitionsGetAllFeeDefinitionsErrors];

export type FeeDefinitionsGetAllFeeDefinitionsResponses = {
  /**
   * Success
   */
  200: Array<FeeDefinition>;
};

export type FeeDefinitionsGetAllFeeDefinitionsResponse =
  FeeDefinitionsGetAllFeeDefinitionsResponses[keyof FeeDefinitionsGetAllFeeDefinitionsResponses];

export type FeeDefinitionsCheckUsageData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    feeId: string;
  };
  query?: never;
  url: '/feedefinitions/{feeId}/usage';
};

export type FeeDefinitionsCheckUsageErrors = {
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  404: ProblemDetails;
};

export type FeeDefinitionsCheckUsageError = FeeDefinitionsCheckUsageErrors[keyof FeeDefinitionsCheckUsageErrors];

export type FeeDefinitionsCheckUsageResponses = {
  200: UsageResponse;
};

export type FeeDefinitionsCheckUsageResponse = FeeDefinitionsCheckUsageResponses[keyof FeeDefinitionsCheckUsageResponses];

export type FeeDefinitionsCreateChangeRequestData = {
  body: ChangeRequestOfFeeDefinitionCrudRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/feedefinitions/create';
};

export type FeeDefinitionsCreateChangeRequestErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  409: ProblemDetails;
};

export type FeeDefinitionsCreateChangeRequestError = FeeDefinitionsCreateChangeRequestErrors[keyof FeeDefinitionsCreateChangeRequestErrors];

export type FeeDefinitionsCreateChangeRequestResponses = {
  200: FeeDefinitionCrudChangeResponse;
};

export type FeeDefinitionsCreateChangeRequestResponse =
  FeeDefinitionsCreateChangeRequestResponses[keyof FeeDefinitionsCreateChangeRequestResponses];

export type FeeDefinitionsValidateDeleteData = {
  body: DeleteCrRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/feedefinitions/validate-delete';
};

export type FeeDefinitionsValidateDeleteErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type FeeDefinitionsValidateDeleteError = FeeDefinitionsValidateDeleteErrors[keyof FeeDefinitionsValidateDeleteErrors];

export type FeeDefinitionsValidateDeleteResponses = {
  /**
   * Per-ID validation result
   */
  200: DeletePrecheckResult;
};

export type FeeDefinitionsValidateDeleteResponse = FeeDefinitionsValidateDeleteResponses[keyof FeeDefinitionsValidateDeleteResponses];

export type FeeDefinitionsCreateDeleteCrData = {
  body: DeleteCrRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/feedefinitions/delete-cr';
};

export type FeeDefinitionsCreateDeleteCrErrors = {
  /**
   * Nothing to delete
   */
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type FeeDefinitionsCreateDeleteCrError = FeeDefinitionsCreateDeleteCrErrors[keyof FeeDefinitionsCreateDeleteCrErrors];

export type FeeDefinitionsCreateDeleteCrResponses = {
  /**
   * Delete CR created
   */
  201: CreateDeleteCrResponse;
};

export type FeeDefinitionsCreateDeleteCrResponse = FeeDefinitionsCreateDeleteCrResponses[keyof FeeDefinitionsCreateDeleteCrResponses];

export type FeeDefinitionsGetDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/feedefinitions/{actionId}/data';
};

export type FeeDefinitionsGetDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type FeeDefinitionsGetDataError = FeeDefinitionsGetDataErrors[keyof FeeDefinitionsGetDataErrors];

export type FeeDefinitionsGetDataResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfFeeDefinitionChangeDataRow;
};

export type FeeDefinitionsGetDataResponse = FeeDefinitionsGetDataResponses[keyof FeeDefinitionsGetDataResponses];

export type FeeDefinitionsAddOrUpdateDataData = {
  body: AddRowsRequestOfFeeDefinitionChangeDataRow;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: never;
  url: '/feedefinitions/{actionId}/data';
};

export type FeeDefinitionsAddOrUpdateDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type FeeDefinitionsAddOrUpdateDataError = FeeDefinitionsAddOrUpdateDataErrors[keyof FeeDefinitionsAddOrUpdateDataErrors];

export type FeeDefinitionsAddOrUpdateDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type FeeDefinitionsAddOrUpdateDataResponse = FeeDefinitionsAddOrUpdateDataResponses[keyof FeeDefinitionsAddOrUpdateDataResponses];

export type FeeDefinitionsDeleteDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
    rowNumbers: Array<number>;
  };
  query?: never;
  url: '/feedefinitions/{actionId}/data/{rowNumbers}';
};

export type FeeDefinitionsDeleteDataErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type FeeDefinitionsDeleteDataError = FeeDefinitionsDeleteDataErrors[keyof FeeDefinitionsDeleteDataErrors];

export type FeeDefinitionsDeleteDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type FeeDefinitionsDeleteDataResponse = FeeDefinitionsDeleteDataResponses[keyof FeeDefinitionsDeleteDataResponses];

export type FeeDefinitionsGetResultData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/feedefinitions/{actionId}/result';
};

export type FeeDefinitionsGetResultErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Import not finished
   */
  409: ProblemDetails;
};

export type FeeDefinitionsGetResultError = FeeDefinitionsGetResultErrors[keyof FeeDefinitionsGetResultErrors];

export type FeeDefinitionsGetResultResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfFeeDefinitionChangeDataRow;
};

export type FeeDefinitionsGetResultResponse = FeeDefinitionsGetResultResponses[keyof FeeDefinitionsGetResultResponses];

export type FeeProfilesGetAllFeeProfilesData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/feeprofiles';
};

export type FeeProfilesGetAllFeeProfilesErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type FeeProfilesGetAllFeeProfilesError = FeeProfilesGetAllFeeProfilesErrors[keyof FeeProfilesGetAllFeeProfilesErrors];

export type FeeProfilesGetAllFeeProfilesResponses = {
  /**
   * Success
   */
  200: Array<FeeProfile>;
};

export type FeeProfilesGetAllFeeProfilesResponse = FeeProfilesGetAllFeeProfilesResponses[keyof FeeProfilesGetAllFeeProfilesResponses];

export type FeeProfilesCheckUsageData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    feeProfileId: string;
  };
  query?: never;
  url: '/feeprofiles/{feeProfileId}/usage';
};

export type FeeProfilesCheckUsageErrors = {
  /**
   * Invalid Fee Profile ID
   */
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Fee Profile not found
   */
  404: ProblemDetails;
};

export type FeeProfilesCheckUsageError = FeeProfilesCheckUsageErrors[keyof FeeProfilesCheckUsageErrors];

export type FeeProfilesCheckUsageResponses = {
  /**
   * Returns usage status
   */
  200: UsageResponse;
};

export type FeeProfilesCheckUsageResponse = FeeProfilesCheckUsageResponses[keyof FeeProfilesCheckUsageResponses];

export type FeeProfilesCreateChangeRequestData = {
  body: ChangeRequestOfFeeProfileCrudRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/feeprofiles/create';
};

export type FeeProfilesCreateChangeRequestErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type FeeProfilesCreateChangeRequestError = FeeProfilesCreateChangeRequestErrors[keyof FeeProfilesCreateChangeRequestErrors];

export type FeeProfilesCreateChangeRequestResponses = {
  /**
   * Validation or creation result
   */
  200: FeeProfileCrudChangeResponse;
};

export type FeeProfilesCreateChangeRequestResponse = FeeProfilesCreateChangeRequestResponses[keyof FeeProfilesCreateChangeRequestResponses];

export type FeeProfilesValidateDeleteData = {
  body: DeleteCrRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/feeprofiles/validate-delete';
};

export type FeeProfilesValidateDeleteErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type FeeProfilesValidateDeleteError = FeeProfilesValidateDeleteErrors[keyof FeeProfilesValidateDeleteErrors];

export type FeeProfilesValidateDeleteResponses = {
  /**
   * Per-ID validation result
   */
  200: DeletePrecheckResult;
};

export type FeeProfilesValidateDeleteResponse = FeeProfilesValidateDeleteResponses[keyof FeeProfilesValidateDeleteResponses];

export type FeeProfilesCreateDeleteCrData = {
  body: DeleteCrRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/feeprofiles/delete-cr';
};

export type FeeProfilesCreateDeleteCrErrors = {
  /**
   * Nothing to delete
   */
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type FeeProfilesCreateDeleteCrError = FeeProfilesCreateDeleteCrErrors[keyof FeeProfilesCreateDeleteCrErrors];

export type FeeProfilesCreateDeleteCrResponses = {
  /**
   * Delete CR created
   */
  201: CreateDeleteCrResponse;
};

export type FeeProfilesCreateDeleteCrResponse = FeeProfilesCreateDeleteCrResponses[keyof FeeProfilesCreateDeleteCrResponses];

export type FeeProfilesGetDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/feeprofiles/{actionId}/data';
};

export type FeeProfilesGetDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type FeeProfilesGetDataError = FeeProfilesGetDataErrors[keyof FeeProfilesGetDataErrors];

export type FeeProfilesGetDataResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfFeeProfileChangeDataRow;
};

export type FeeProfilesGetDataResponse = FeeProfilesGetDataResponses[keyof FeeProfilesGetDataResponses];

export type FeeProfilesAddOrUpdateDataData = {
  body: AddRowsRequestOfFeeProfileChangeDataRow;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: never;
  url: '/feeprofiles/{actionId}/data';
};

export type FeeProfilesAddOrUpdateDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type FeeProfilesAddOrUpdateDataError = FeeProfilesAddOrUpdateDataErrors[keyof FeeProfilesAddOrUpdateDataErrors];

export type FeeProfilesAddOrUpdateDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type FeeProfilesAddOrUpdateDataResponse = FeeProfilesAddOrUpdateDataResponses[keyof FeeProfilesAddOrUpdateDataResponses];

export type FeeProfilesDeleteDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
    rowNumbers: Array<number>;
  };
  query?: never;
  url: '/feeprofiles/{actionId}/data/{rowNumbers}';
};

export type FeeProfilesDeleteDataErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type FeeProfilesDeleteDataError = FeeProfilesDeleteDataErrors[keyof FeeProfilesDeleteDataErrors];

export type FeeProfilesDeleteDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type FeeProfilesDeleteDataResponse = FeeProfilesDeleteDataResponses[keyof FeeProfilesDeleteDataResponses];

export type FeeProfilesGetResultData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/feeprofiles/{actionId}/result';
};

export type FeeProfilesGetResultErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Import not finished
   */
  409: ProblemDetails;
};

export type FeeProfilesGetResultError = FeeProfilesGetResultErrors[keyof FeeProfilesGetResultErrors];

export type FeeProfilesGetResultResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfFeeProfileChangeDataRow;
};

export type FeeProfilesGetResultResponse = FeeProfilesGetResultResponses[keyof FeeProfilesGetResultResponses];

export type FirmIntermediariesGetFirmAdvisersData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    firmId: string;
  };
  query?: never;
  url: '/firm-intermediaries/{firmId}/advisers';
};

export type FirmIntermediariesGetFirmAdvisersErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type FirmIntermediariesGetFirmAdvisersError = FirmIntermediariesGetFirmAdvisersErrors[keyof FirmIntermediariesGetFirmAdvisersErrors];

export type FirmIntermediariesGetFirmAdvisersResponses = {
  /**
   * Success
   */
  200: Array<FirmIntermediaryByRole>;
};

export type FirmIntermediariesGetFirmAdvisersResponse =
  FirmIntermediariesGetFirmAdvisersResponses[keyof FirmIntermediariesGetFirmAdvisersResponses];

export type FirmIntermediariesGetFirmAssistantsData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    firmId: string;
  };
  query?: never;
  url: '/firm-intermediaries/{firmId}/assistants';
};

export type FirmIntermediariesGetFirmAssistantsErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type FirmIntermediariesGetFirmAssistantsError =
  FirmIntermediariesGetFirmAssistantsErrors[keyof FirmIntermediariesGetFirmAssistantsErrors];

export type FirmIntermediariesGetFirmAssistantsResponses = {
  /**
   * Success
   */
  200: Array<FirmIntermediaryByRole>;
};

export type FirmIntermediariesGetFirmAssistantsResponse =
  FirmIntermediariesGetFirmAssistantsResponses[keyof FirmIntermediariesGetFirmAssistantsResponses];

export type FirmProcFeeAssignmentsGetAllFirmAssignmentsData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    firmId: string;
  };
  query?: never;
  url: '/firm-proc-fee-assignments/{firmId}';
};

export type FirmProcFeeAssignmentsGetAllFirmAssignmentsErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type FirmProcFeeAssignmentsGetAllFirmAssignmentsError =
  FirmProcFeeAssignmentsGetAllFirmAssignmentsErrors[keyof FirmProcFeeAssignmentsGetAllFirmAssignmentsErrors];

export type FirmProcFeeAssignmentsGetAllFirmAssignmentsResponses = {
  /**
   * Success
   */
  200: Array<FirmProcFeeAssignmentItemsResponse>;
};

export type FirmProcFeeAssignmentsGetAllFirmAssignmentsResponse =
  FirmProcFeeAssignmentsGetAllFirmAssignmentsResponses[keyof FirmProcFeeAssignmentsGetAllFirmAssignmentsResponses];

export type FirmProcFeeAssignmentsCreateChangeRequestData = {
  body: ChangeRequestOfDraftFirmProcFeeAssignment;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/firm-proc-fee-assignments';
};

export type FirmProcFeeAssignmentsCreateChangeRequestErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Item to edit not found
   */
  404: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type FirmProcFeeAssignmentsCreateChangeRequestError =
  FirmProcFeeAssignmentsCreateChangeRequestErrors[keyof FirmProcFeeAssignmentsCreateChangeRequestErrors];

export type FirmProcFeeAssignmentsCreateChangeRequestResponses = {
  /**
   * Change Request Created/Validated
   */
  200: FirmProcFeeAssignmentsCrudChangeResponse;
};

export type FirmProcFeeAssignmentsCreateChangeRequestResponse =
  FirmProcFeeAssignmentsCreateChangeRequestResponses[keyof FirmProcFeeAssignmentsCreateChangeRequestResponses];

export type FirmProcFeeAssignmentsValidateDeleteData = {
  body: DeleteGuidRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    firmId: string;
  };
  query?: never;
  url: '/firm-proc-fee-assignments/firm/{firmId}/validate-delete';
};

export type FirmProcFeeAssignmentsValidateDeleteErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type FirmProcFeeAssignmentsValidateDeleteError =
  FirmProcFeeAssignmentsValidateDeleteErrors[keyof FirmProcFeeAssignmentsValidateDeleteErrors];

export type FirmProcFeeAssignmentsValidateDeleteResponses = {
  200: DeleteGuidPrecheckResult;
};

export type FirmProcFeeAssignmentsValidateDeleteResponse =
  FirmProcFeeAssignmentsValidateDeleteResponses[keyof FirmProcFeeAssignmentsValidateDeleteResponses];

export type FirmProcFeeAssignmentsCreateDeleteCrData = {
  body: DeleteGuidRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    firmId: string;
  };
  query?: never;
  url: '/firm-proc-fee-assignments/firm/{firmId}/delete-cr';
};

export type FirmProcFeeAssignmentsCreateDeleteCrErrors = {
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type FirmProcFeeAssignmentsCreateDeleteCrError =
  FirmProcFeeAssignmentsCreateDeleteCrErrors[keyof FirmProcFeeAssignmentsCreateDeleteCrErrors];

export type FirmProcFeeAssignmentsCreateDeleteCrResponses = {
  201: CreateDeleteCrResponse;
};

export type FirmProcFeeAssignmentsCreateDeleteCrResponse =
  FirmProcFeeAssignmentsCreateDeleteCrResponses[keyof FirmProcFeeAssignmentsCreateDeleteCrResponses];

export type FirmProcFeeAssignmentsCreateFirmReorderChangeRequestData = {
  body: ChangeRequestOfListOfDraftFirmProcFeeAssignment;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    firmId: string;
  };
  query?: never;
  url: '/firm-proc-fee-assignments/firm/{firmId}/proc-fee-assignments/reorder';
};

export type FirmProcFeeAssignmentsCreateFirmReorderChangeRequestErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type FirmProcFeeAssignmentsCreateFirmReorderChangeRequestError =
  FirmProcFeeAssignmentsCreateFirmReorderChangeRequestErrors[keyof FirmProcFeeAssignmentsCreateFirmReorderChangeRequestErrors];

export type FirmProcFeeAssignmentsCreateFirmReorderChangeRequestResponses = {
  200: FirmProcFeeAssignmentsCrudChangeResponse;
};

export type FirmProcFeeAssignmentsCreateFirmReorderChangeRequestResponse =
  FirmProcFeeAssignmentsCreateFirmReorderChangeRequestResponses[keyof FirmProcFeeAssignmentsCreateFirmReorderChangeRequestResponses];

export type FirmProcFeeAssignmentsGetDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/firm-proc-fee-assignments/{actionId}/data';
};

export type FirmProcFeeAssignmentsGetDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type FirmProcFeeAssignmentsGetDataError = FirmProcFeeAssignmentsGetDataErrors[keyof FirmProcFeeAssignmentsGetDataErrors];

export type FirmProcFeeAssignmentsGetDataResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfFirmProcFeeAssignmentDataRow;
};

export type FirmProcFeeAssignmentsGetDataResponse = FirmProcFeeAssignmentsGetDataResponses[keyof FirmProcFeeAssignmentsGetDataResponses];

export type FirmProcFeeAssignmentsAddOrUpdateDataData = {
  body: AddRowsRequestOfFirmProcFeeAssignmentDataRow;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: never;
  url: '/firm-proc-fee-assignments/{actionId}/data';
};

export type FirmProcFeeAssignmentsAddOrUpdateDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type FirmProcFeeAssignmentsAddOrUpdateDataError =
  FirmProcFeeAssignmentsAddOrUpdateDataErrors[keyof FirmProcFeeAssignmentsAddOrUpdateDataErrors];

export type FirmProcFeeAssignmentsAddOrUpdateDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type FirmProcFeeAssignmentsAddOrUpdateDataResponse =
  FirmProcFeeAssignmentsAddOrUpdateDataResponses[keyof FirmProcFeeAssignmentsAddOrUpdateDataResponses];

export type FirmProcFeeAssignmentsDeleteDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
    rowNumbers: Array<number>;
  };
  query?: never;
  url: '/firm-proc-fee-assignments/{actionId}/data/{rowNumbers}';
};

export type FirmProcFeeAssignmentsDeleteDataErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type FirmProcFeeAssignmentsDeleteDataError = FirmProcFeeAssignmentsDeleteDataErrors[keyof FirmProcFeeAssignmentsDeleteDataErrors];

export type FirmProcFeeAssignmentsDeleteDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type FirmProcFeeAssignmentsDeleteDataResponse =
  FirmProcFeeAssignmentsDeleteDataResponses[keyof FirmProcFeeAssignmentsDeleteDataResponses];

export type FirmProcFeeAssignmentsGetResultData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/firm-proc-fee-assignments/{actionId}/result';
};

export type FirmProcFeeAssignmentsGetResultErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Import not finished
   */
  409: ProblemDetails;
};

export type FirmProcFeeAssignmentsGetResultError = FirmProcFeeAssignmentsGetResultErrors[keyof FirmProcFeeAssignmentsGetResultErrors];

export type FirmProcFeeAssignmentsGetResultResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfFirmProcFeeAssignmentDataRow;
};

export type FirmProcFeeAssignmentsGetResultResponse =
  FirmProcFeeAssignmentsGetResultResponses[keyof FirmProcFeeAssignmentsGetResultResponses];

export type FirmsGetAllFirmsData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/firms';
};

export type FirmsGetAllFirmsErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type FirmsGetAllFirmsError = FirmsGetAllFirmsErrors[keyof FirmsGetAllFirmsErrors];

export type FirmsGetAllFirmsResponses = {
  /**
   * Success
   */
  200: Array<FirmGetAllResponse>;
};

export type FirmsGetAllFirmsResponse = FirmsGetAllFirmsResponses[keyof FirmsGetAllFirmsResponses];

export type FirmsCreateChangeRequestData = {
  body: ChangeRequestOfFirmDraftDto;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/firms';
};

export type FirmsCreateChangeRequestErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Firm not found
   */
  404: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type FirmsCreateChangeRequestError = FirmsCreateChangeRequestErrors[keyof FirmsCreateChangeRequestErrors];

export type FirmsCreateChangeRequestResponses = {
  /**
   * Change Request Created
   */
  200: FirmCrudChangeResponse;
};

export type FirmsCreateChangeRequestResponse = FirmsCreateChangeRequestResponses[keyof FirmsCreateChangeRequestResponses];

export type FirmsSqeData = {
  body: FirmsSqeRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/firms/sqe';
};

export type FirmsSqeErrors = {
  /**
   * Bad Request
   */
  400: ValidationErrorProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Content Too Large
   */
  413: ProblemDetails;
  /**
   * Unprocessable Content
   */
  422: ValidationErrorProblemDetails;
};

export type FirmsSqeError = FirmsSqeErrors[keyof FirmsSqeErrors];

export type FirmsSqeResponses = {
  /**
   * Success
   */
  200: SqePageOfFirmGetAllResponse;
};

export type FirmsSqeResponse = FirmsSqeResponses[keyof FirmsSqeResponses];

export type FirmsGetFirmData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    firmId: string;
  };
  query?: never;
  url: '/firms/{firmId}';
};

export type FirmsGetFirmErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type FirmsGetFirmError = FirmsGetFirmErrors[keyof FirmsGetFirmErrors];

export type FirmsGetFirmResponses = {
  /**
   * Success
   */
  200: FirmGetById;
};

export type FirmsGetFirmResponse = FirmsGetFirmResponses[keyof FirmsGetFirmResponses];

export type FirmsGetFirmFcaDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    frn: number;
  };
  query?: never;
  url: '/firms/fca-data/{frn}';
};

export type FirmsGetFirmFcaDataErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type FirmsGetFirmFcaDataError = FirmsGetFirmFcaDataErrors[keyof FirmsGetFirmFcaDataErrors];

export type FirmsGetFirmFcaDataResponses = {
  /**
   * Success
   */
  200: FirmFcaData;
};

export type FirmsGetFirmFcaDataResponse = FirmsGetFirmFcaDataResponses[keyof FirmsGetFirmFcaDataResponses];

export type FirmsGetTradingAddressesData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    firmId: string;
  };
  query?: never;
  url: '/firms/{firmId}/trading-addresses';
};

export type FirmsGetTradingAddressesErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Firm not found
   */
  404: ProblemDetails;
};

export type FirmsGetTradingAddressesError = FirmsGetTradingAddressesErrors[keyof FirmsGetTradingAddressesErrors];

export type FirmsGetTradingAddressesResponses = {
  /**
   * Success
   */
  200: Array<TradingAddressResponse>;
};

export type FirmsGetTradingAddressesResponse = FirmsGetTradingAddressesResponses[keyof FirmsGetTradingAddressesResponses];

export type FirmsValidateDeleteData = {
  body: DeleteGuidRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/firms/validate-delete';
};

export type FirmsValidateDeleteErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type FirmsValidateDeleteError = FirmsValidateDeleteErrors[keyof FirmsValidateDeleteErrors];

export type FirmsValidateDeleteResponses = {
  200: DeleteGuidPrecheckResult;
};

export type FirmsValidateDeleteResponse = FirmsValidateDeleteResponses[keyof FirmsValidateDeleteResponses];

export type FirmsCreateDeleteCrData = {
  body: DeleteGuidRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/firms/delete-cr';
};

export type FirmsCreateDeleteCrErrors = {
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type FirmsCreateDeleteCrError = FirmsCreateDeleteCrErrors[keyof FirmsCreateDeleteCrErrors];

export type FirmsCreateDeleteCrResponses = {
  201: CreateDeleteCrResponse;
};

export type FirmsCreateDeleteCrResponse = FirmsCreateDeleteCrResponses[keyof FirmsCreateDeleteCrResponses];

export type FirmsGetDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/firms/{actionId}/data';
};

export type FirmsGetDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type FirmsGetDataError = FirmsGetDataErrors[keyof FirmsGetDataErrors];

export type FirmsGetDataResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfFirmDraftDataRow;
};

export type FirmsGetDataResponse = FirmsGetDataResponses[keyof FirmsGetDataResponses];

export type FirmsAddOrUpdateDataData = {
  body: AddRowsRequestOfFirmDraftDataRow;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: never;
  url: '/firms/{actionId}/data';
};

export type FirmsAddOrUpdateDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type FirmsAddOrUpdateDataError = FirmsAddOrUpdateDataErrors[keyof FirmsAddOrUpdateDataErrors];

export type FirmsAddOrUpdateDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type FirmsAddOrUpdateDataResponse = FirmsAddOrUpdateDataResponses[keyof FirmsAddOrUpdateDataResponses];

export type FirmsDeleteDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
    rowNumbers: Array<number>;
  };
  query?: never;
  url: '/firms/{actionId}/data/{rowNumbers}';
};

export type FirmsDeleteDataErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type FirmsDeleteDataError = FirmsDeleteDataErrors[keyof FirmsDeleteDataErrors];

export type FirmsDeleteDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type FirmsDeleteDataResponse = FirmsDeleteDataResponses[keyof FirmsDeleteDataResponses];

export type FirmsGetResultData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/firms/{actionId}/result';
};

export type FirmsGetResultErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Import not finished
   */
  409: ProblemDetails;
};

export type FirmsGetResultError = FirmsGetResultErrors[keyof FirmsGetResultErrors];

export type FirmsGetResultResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfFirmDraftDataRow;
};

export type FirmsGetResultResponse = FirmsGetResultResponses[keyof FirmsGetResultResponses];

export type UpdateImportMatchingData = {
  body: ImportMatchingRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/importMatching';
};

export type UpdateImportMatchingResponses = {
  /**
   * Success
   */
  200: ImportMatchResponse;
};

export type UpdateImportMatchingResponse = UpdateImportMatchingResponses[keyof UpdateImportMatchingResponses];

export type ImportMatchingGetImportMatchingOfTypeData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    importEntityType: ActionEntityType;
  };
  query?: never;
  url: '/importMatching/{importEntityType}';
};

export type ImportMatchingGetImportMatchingOfTypeResponses = {
  /**
   * Success
   */
  200: Array<ImportMatchResponse>;
};

export type ImportMatchingGetImportMatchingOfTypeResponse =
  ImportMatchingGetImportMatchingOfTypeResponses[keyof ImportMatchingGetImportMatchingOfTypeResponses];

export type ImportSchemasGetImportSchemasData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/import-schemas';
};

export type ImportSchemasGetImportSchemasErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
};

export type ImportSchemasGetImportSchemasError = ImportSchemasGetImportSchemasErrors[keyof ImportSchemasGetImportSchemasErrors];

export type ImportSchemasGetImportSchemasResponses = {
  /**
   * Success
   */
  200: Array<ImportSchemaResponse>;
};

export type ImportSchemasGetImportSchemasResponse = ImportSchemasGetImportSchemasResponses[keyof ImportSchemasGetImportSchemasResponses];

export type ImportSchemasGetAnImportSchemaData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    importEntityType: ActionEntityType;
  };
  query?: never;
  url: '/import-schemas/{importEntityType}';
};

export type ImportSchemasGetAnImportSchemaErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type ImportSchemasGetAnImportSchemaError = ImportSchemasGetAnImportSchemaErrors[keyof ImportSchemasGetAnImportSchemaErrors];

export type ImportSchemasGetAnImportSchemaResponses = {
  /**
   * Success
   */
  200: ImportSchemaResponse;
};

export type ImportSchemasGetAnImportSchemaResponse = ImportSchemasGetAnImportSchemaResponses[keyof ImportSchemasGetAnImportSchemaResponses];

export type ImportsCreateImportData = {
  body: ImportCreateRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/imports';
};

export type ImportsCreateImportErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ImportsCreateImportError = ImportsCreateImportErrors[keyof ImportsCreateImportErrors];

export type ImportsCreateImportResponses = {
  /**
   * Success
   */
  200: ImportResult;
};

export type ImportsCreateImportResponse = ImportsCreateImportResponses[keyof ImportsCreateImportResponses];

export type ImportsDeleteImportData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    importId: string;
  };
  query?: never;
  url: '/imports/{importId}';
};

export type ImportsDeleteImportErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Import started
   */
  409: ProblemDetails;
};

export type ImportsDeleteImportError = ImportsDeleteImportErrors[keyof ImportsDeleteImportErrors];

export type ImportsDeleteImportResponses = {
  /**
   * Success
   */
  204: void;
};

export type ImportsDeleteImportResponse = ImportsDeleteImportResponses[keyof ImportsDeleteImportResponses];

export type ImportsGetImportData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    importId: string;
  };
  query?: never;
  url: '/imports/{importId}';
};

export type ImportsGetImportErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type ImportsGetImportError = ImportsGetImportErrors[keyof ImportsGetImportErrors];

export type ImportsGetImportResponses = {
  /**
   * Success
   */
  200: ImportResult;
};

export type ImportsGetImportResponse = ImportsGetImportResponses[keyof ImportsGetImportResponses];

export type ImportsRecreateImportData = {
  body: ImportCreateRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    importId: string;
  };
  query?: never;
  url: '/imports/{importId}';
};

export type ImportsRecreateImportErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Import started
   */
  409: ProblemDetails;
};

export type ImportsRecreateImportError = ImportsRecreateImportErrors[keyof ImportsRecreateImportErrors];

export type ImportsRecreateImportResponses = {
  /**
   * Success
   */
  200: ImportResult;
};

export type ImportsRecreateImportResponse = ImportsRecreateImportResponses[keyof ImportsRecreateImportResponses];

export type ImportsGetLatestImportsData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: {
    entityType?: ActionEntityType | null;
    limit?: number | null;
  };
  url: '/imports/list';
};

export type ImportsGetLatestImportsErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ImportsGetLatestImportsError = ImportsGetLatestImportsErrors[keyof ImportsGetLatestImportsErrors];

export type ImportsGetLatestImportsResponses = {
  /**
   * Success
   */
  200: Array<ImportResult>;
};

export type ImportsGetLatestImportsResponse = ImportsGetLatestImportsResponses[keyof ImportsGetLatestImportsResponses];

export type ImportsGetImportDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    importId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/imports/{importId}/data';
};

export type ImportsGetImportDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type ImportsGetImportDataError = ImportsGetImportDataErrors[keyof ImportsGetImportDataErrors];

export type ImportsGetImportDataResponses = {
  /**
   * Success
   */
  200: ImportDataResponse;
};

export type ImportsGetImportDataResponse = ImportsGetImportDataResponses[keyof ImportsGetImportDataResponses];

export type ImportsAddImportRowsData = {
  body: ImportAddRowsRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    importId: string;
  };
  query?: never;
  url: '/imports/{importId}/data';
};

export type ImportsAddImportRowsErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Import started
   */
  409: ProblemDetails;
};

export type ImportsAddImportRowsError = ImportsAddImportRowsErrors[keyof ImportsAddImportRowsErrors];

export type ImportsAddImportRowsResponses = {
  /**
   * Success
   */
  200: unknown;
};

export type ImportsUpdateImportCellData = {
  body: ImportUpdateCellRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    importId: string;
  };
  query?: {
    pageSize?: number;
  };
  url: '/imports/{importId}/data';
};

export type ImportsUpdateImportCellErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Import started
   */
  409: ProblemDetails;
};

export type ImportsUpdateImportCellError = ImportsUpdateImportCellErrors[keyof ImportsUpdateImportCellErrors];

export type ImportsUpdateImportCellResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type ImportsUpdateImportCellResponse = ImportsUpdateImportCellResponses[keyof ImportsUpdateImportCellResponses];

export type ImportsDeleteImportRowsData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    importId: string;
    rowNumbers: Array<number>;
  };
  query?: {
    pageSize?: number;
  };
  url: '/imports/{importId}/data/{rowNumbers}';
};

export type ImportsDeleteImportRowsErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Import started
   */
  409: ProblemDetails;
};

export type ImportsDeleteImportRowsError = ImportsDeleteImportRowsErrors[keyof ImportsDeleteImportRowsErrors];

export type ImportsDeleteImportRowsResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type ImportsDeleteImportRowsResponse = ImportsDeleteImportRowsResponses[keyof ImportsDeleteImportRowsResponses];

export type ImportsValidateImportData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    importId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/imports/{importId}/errors';
};

export type ImportsValidateImportErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type ImportsValidateImportError = ImportsValidateImportErrors[keyof ImportsValidateImportErrors];

export type ImportsValidateImportResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type ImportsValidateImportResponse = ImportsValidateImportResponses[keyof ImportsValidateImportResponses];

export type ImportsSubmitForReviewData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    importId: string;
  };
  query?: never;
  url: '/imports/{importId}/submit-for-review';
};

export type ImportsSubmitForReviewErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Import started
   */
  409: ProblemDetails;
  /**
   * Unprocessable entity
   */
  422: OhpenValidationError;
};

export type ImportsSubmitForReviewError = ImportsSubmitForReviewErrors[keyof ImportsSubmitForReviewErrors];

export type ImportsSubmitForReviewResponses = {
  /**
   * Success
   */
  202: unknown;
};

export type InterestRatesCreateChangeRequestData = {
  body: ChangeRequestOfInterestRateRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/interest-rates/create';
};

export type InterestRatesCreateChangeRequestErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type InterestRatesCreateChangeRequestError = InterestRatesCreateChangeRequestErrors[keyof InterestRatesCreateChangeRequestErrors];

export type InterestRatesCreateChangeRequestResponses = {
  /**
   * Validation or creation result
   */
  200: InterestRateCrudChangeResponse;
};

export type InterestRatesCreateChangeRequestResponse =
  InterestRatesCreateChangeRequestResponses[keyof InterestRatesCreateChangeRequestResponses];

export type InterestRatesValidateIrDeleteData = {
  body: DeleteCrRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/interest-rates/interest-rates/validate-delete';
};

export type InterestRatesValidateIrDeleteErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type InterestRatesValidateIrDeleteError = InterestRatesValidateIrDeleteErrors[keyof InterestRatesValidateIrDeleteErrors];

export type InterestRatesValidateIrDeleteResponses = {
  200: DeletePrecheckResult;
};

export type InterestRatesValidateIrDeleteResponse = InterestRatesValidateIrDeleteResponses[keyof InterestRatesValidateIrDeleteResponses];

export type InterestRatesCreateIrDeleteCrData = {
  body: DeleteCrRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/interest-rates/interest-rates/delete-cr';
};

export type InterestRatesCreateIrDeleteCrErrors = {
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type InterestRatesCreateIrDeleteCrError = InterestRatesCreateIrDeleteCrErrors[keyof InterestRatesCreateIrDeleteCrErrors];

export type InterestRatesCreateIrDeleteCrResponses = {
  201: CreateDeleteCrResponse;
};

export type InterestRatesCreateIrDeleteCrResponse = InterestRatesCreateIrDeleteCrResponses[keyof InterestRatesCreateIrDeleteCrResponses];

export type InterestRatesGetDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/interest-rates/{actionId}/data';
};

export type InterestRatesGetDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type InterestRatesGetDataError = InterestRatesGetDataErrors[keyof InterestRatesGetDataErrors];

export type InterestRatesGetDataResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfInterestRateChangeDataRow;
};

export type InterestRatesGetDataResponse = InterestRatesGetDataResponses[keyof InterestRatesGetDataResponses];

export type InterestRatesAddOrUpdateDataData = {
  body: AddRowsRequestOfInterestRateChangeDataRow;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: never;
  url: '/interest-rates/{actionId}/data';
};

export type InterestRatesAddOrUpdateDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type InterestRatesAddOrUpdateDataError = InterestRatesAddOrUpdateDataErrors[keyof InterestRatesAddOrUpdateDataErrors];

export type InterestRatesAddOrUpdateDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type InterestRatesAddOrUpdateDataResponse = InterestRatesAddOrUpdateDataResponses[keyof InterestRatesAddOrUpdateDataResponses];

export type InterestRatesDeleteDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
    rowNumbers: Array<number>;
  };
  query?: never;
  url: '/interest-rates/{actionId}/data/{rowNumbers}';
};

export type InterestRatesDeleteDataErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type InterestRatesDeleteDataError = InterestRatesDeleteDataErrors[keyof InterestRatesDeleteDataErrors];

export type InterestRatesDeleteDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type InterestRatesDeleteDataResponse = InterestRatesDeleteDataResponses[keyof InterestRatesDeleteDataResponses];

export type InterestRatesGetResultData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/interest-rates/{actionId}/result';
};

export type InterestRatesGetResultErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Import not finished
   */
  409: ProblemDetails;
};

export type InterestRatesGetResultError = InterestRatesGetResultErrors[keyof InterestRatesGetResultErrors];

export type InterestRatesGetResultResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfInterestRateChangeDataRow;
};

export type InterestRatesGetResultResponse = InterestRatesGetResultResponses[keyof InterestRatesGetResultResponses];

export type IntermediaryGetAllData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/intermediaries';
};

export type IntermediaryGetAllErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type IntermediaryGetAllError = IntermediaryGetAllErrors[keyof IntermediaryGetAllErrors];

export type IntermediaryGetAllResponses = {
  /**
   * Success
   */
  200: Array<IntermediaryGetAllResponse>;
};

export type IntermediaryGetAllResponse2 = IntermediaryGetAllResponses[keyof IntermediaryGetAllResponses];

export type IntermediaryCreateChangeRequestData = {
  body: ChangeRequestOfIntermediaryDraftDto;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/intermediaries';
};

export type IntermediaryCreateChangeRequestErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Intermediary not found
   */
  404: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type IntermediaryCreateChangeRequestError = IntermediaryCreateChangeRequestErrors[keyof IntermediaryCreateChangeRequestErrors];

export type IntermediaryCreateChangeRequestResponses = {
  /**
   * Change Request Created
   */
  200: IntermediaryCrudChangeResponse;
};

export type IntermediaryCreateChangeRequestResponse =
  IntermediaryCreateChangeRequestResponses[keyof IntermediaryCreateChangeRequestResponses];

export type IntermediariesSqeData = {
  body: IntermediariesSqeRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/intermediaries/sqe';
};

export type IntermediariesSqeErrors = {
  /**
   * Bad Request
   */
  400: ValidationErrorProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Content Too Large
   */
  413: ProblemDetails;
  /**
   * Unprocessable Content
   */
  422: ValidationErrorProblemDetails;
};

export type IntermediariesSqeError = IntermediariesSqeErrors[keyof IntermediariesSqeErrors];

export type IntermediariesSqeResponses = {
  /**
   * Success
   */
  200: SqePageOfIntermediaryGetAllResponse;
};

export type IntermediariesSqeResponse = IntermediariesSqeResponses[keyof IntermediariesSqeResponses];

export type IntermediaryGetByIdData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    id: string;
  };
  query?: never;
  url: '/intermediaries/{id}';
};

export type IntermediaryGetByIdErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type IntermediaryGetByIdError = IntermediaryGetByIdErrors[keyof IntermediaryGetByIdErrors];

export type IntermediaryGetByIdResponses = {
  /**
   * Success
   */
  200: PmpIntermediaryResponse;
};

export type IntermediaryGetByIdResponse = IntermediaryGetByIdResponses[keyof IntermediaryGetByIdResponses];

export type IntermediarySendInvitationEmailData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    id: string;
  };
  query?: never;
  url: '/intermediaries/{id}/send-invite-email';
};

export type IntermediarySendInvitationEmailErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type IntermediarySendInvitationEmailError = IntermediarySendInvitationEmailErrors[keyof IntermediarySendInvitationEmailErrors];

export type IntermediarySendInvitationEmailResponses = {
  /**
   * Success
   */
  204: void;
};

export type IntermediarySendInvitationEmailResponse =
  IntermediarySendInvitationEmailResponses[keyof IntermediarySendInvitationEmailResponses];

export type IntermediaryGetIntermediaryFcaDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    irn: string;
  };
  query?: never;
  url: '/intermediaries/fca-data/{irn}';
};

export type IntermediaryGetIntermediaryFcaDataErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type IntermediaryGetIntermediaryFcaDataError =
  IntermediaryGetIntermediaryFcaDataErrors[keyof IntermediaryGetIntermediaryFcaDataErrors];

export type IntermediaryGetIntermediaryFcaDataResponses = {
  /**
   * Success
   */
  200: IntermediaryFcaData;
};

export type IntermediaryGetIntermediaryFcaDataResponse =
  IntermediaryGetIntermediaryFcaDataResponses[keyof IntermediaryGetIntermediaryFcaDataResponses];

export type IntermediaryValidateDeleteData = {
  body: DeleteGuidRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/intermediaries/validate-delete';
};

export type IntermediaryValidateDeleteErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type IntermediaryValidateDeleteError = IntermediaryValidateDeleteErrors[keyof IntermediaryValidateDeleteErrors];

export type IntermediaryValidateDeleteResponses = {
  200: DeleteGuidPrecheckResult;
};

export type IntermediaryValidateDeleteResponse = IntermediaryValidateDeleteResponses[keyof IntermediaryValidateDeleteResponses];

export type IntermediaryCreateDeleteCrData = {
  body: DeleteGuidRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/intermediaries/delete-cr';
};

export type IntermediaryCreateDeleteCrErrors = {
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type IntermediaryCreateDeleteCrError = IntermediaryCreateDeleteCrErrors[keyof IntermediaryCreateDeleteCrErrors];

export type IntermediaryCreateDeleteCrResponses = {
  201: CreateDeleteCrResponse;
};

export type IntermediaryCreateDeleteCrResponse = IntermediaryCreateDeleteCrResponses[keyof IntermediaryCreateDeleteCrResponses];

export type IntermediaryGetDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/intermediaries/{actionId}/data';
};

export type IntermediaryGetDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type IntermediaryGetDataError = IntermediaryGetDataErrors[keyof IntermediaryGetDataErrors];

export type IntermediaryGetDataResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfIntermediaryDraftDataRow;
};

export type IntermediaryGetDataResponse = IntermediaryGetDataResponses[keyof IntermediaryGetDataResponses];

export type IntermediaryAddOrUpdateDataData = {
  body: AddRowsRequestOfIntermediaryDraftDataRow;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: never;
  url: '/intermediaries/{actionId}/data';
};

export type IntermediaryAddOrUpdateDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type IntermediaryAddOrUpdateDataError = IntermediaryAddOrUpdateDataErrors[keyof IntermediaryAddOrUpdateDataErrors];

export type IntermediaryAddOrUpdateDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type IntermediaryAddOrUpdateDataResponse = IntermediaryAddOrUpdateDataResponses[keyof IntermediaryAddOrUpdateDataResponses];

export type IntermediaryDeleteDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
    rowNumbers: Array<number>;
  };
  query?: never;
  url: '/intermediaries/{actionId}/data/{rowNumbers}';
};

export type IntermediaryDeleteDataErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type IntermediaryDeleteDataError = IntermediaryDeleteDataErrors[keyof IntermediaryDeleteDataErrors];

export type IntermediaryDeleteDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type IntermediaryDeleteDataResponse = IntermediaryDeleteDataResponses[keyof IntermediaryDeleteDataResponses];

export type IntermediaryGetResultData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/intermediaries/{actionId}/result';
};

export type IntermediaryGetResultErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Import not finished
   */
  409: ProblemDetails;
};

export type IntermediaryGetResultError = IntermediaryGetResultErrors[keyof IntermediaryGetResultErrors];

export type IntermediaryGetResultResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfIntermediaryDraftDataRow;
};

export type IntermediaryGetResultResponse = IntermediaryGetResultResponses[keyof IntermediaryGetResultResponses];

export type LendersGetLenderData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/lenders';
};

export type LendersGetLenderErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type LendersGetLenderError = LendersGetLenderErrors[keyof LendersGetLenderErrors];

export type LendersGetLenderResponses = {
  /**
   * The lender
   */
  200: LenderResponse;
};

export type LendersGetLenderResponse = LendersGetLenderResponses[keyof LendersGetLenderResponses];

export type LendersCreateChangeRequestData = {
  body: ChangeRequestOfLenderDraftDto;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/lenders';
};

export type LendersCreateChangeRequestErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Lender not found
   */
  404: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type LendersCreateChangeRequestError = LendersCreateChangeRequestErrors[keyof LendersCreateChangeRequestErrors];

export type LendersCreateChangeRequestResponses = {
  /**
   * Change Request Created
   */
  200: LenderCrudChangeResponse;
};

export type LendersCreateChangeRequestResponse = LendersCreateChangeRequestResponses[keyof LendersCreateChangeRequestResponses];

export type LendersGetDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/lenders/{actionId}/data';
};

export type LendersGetDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type LendersGetDataError = LendersGetDataErrors[keyof LendersGetDataErrors];

export type LendersGetDataResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfLenderDraftDataRow;
};

export type LendersGetDataResponse = LendersGetDataResponses[keyof LendersGetDataResponses];

export type LendersAddOrUpdateDataData = {
  body: AddRowsRequestOfLenderDraftDataRow;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: never;
  url: '/lenders/{actionId}/data';
};

export type LendersAddOrUpdateDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type LendersAddOrUpdateDataError = LendersAddOrUpdateDataErrors[keyof LendersAddOrUpdateDataErrors];

export type LendersAddOrUpdateDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type LendersAddOrUpdateDataResponse = LendersAddOrUpdateDataResponses[keyof LendersAddOrUpdateDataResponses];

export type LendersGetResultData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/lenders/{actionId}/result';
};

export type LendersGetResultErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Change request not applied yet
   */
  409: ProblemDetails;
};

export type LendersGetResultError = LendersGetResultErrors[keyof LendersGetResultErrors];

export type LendersGetResultResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfLenderDraftDataRow;
};

export type LendersGetResultResponse = LendersGetResultResponses[keyof LendersGetResultResponses];

export type NotesGetNotesData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: {
    entityType?: ActionEntityType;
    entityId?: string;
  };
  url: '/notes';
};

export type NotesGetNotesErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type NotesGetNotesError = NotesGetNotesErrors[keyof NotesGetNotesErrors];

export type NotesGetNotesResponses = {
  /**
   * Success
   */
  200: Array<NoteResponse>;
};

export type NotesGetNotesResponse = NotesGetNotesResponses[keyof NotesGetNotesResponses];

export type NotesCreateNoteData = {
  body: DraftNote;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/notes';
};

export type NotesCreateNoteErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type NotesCreateNoteError = NotesCreateNoteErrors[keyof NotesCreateNoteErrors];

export type NotesCreateNoteResponses = {
  /**
   * Note created
   */
  201: NoteResponse;
};

export type NotesCreateNoteResponse = NotesCreateNoteResponses[keyof NotesCreateNoteResponses];

export type NotesDeleteNoteData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    noteId: string;
  };
  query?: {
    entityType?: ActionEntityType;
    entityId?: string;
  };
  url: '/notes/{noteId}';
};

export type NotesDeleteNoteErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Note not found
   */
  404: unknown;
};

export type NotesDeleteNoteError = NotesDeleteNoteErrors[keyof NotesDeleteNoteErrors];

export type NotesDeleteNoteResponses = {
  /**
   * Note deleted
   */
  204: void;
};

export type NotesDeleteNoteResponse = NotesDeleteNoteResponses[keyof NotesDeleteNoteResponses];

export type NotesUpdateNoteData = {
  body: DraftNote;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    noteId: string;
  };
  query?: never;
  url: '/notes/{noteId}';
};

export type NotesUpdateNoteErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Note not found
   */
  404: unknown;
};

export type NotesUpdateNoteError = NotesUpdateNoteErrors[keyof NotesUpdateNoteErrors];

export type NotesUpdateNoteResponses = {
  /**
   * Note updated
   */
  200: NoteResponse;
};

export type NotesUpdateNoteResponse = NotesUpdateNoteResponses[keyof NotesUpdateNoteResponses];

export type OptionsGetAllOptionsForFieldsData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: {
    fields?: Array<FieldType> | null;
  };
  url: '/options';
};

export type OptionsGetAllOptionsForFieldsErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
};

export type OptionsGetAllOptionsForFieldsError = OptionsGetAllOptionsForFieldsErrors[keyof OptionsGetAllOptionsForFieldsErrors];

export type OptionsGetAllOptionsForFieldsResponses = {
  /**
   * Success
   */
  200: OptionsResponse;
};

export type OptionsGetAllOptionsForFieldsResponse = OptionsGetAllOptionsForFieldsResponses[keyof OptionsGetAllOptionsForFieldsResponses];

export type ProcurationFeeAssignmentsGetAllDefaultProcFeeAssignmentsData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/procuration-fee-assignments/default';
};

export type ProcurationFeeAssignmentsGetAllDefaultProcFeeAssignmentsErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ProcurationFeeAssignmentsGetAllDefaultProcFeeAssignmentsError =
  ProcurationFeeAssignmentsGetAllDefaultProcFeeAssignmentsErrors[keyof ProcurationFeeAssignmentsGetAllDefaultProcFeeAssignmentsErrors];

export type ProcurationFeeAssignmentsGetAllDefaultProcFeeAssignmentsResponses = {
  /**
   * Success
   */
  200: Array<ProcFeeAssignmentFeResponse>;
};

export type ProcurationFeeAssignmentsGetAllDefaultProcFeeAssignmentsResponse =
  ProcurationFeeAssignmentsGetAllDefaultProcFeeAssignmentsResponses[keyof ProcurationFeeAssignmentsGetAllDefaultProcFeeAssignmentsResponses];

export type ProcurationFeeAssignmentsGetFirmProcFeeAssignmentsData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    firmId: string;
  };
  query?: never;
  url: '/procuration-fee-assignments/{firmId}';
};

export type ProcurationFeeAssignmentsGetFirmProcFeeAssignmentsErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ProcurationFeeAssignmentsGetFirmProcFeeAssignmentsError =
  ProcurationFeeAssignmentsGetFirmProcFeeAssignmentsErrors[keyof ProcurationFeeAssignmentsGetFirmProcFeeAssignmentsErrors];

export type ProcurationFeeAssignmentsGetFirmProcFeeAssignmentsResponses = {
  /**
   * Success
   */
  200: Array<ProcFeeAssignmentFeResponse>;
};

export type ProcurationFeeAssignmentsGetFirmProcFeeAssignmentsResponse =
  ProcurationFeeAssignmentsGetFirmProcFeeAssignmentsResponses[keyof ProcurationFeeAssignmentsGetFirmProcFeeAssignmentsResponses];

export type ProcurationFeeAssignmentsCreateChangeRequestData = {
  body: ChangeRequestOfDraftProcFeeAssignmentFe;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/procuration-fee-assignments';
};

export type ProcurationFeeAssignmentsCreateChangeRequestErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails2;
};

export type ProcurationFeeAssignmentsCreateChangeRequestError =
  ProcurationFeeAssignmentsCreateChangeRequestErrors[keyof ProcurationFeeAssignmentsCreateChangeRequestErrors];

export type ProcurationFeeAssignmentsCreateChangeRequestResponses = {
  200: ProcFeeAssignmentsCrudChangeResponse;
};

export type ProcurationFeeAssignmentsCreateChangeRequestResponse =
  ProcurationFeeAssignmentsCreateChangeRequestResponses[keyof ProcurationFeeAssignmentsCreateChangeRequestResponses];

export type ProcurationFeeAssignmentsValidateDeleteData = {
  body: DeleteGuidRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/procuration-fee-assignments/validate-delete';
};

export type ProcurationFeeAssignmentsValidateDeleteErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ProcurationFeeAssignmentsValidateDeleteError =
  ProcurationFeeAssignmentsValidateDeleteErrors[keyof ProcurationFeeAssignmentsValidateDeleteErrors];

export type ProcurationFeeAssignmentsValidateDeleteResponses = {
  200: DeleteGuidPrecheckResult;
};

export type ProcurationFeeAssignmentsValidateDeleteResponse =
  ProcurationFeeAssignmentsValidateDeleteResponses[keyof ProcurationFeeAssignmentsValidateDeleteResponses];

export type ProcurationFeeAssignmentsCreateDeleteCrData = {
  body: DeleteGuidRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/procuration-fee-assignments/delete-cr';
};

export type ProcurationFeeAssignmentsCreateDeleteCrErrors = {
  400: ProblemDetails2;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ProcurationFeeAssignmentsCreateDeleteCrError =
  ProcurationFeeAssignmentsCreateDeleteCrErrors[keyof ProcurationFeeAssignmentsCreateDeleteCrErrors];

export type ProcurationFeeAssignmentsCreateDeleteCrResponses = {
  201: CreateDeleteCrResponse;
};

export type ProcurationFeeAssignmentsCreateDeleteCrResponse =
  ProcurationFeeAssignmentsCreateDeleteCrResponses[keyof ProcurationFeeAssignmentsCreateDeleteCrResponses];

export type ProcurationFeeAssignmentsCreateReorderChangeRequestData = {
  body: ChangeRequestOfListOfDraftProcFeeAssignmentFe;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/procuration-fee-assignments/reorder';
};

export type ProcurationFeeAssignmentsCreateReorderChangeRequestErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ProcurationFeeAssignmentsCreateReorderChangeRequestError =
  ProcurationFeeAssignmentsCreateReorderChangeRequestErrors[keyof ProcurationFeeAssignmentsCreateReorderChangeRequestErrors];

export type ProcurationFeeAssignmentsCreateReorderChangeRequestResponses = {
  200: ProcFeeAssignmentsCrudChangeResponse;
};

export type ProcurationFeeAssignmentsCreateReorderChangeRequestResponse =
  ProcurationFeeAssignmentsCreateReorderChangeRequestResponses[keyof ProcurationFeeAssignmentsCreateReorderChangeRequestResponses];

export type ProcurationFeeAssignmentsGetDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/procuration-fee-assignments/{actionId}/data';
};

export type ProcurationFeeAssignmentsGetDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type ProcurationFeeAssignmentsGetDataError = ProcurationFeeAssignmentsGetDataErrors[keyof ProcurationFeeAssignmentsGetDataErrors];

export type ProcurationFeeAssignmentsGetDataResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfProcFeeAssignmentFeDataRow;
};

export type ProcurationFeeAssignmentsGetDataResponse =
  ProcurationFeeAssignmentsGetDataResponses[keyof ProcurationFeeAssignmentsGetDataResponses];

export type ProcurationFeeAssignmentsAddOrUpdateDataData = {
  body: AddRowsRequestOfProcFeeAssignmentFeDataRow;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: never;
  url: '/procuration-fee-assignments/{actionId}/data';
};

export type ProcurationFeeAssignmentsAddOrUpdateDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type ProcurationFeeAssignmentsAddOrUpdateDataError =
  ProcurationFeeAssignmentsAddOrUpdateDataErrors[keyof ProcurationFeeAssignmentsAddOrUpdateDataErrors];

export type ProcurationFeeAssignmentsAddOrUpdateDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type ProcurationFeeAssignmentsAddOrUpdateDataResponse =
  ProcurationFeeAssignmentsAddOrUpdateDataResponses[keyof ProcurationFeeAssignmentsAddOrUpdateDataResponses];

export type ProcurationFeeAssignmentsDeleteDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
    rowNumbers: Array<number>;
  };
  query?: never;
  url: '/procuration-fee-assignments/{actionId}/data/{rowNumbers}';
};

export type ProcurationFeeAssignmentsDeleteDataErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ProcurationFeeAssignmentsDeleteDataError =
  ProcurationFeeAssignmentsDeleteDataErrors[keyof ProcurationFeeAssignmentsDeleteDataErrors];

export type ProcurationFeeAssignmentsDeleteDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type ProcurationFeeAssignmentsDeleteDataResponse =
  ProcurationFeeAssignmentsDeleteDataResponses[keyof ProcurationFeeAssignmentsDeleteDataResponses];

export type ProcurationFeeAssignmentsGetResultData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/procuration-fee-assignments/{actionId}/result';
};

export type ProcurationFeeAssignmentsGetResultErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Import not finished
   */
  409: ProblemDetails;
};

export type ProcurationFeeAssignmentsGetResultError =
  ProcurationFeeAssignmentsGetResultErrors[keyof ProcurationFeeAssignmentsGetResultErrors];

export type ProcurationFeeAssignmentsGetResultResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfProcFeeAssignmentFeDataRow;
};

export type ProcurationFeeAssignmentsGetResultResponse =
  ProcurationFeeAssignmentsGetResultResponses[keyof ProcurationFeeAssignmentsGetResultResponses];

export type ProcurationFeeCalculatorCalculateData = {
  body: GetProcurationFeeRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/procuration-fee-calculator/calculate';
};

export type ProcurationFeeCalculatorCalculateErrors = {
  /**
   * Bad request
   */
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type ProcurationFeeCalculatorCalculateError = ProcurationFeeCalculatorCalculateErrors[keyof ProcurationFeeCalculatorCalculateErrors];

export type ProcurationFeeCalculatorCalculateResponses = {
  /**
   * Success
   */
  200: GetProcurationFeeResponse;
};

export type ProcurationFeeCalculatorCalculateResponse =
  ProcurationFeeCalculatorCalculateResponses[keyof ProcurationFeeCalculatorCalculateResponses];

export type ProcurationFeeCalculatorCalculateV2Data = {
  body: GetProcurationFeeRequestV2;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/procuration-fee-calculator/calculateV2';
};

export type ProcurationFeeCalculatorCalculateV2Errors = {
  /**
   * Bad request
   */
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Conflict
   */
  409: ProblemDetails;
};

export type ProcurationFeeCalculatorCalculateV2Error =
  ProcurationFeeCalculatorCalculateV2Errors[keyof ProcurationFeeCalculatorCalculateV2Errors];

export type ProcurationFeeCalculatorCalculateV2Responses = {
  /**
   * Success
   */
  200: GetProcurationFeeResponseV2;
};

export type ProcurationFeeCalculatorCalculateV2Response =
  ProcurationFeeCalculatorCalculateV2Responses[keyof ProcurationFeeCalculatorCalculateV2Responses];

export type ProcurationFeeRulesGetAllProcurationFeeRulesData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/procuration-fee-rules';
};

export type ProcurationFeeRulesGetAllProcurationFeeRulesErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ProcurationFeeRulesGetAllProcurationFeeRulesError =
  ProcurationFeeRulesGetAllProcurationFeeRulesErrors[keyof ProcurationFeeRulesGetAllProcurationFeeRulesErrors];

export type ProcurationFeeRulesGetAllProcurationFeeRulesResponses = {
  /**
   * Success
   */
  200: Array<ProcurationFeeRuleResponse>;
};

export type ProcurationFeeRulesGetAllProcurationFeeRulesResponse =
  ProcurationFeeRulesGetAllProcurationFeeRulesResponses[keyof ProcurationFeeRulesGetAllProcurationFeeRulesResponses];

export type ProcurationFeeRulesCreateChangeRequestData = {
  body: ChangeRequestOfDraftProcurationFeeRule;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/procuration-fee-rules';
};

export type ProcurationFeeRulesCreateChangeRequestErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Rule to edit not found
   */
  404: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type ProcurationFeeRulesCreateChangeRequestError =
  ProcurationFeeRulesCreateChangeRequestErrors[keyof ProcurationFeeRulesCreateChangeRequestErrors];

export type ProcurationFeeRulesCreateChangeRequestResponses = {
  /**
   * Change Request Created/Validated
   */
  200: ProcurationFeeRulesCrudChangeResponse;
};

export type ProcurationFeeRulesCreateChangeRequestResponse =
  ProcurationFeeRulesCreateChangeRequestResponses[keyof ProcurationFeeRulesCreateChangeRequestResponses];

export type ProcurationFeeRulesCheckUsageData = {
  body: Array<string>;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/procuration-fee-rules/usage';
};

export type ProcurationFeeRulesCheckUsageErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Procuration fee rule not found
   */
  404: ProblemDetails;
};

export type ProcurationFeeRulesCheckUsageError = ProcurationFeeRulesCheckUsageErrors[keyof ProcurationFeeRulesCheckUsageErrors];

export type ProcurationFeeRulesCheckUsageResponses = {
  /**
   * Returns usage status
   */
  200: UsageBatchResponse;
};

export type ProcurationFeeRulesCheckUsageResponse = ProcurationFeeRulesCheckUsageResponses[keyof ProcurationFeeRulesCheckUsageResponses];

export type ProcurationFeeRulesValidateDeleteData = {
  body: DeleteGuidRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/procuration-fee-rules/validate-delete';
};

export type ProcurationFeeRulesValidateDeleteErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ProcurationFeeRulesValidateDeleteError = ProcurationFeeRulesValidateDeleteErrors[keyof ProcurationFeeRulesValidateDeleteErrors];

export type ProcurationFeeRulesValidateDeleteResponses = {
  200: DeleteGuidPrecheckResult;
};

export type ProcurationFeeRulesValidateDeleteResponse =
  ProcurationFeeRulesValidateDeleteResponses[keyof ProcurationFeeRulesValidateDeleteResponses];

export type ProcurationFeeRulesCreateDeleteCrData = {
  body: DeleteGuidRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/procuration-fee-rules/delete-cr';
};

export type ProcurationFeeRulesCreateDeleteCrErrors = {
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ProcurationFeeRulesCreateDeleteCrError = ProcurationFeeRulesCreateDeleteCrErrors[keyof ProcurationFeeRulesCreateDeleteCrErrors];

export type ProcurationFeeRulesCreateDeleteCrResponses = {
  201: CreateDeleteCrResponse;
};

export type ProcurationFeeRulesCreateDeleteCrResponse =
  ProcurationFeeRulesCreateDeleteCrResponses[keyof ProcurationFeeRulesCreateDeleteCrResponses];

export type ProcurationFeeRulesGetDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/procuration-fee-rules/{actionId}/data';
};

export type ProcurationFeeRulesGetDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type ProcurationFeeRulesGetDataError = ProcurationFeeRulesGetDataErrors[keyof ProcurationFeeRulesGetDataErrors];

export type ProcurationFeeRulesGetDataResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfProcurationFeeRuleDataRow;
};

export type ProcurationFeeRulesGetDataResponse = ProcurationFeeRulesGetDataResponses[keyof ProcurationFeeRulesGetDataResponses];

export type ProcurationFeeRulesAddOrUpdateDataData = {
  body: AddRowsRequestOfProcurationFeeRuleDataRow;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: never;
  url: '/procuration-fee-rules/{actionId}/data';
};

export type ProcurationFeeRulesAddOrUpdateDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type ProcurationFeeRulesAddOrUpdateDataError =
  ProcurationFeeRulesAddOrUpdateDataErrors[keyof ProcurationFeeRulesAddOrUpdateDataErrors];

export type ProcurationFeeRulesAddOrUpdateDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type ProcurationFeeRulesAddOrUpdateDataResponse =
  ProcurationFeeRulesAddOrUpdateDataResponses[keyof ProcurationFeeRulesAddOrUpdateDataResponses];

export type ProcurationFeeRulesDeleteDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
    rowNumbers: Array<number>;
  };
  query?: never;
  url: '/procuration-fee-rules/{actionId}/data/{rowNumbers}';
};

export type ProcurationFeeRulesDeleteDataErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ProcurationFeeRulesDeleteDataError = ProcurationFeeRulesDeleteDataErrors[keyof ProcurationFeeRulesDeleteDataErrors];

export type ProcurationFeeRulesDeleteDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type ProcurationFeeRulesDeleteDataResponse = ProcurationFeeRulesDeleteDataResponses[keyof ProcurationFeeRulesDeleteDataResponses];

export type ProcurationFeeRulesGetResultData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/procuration-fee-rules/{actionId}/result';
};

export type ProcurationFeeRulesGetResultErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Import not finished
   */
  409: ProblemDetails;
};

export type ProcurationFeeRulesGetResultError = ProcurationFeeRulesGetResultErrors[keyof ProcurationFeeRulesGetResultErrors];

export type ProcurationFeeRulesGetResultResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfProcurationFeeRuleDataRow;
};

export type ProcurationFeeRulesGetResultResponse = ProcurationFeeRulesGetResultResponses[keyof ProcurationFeeRulesGetResultResponses];

export type ProcurationFeesGetAllProcurationFeesData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/procuration-fees';
};

export type ProcurationFeesGetAllProcurationFeesErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ProcurationFeesGetAllProcurationFeesError =
  ProcurationFeesGetAllProcurationFeesErrors[keyof ProcurationFeesGetAllProcurationFeesErrors];

export type ProcurationFeesGetAllProcurationFeesResponses = {
  /**
   * Success
   */
  200: Array<ProcurationFeeItemsResponse>;
};

export type ProcurationFeesGetAllProcurationFeesResponse =
  ProcurationFeesGetAllProcurationFeesResponses[keyof ProcurationFeesGetAllProcurationFeesResponses];

export type ProcurationFeesCreateChangeRequestData = {
  body: ChangeRequestOfNormalizedDraftProcurationFee;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/procuration-fees';
};

export type ProcurationFeesCreateChangeRequestErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * The Set you are trying to edit could not be found
   */
  404: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type ProcurationFeesCreateChangeRequestError =
  ProcurationFeesCreateChangeRequestErrors[keyof ProcurationFeesCreateChangeRequestErrors];

export type ProcurationFeesCreateChangeRequestResponses = {
  /**
   * Change Request Created
   */
  200: ProcurationFeeCrudChangeResponse;
};

export type ProcurationFeesCreateChangeRequestResponse =
  ProcurationFeesCreateChangeRequestResponses[keyof ProcurationFeesCreateChangeRequestResponses];

export type ProcurationFeesCheckUsageData = {
  body: Array<string>;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/procuration-fees/usage';
};

export type ProcurationFeesCheckUsageErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Procuration fee rule not found
   */
  404: ProblemDetails;
};

export type ProcurationFeesCheckUsageError = ProcurationFeesCheckUsageErrors[keyof ProcurationFeesCheckUsageErrors];

export type ProcurationFeesCheckUsageResponses = {
  /**
   * Returns usage status
   */
  200: UsageBatchResponse;
};

export type ProcurationFeesCheckUsageResponse = ProcurationFeesCheckUsageResponses[keyof ProcurationFeesCheckUsageResponses];

export type ProcurationFeesValidateDeleteData = {
  body: DeleteGuidRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/procuration-fees/validate-delete';
};

export type ProcurationFeesValidateDeleteErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ProcurationFeesValidateDeleteError = ProcurationFeesValidateDeleteErrors[keyof ProcurationFeesValidateDeleteErrors];

export type ProcurationFeesValidateDeleteResponses = {
  200: DeleteGuidPrecheckResult;
};

export type ProcurationFeesValidateDeleteResponse = ProcurationFeesValidateDeleteResponses[keyof ProcurationFeesValidateDeleteResponses];

export type ProcurationFeesCreateDeleteCrData = {
  body: DeleteGuidRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/procuration-fees/delete-cr';
};

export type ProcurationFeesCreateDeleteCrErrors = {
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ProcurationFeesCreateDeleteCrError = ProcurationFeesCreateDeleteCrErrors[keyof ProcurationFeesCreateDeleteCrErrors];

export type ProcurationFeesCreateDeleteCrResponses = {
  201: CreateDeleteCrResponse;
};

export type ProcurationFeesCreateDeleteCrResponse = ProcurationFeesCreateDeleteCrResponses[keyof ProcurationFeesCreateDeleteCrResponses];

export type ProcurationFeesGetDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/procuration-fees/{actionId}/data';
};

export type ProcurationFeesGetDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type ProcurationFeesGetDataError = ProcurationFeesGetDataErrors[keyof ProcurationFeesGetDataErrors];

export type ProcurationFeesGetDataResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfProcurationFeeDataRow;
};

export type ProcurationFeesGetDataResponse = ProcurationFeesGetDataResponses[keyof ProcurationFeesGetDataResponses];

export type ProcurationFeesAddOrUpdateDataData = {
  body: AddRowsRequestOfProcurationFeeDataRow;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: never;
  url: '/procuration-fees/{actionId}/data';
};

export type ProcurationFeesAddOrUpdateDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type ProcurationFeesAddOrUpdateDataError = ProcurationFeesAddOrUpdateDataErrors[keyof ProcurationFeesAddOrUpdateDataErrors];

export type ProcurationFeesAddOrUpdateDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type ProcurationFeesAddOrUpdateDataResponse = ProcurationFeesAddOrUpdateDataResponses[keyof ProcurationFeesAddOrUpdateDataResponses];

export type ProcurationFeesDeleteDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
    rowNumbers: Array<number>;
  };
  query?: never;
  url: '/procuration-fees/{actionId}/data/{rowNumbers}';
};

export type ProcurationFeesDeleteDataErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ProcurationFeesDeleteDataError = ProcurationFeesDeleteDataErrors[keyof ProcurationFeesDeleteDataErrors];

export type ProcurationFeesDeleteDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type ProcurationFeesDeleteDataResponse = ProcurationFeesDeleteDataResponses[keyof ProcurationFeesDeleteDataResponses];

export type ProcurationFeesGetResultData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/procuration-fees/{actionId}/result';
};

export type ProcurationFeesGetResultErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Import not finished
   */
  409: ProblemDetails;
};

export type ProcurationFeesGetResultError = ProcurationFeesGetResultErrors[keyof ProcurationFeesGetResultErrors];

export type ProcurationFeesGetResultResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfProcurationFeeDataRow;
};

export type ProcurationFeesGetResultResponse = ProcurationFeesGetResultResponses[keyof ProcurationFeesGetResultResponses];

export type ProductChangesGetDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/products/changes/{actionId}/data';
};

export type ProductChangesGetDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type ProductChangesGetDataError = ProductChangesGetDataErrors[keyof ProductChangesGetDataErrors];

export type ProductChangesGetDataResponses = {
  /**
   * Success
   */
  200: ProductChangeDataResponse;
};

export type ProductChangesGetDataResponse = ProductChangesGetDataResponses[keyof ProductChangesGetDataResponses];

export type ProductChangesAddOrUpdateDataData = {
  body: ProductChangeAddRowsRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: never;
  url: '/products/changes/{actionId}/data';
};

export type ProductChangesAddOrUpdateDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type ProductChangesAddOrUpdateDataError = ProductChangesAddOrUpdateDataErrors[keyof ProductChangesAddOrUpdateDataErrors];

export type ProductChangesAddOrUpdateDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type ProductChangesAddOrUpdateDataResponse = ProductChangesAddOrUpdateDataResponses[keyof ProductChangesAddOrUpdateDataResponses];

export type ProductChangesDeleteDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
    rowNumbers: Array<number>;
  };
  query?: never;
  url: '/products/changes/{actionId}/data/{rowNumbers}';
};

export type ProductChangesDeleteDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type ProductChangesDeleteDataError = ProductChangesDeleteDataErrors[keyof ProductChangesDeleteDataErrors];

export type ProductChangesDeleteDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type ProductChangesDeleteDataResponse = ProductChangesDeleteDataResponses[keyof ProductChangesDeleteDataResponses];

export type ProductChangesSubmitForReviewData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: never;
  url: '/products/changes/{actionId}/submit-for-review';
};

export type ProductChangesSubmitForReviewErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Import started
   */
  409: ProblemDetails;
  /**
   * Unprocessable entity
   */
  422: OhpenValidationError;
};

export type ProductChangesSubmitForReviewError = ProductChangesSubmitForReviewErrors[keyof ProductChangesSubmitForReviewErrors];

export type ProductChangesSubmitForReviewResponses = {
  /**
   * Success
   */
  202: unknown;
};

export type ProductChangesGetResultData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/products/changes/{actionId}/result';
};

export type ProductChangesGetResultErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Import not finished
   */
  409: ProblemDetails;
};

export type ProductChangesGetResultError = ProductChangesGetResultErrors[keyof ProductChangesGetResultErrors];

export type ProductChangesGetResultResponses = {
  /**
   * Success
   */
  200: ProductChangeResultResponse;
};

export type ProductChangesGetResultResponse = ProductChangesGetResultResponses[keyof ProductChangesGetResultResponses];

export type ProductChangesApplyColumnDeltaData = {
  body: ColumnDeltaUpdateRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: never;
  url: '/products/changes/{actionId}/apply-column-delta';
};

export type ProductChangesApplyColumnDeltaErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type ProductChangesApplyColumnDeltaError = ProductChangesApplyColumnDeltaErrors[keyof ProductChangesApplyColumnDeltaErrors];

export type ProductChangesApplyColumnDeltaResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type ProductChangesApplyColumnDeltaResponse = ProductChangesApplyColumnDeltaResponses[keyof ProductChangesApplyColumnDeltaResponses];

export type ProductExclusivitySetsGetAllSetsData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/products/exclusivitySets';
};

export type ProductExclusivitySetsGetAllSetsErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ProductExclusivitySetsGetAllSetsError = ProductExclusivitySetsGetAllSetsErrors[keyof ProductExclusivitySetsGetAllSetsErrors];

export type ProductExclusivitySetsGetAllSetsResponses = {
  /**
   * Success
   */
  200: Array<ExclusivitySetResponse>;
};

export type ProductExclusivitySetsGetAllSetsResponse =
  ProductExclusivitySetsGetAllSetsResponses[keyof ProductExclusivitySetsGetAllSetsResponses];

export type ProductExclusivitySetsCreateChangeRequestData = {
  body: ChangeRequestOfExclusivitySetRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/products/exclusivitySets';
};

export type ProductExclusivitySetsCreateChangeRequestErrors = {
  /**
   * Invalid data
   */
  400: ExclusivitySetsCrudChangeResponse;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * The Set you are trying to edit could not be found
   */
  404: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type ProductExclusivitySetsCreateChangeRequestError =
  ProductExclusivitySetsCreateChangeRequestErrors[keyof ProductExclusivitySetsCreateChangeRequestErrors];

export type ProductExclusivitySetsCreateChangeRequestResponses = {
  /**
   * Change Request Created
   */
  200: ExclusivitySetsCrudChangeResponse;
};

export type ProductExclusivitySetsCreateChangeRequestResponse =
  ProductExclusivitySetsCreateChangeRequestResponses[keyof ProductExclusivitySetsCreateChangeRequestResponses];

export type ProductExclusivitySetsCheckUsageData = {
  body: Array<string>;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/products/exclusivitySets/usage';
};

export type ProductExclusivitySetsCheckUsageErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Exclusivity set not found
   */
  404: ProblemDetails;
};

export type ProductExclusivitySetsCheckUsageError = ProductExclusivitySetsCheckUsageErrors[keyof ProductExclusivitySetsCheckUsageErrors];

export type ProductExclusivitySetsCheckUsageResponses = {
  /**
   * Returns usage status
   */
  200: UsageBatchResponse;
};

export type ProductExclusivitySetsCheckUsageResponse =
  ProductExclusivitySetsCheckUsageResponses[keyof ProductExclusivitySetsCheckUsageResponses];

export type ProductExclusivitySetsValidateDeleteData = {
  body: DeleteGuidRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/products/exclusivitySets/validate-delete';
};

export type ProductExclusivitySetsValidateDeleteErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ProductExclusivitySetsValidateDeleteError =
  ProductExclusivitySetsValidateDeleteErrors[keyof ProductExclusivitySetsValidateDeleteErrors];

export type ProductExclusivitySetsValidateDeleteResponses = {
  200: DeleteGuidPrecheckResult;
};

export type ProductExclusivitySetsValidateDeleteResponse =
  ProductExclusivitySetsValidateDeleteResponses[keyof ProductExclusivitySetsValidateDeleteResponses];

export type ProductExclusivitySetsCreateDeleteCrData = {
  body: DeleteGuidRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/products/exclusivitySets/delete-cr';
};

export type ProductExclusivitySetsCreateDeleteCrErrors = {
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ProductExclusivitySetsCreateDeleteCrError =
  ProductExclusivitySetsCreateDeleteCrErrors[keyof ProductExclusivitySetsCreateDeleteCrErrors];

export type ProductExclusivitySetsCreateDeleteCrResponses = {
  201: CreateDeleteCrResponse;
};

export type ProductExclusivitySetsCreateDeleteCrResponse =
  ProductExclusivitySetsCreateDeleteCrResponses[keyof ProductExclusivitySetsCreateDeleteCrResponses];

export type ProductExclusivitySetsGetDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/products/exclusivitySets/{actionId}/data';
};

export type ProductExclusivitySetsGetDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
};

export type ProductExclusivitySetsGetDataError = ProductExclusivitySetsGetDataErrors[keyof ProductExclusivitySetsGetDataErrors];

export type ProductExclusivitySetsGetDataResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfExclusivitySetDataRow;
};

export type ProductExclusivitySetsGetDataResponse = ProductExclusivitySetsGetDataResponses[keyof ProductExclusivitySetsGetDataResponses];

export type ProductExclusivitySetsAddOrUpdateDataData = {
  body: AddRowsRequestOfExclusivitySetDataRow;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: never;
  url: '/products/exclusivitySets/{actionId}/data';
};

export type ProductExclusivitySetsAddOrUpdateDataErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Change request locked
   */
  409: ProblemDetails;
};

export type ProductExclusivitySetsAddOrUpdateDataError =
  ProductExclusivitySetsAddOrUpdateDataErrors[keyof ProductExclusivitySetsAddOrUpdateDataErrors];

export type ProductExclusivitySetsAddOrUpdateDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type ProductExclusivitySetsAddOrUpdateDataResponse =
  ProductExclusivitySetsAddOrUpdateDataResponses[keyof ProductExclusivitySetsAddOrUpdateDataResponses];

export type ProductExclusivitySetsDeleteDataData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
    rowNumbers: Array<number>;
  };
  query?: never;
  url: '/products/exclusivitySets/{actionId}/data/{rowNumbers}';
};

export type ProductExclusivitySetsDeleteDataErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type ProductExclusivitySetsDeleteDataError = ProductExclusivitySetsDeleteDataErrors[keyof ProductExclusivitySetsDeleteDataErrors];

export type ProductExclusivitySetsDeleteDataResponses = {
  /**
   * Success
   */
  200: ChangeRequestValidationResponse;
};

export type ProductExclusivitySetsDeleteDataResponse =
  ProductExclusivitySetsDeleteDataResponses[keyof ProductExclusivitySetsDeleteDataResponses];

export type ProductExclusivitySetsGetResultData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    actionId: string;
  };
  query?: {
    paginationToken?: string | null;
    pageSize?: number;
  };
  url: '/products/exclusivitySets/{actionId}/result';
};

export type ProductExclusivitySetsGetResultErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not found
   */
  404: ProblemDetails;
  /**
   * Import not finished
   */
  409: ProblemDetails;
};

export type ProductExclusivitySetsGetResultError = ProductExclusivitySetsGetResultErrors[keyof ProductExclusivitySetsGetResultErrors];

export type ProductExclusivitySetsGetResultResponses = {
  /**
   * Success
   */
  200: ChangeDataResponseOfExclusivitySetDataRow;
};

export type ProductExclusivitySetsGetResultResponse =
  ProductExclusivitySetsGetResultResponses[keyof ProductExclusivitySetsGetResultResponses];

export type ProductsGetAllProductsData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: {
    startYear?: number | null;
    endYear?: number | null;
  };
  url: '/products';
};

export type ProductsGetAllProductsErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
};

export type ProductsGetAllProductsError = ProductsGetAllProductsErrors[keyof ProductsGetAllProductsErrors];

export type ProductsGetAllProductsResponses = {
  /**
   * Success
   */
  200: Array<ProductResponse>;
};

export type ProductsGetAllProductsResponse = ProductsGetAllProductsResponses[keyof ProductsGetAllProductsResponses];

export type ProductsSqeData = {
  body: ProductsSqeRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/products/sqe';
};

export type ProductsSqeErrors = {
  /**
   * Bad Request
   */
  400: ValidationErrorProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Content Too Large
   */
  413: ProblemDetails;
  /**
   * Unprocessable Content
   */
  422: ValidationErrorProblemDetails;
};

export type ProductsSqeError = ProductsSqeErrors[keyof ProductsSqeErrors];

export type ProductsSqeResponses = {
  /**
   * Success
   */
  200: SqePageOfProductResponse;
};

export type ProductsSqeResponse = ProductsSqeResponses[keyof ProductsSqeResponses];

export type ProductsGetProductCodesData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: {
    startYear?: number | null;
    endYear?: number | null;
  };
  url: '/products/product-codes';
};

export type ProductsGetProductCodesErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
};

export type ProductsGetProductCodesError = ProductsGetProductCodesErrors[keyof ProductsGetProductCodesErrors];

export type ProductsGetProductCodesResponses = {
  /**
   * Success
   */
  200: Array<ProductCodesResponse>;
};

export type ProductsGetProductCodesResponse = ProductsGetProductCodesResponses[keyof ProductsGetProductCodesResponses];

export type ProductsGetBoSyncStatusData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    productCode: string;
  };
  query?: never;
  url: '/products/{productCode}/bo-sync-status';
};

export type ProductsGetBoSyncStatusErrors = {
  /**
   * The sync to BO is not active
   */
  400: OhpenValidationError;
  /**
   * Product not found
   */
  404: ProblemDetails;
};

export type ProductsGetBoSyncStatusError = ProductsGetBoSyncStatusErrors[keyof ProductsGetBoSyncStatusErrors];

export type ProductsGetBoSyncStatusResponses = {
  /**
   * Success
   */
  200: BoSyncStatusResponse;
};

export type ProductsGetBoSyncStatusResponse = ProductsGetBoSyncStatusResponses[keyof ProductsGetBoSyncStatusResponses];

export type RegionGetAllData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/regions';
};

export type RegionGetAllErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
};

export type RegionGetAllError = RegionGetAllErrors[keyof RegionGetAllErrors];

export type RegionGetAllResponses = {
  /**
   * Success
   */
  200: Array<RegionResponse>;
};

export type RegionGetAllResponse = RegionGetAllResponses[keyof RegionGetAllResponses];

export type RegionCreateData = {
  body: RegionRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/regions';
};

export type RegionCreateErrors = {
  /**
   * Duplicate region name
   */
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Region name already exists
   */
  409: ProblemDetails;
};

export type RegionCreateError = RegionCreateErrors[keyof RegionCreateErrors];

export type RegionCreateResponses = {
  /**
   * Created
   */
  201: RegionResponse;
};

export type RegionCreateResponse = RegionCreateResponses[keyof RegionCreateResponses];

export type RegionDeleteData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    id: string;
  };
  query?: never;
  url: '/regions/{id}';
};

export type RegionDeleteErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not Found
   */
  404: ProblemDetails;
  /**
   * Region in use
   */
  409: ProblemDetails;
};

export type RegionDeleteError = RegionDeleteErrors[keyof RegionDeleteErrors];

export type RegionDeleteResponses = {
  /**
   * No Content
   */
  204: void;
};

export type RegionDeleteResponse = RegionDeleteResponses[keyof RegionDeleteResponses];

export type RegionGetByIdData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    id: string;
  };
  query?: never;
  url: '/regions/{id}';
};

export type RegionGetByIdErrors = {
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not Found
   */
  404: ProblemDetails;
};

export type RegionGetByIdError = RegionGetByIdErrors[keyof RegionGetByIdErrors];

export type RegionGetByIdResponses = {
  /**
   * Success
   */
  200: RegionResponse;
};

export type RegionGetByIdResponse = RegionGetByIdResponses[keyof RegionGetByIdResponses];

export type RegionUpdateData = {
  body: RegionRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    id: string;
  };
  query?: never;
  url: '/regions/{id}';
};

export type RegionUpdateErrors = {
  /**
   * Duplicate region name
   */
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not Found
   */
  404: ProblemDetails;
  /**
   * Region name already exists or a removed BDM still has assigned addresses here
   */
  409: ProblemDetails;
};

export type RegionUpdateError = RegionUpdateErrors[keyof RegionUpdateErrors];

export type RegionUpdateResponses = {
  /**
   * Success
   */
  200: RegionResponse;
};

export type RegionUpdateResponse = RegionUpdateResponses[keyof RegionUpdateResponses];

export type RegionReplaceData = {
  body: RegionReplaceRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    id: string;
  };
  query?: never;
  url: '/regions/{id}/replace';
};

export type RegionReplaceErrors = {
  /**
   * Invalid replacement
   */
  400: ProblemDetails;
  /**
   * Unauthorized
   */
  401: ProblemDetails;
  /**
   * Not Found
   */
  404: ProblemDetails;
  /**
   * Conflict
   */
  409: ProblemDetails;
};

export type RegionReplaceError = RegionReplaceErrors[keyof RegionReplaceErrors];

export type RegionReplaceResponses = {
  /**
   * No Content
   */
  204: void;
};

export type RegionReplaceResponse = RegionReplaceResponses[keyof RegionReplaceResponses];

export type StaffGetAllData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/staff';
};

export type StaffGetAllResponses = {
  200: Array<PmpStaffResponse>;
};

export type StaffGetAllResponse = StaffGetAllResponses[keyof StaffGetAllResponses];

export type StaffGetByIdData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    id: string;
  };
  query?: never;
  url: '/staff/{id}';
};

export type StaffGetByIdErrors = {
  404: ProblemDetails;
};

export type StaffGetByIdError = StaffGetByIdErrors[keyof StaffGetByIdErrors];

export type StaffGetByIdResponses = {
  200: PmpStaffResponse;
};

export type StaffGetByIdResponse = StaffGetByIdResponses[keyof StaffGetByIdResponses];

export type CreateTableViewData = {
  body: CreateTableViewRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/tableViews';
};

export type CreateTableViewErrors = {
  /**
   * Failure
   */
  400: OhpenValidationError;
};

export type CreateTableViewError = CreateTableViewErrors[keyof CreateTableViewErrors];

export type CreateTableViewResponses = {
  /**
   * Success
   */
  200: TableViewResponse;
};

export type CreateTableViewResponse = CreateTableViewResponses[keyof CreateTableViewResponses];

export type GetTableViewsForADataTypeData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    entityType: ActionEntityType;
  };
  query?: never;
  url: '/tableViews/{entityType}';
};

export type GetTableViewsForADataTypeResponses = {
  /**
   * Success
   */
  200: Array<TableViewResponse>;
};

export type GetTableViewsForADataTypeResponse = GetTableViewsForADataTypeResponses[keyof GetTableViewsForADataTypeResponses];

export type DeleteTableViewData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    viewId: string;
  };
  query?: never;
  url: '/tableViews/{viewId}';
};

export type DeleteTableViewErrors = {
  /**
   * Bad Request
   */
  400: OhpenValidationError;
  /**
   * Table View Not Found
   */
  404: ProblemDetails;
  /**
   * Concurrent Update
   */
  409: ProblemDetails;
};

export type DeleteTableViewError = DeleteTableViewErrors[keyof DeleteTableViewErrors];

export type DeleteTableViewResponses = {
  /**
   * Success
   */
  204: void;
};

export type DeleteTableViewResponse = DeleteTableViewResponses[keyof DeleteTableViewResponses];

export type UpdateTableViewsData = {
  body: CreateTableViewRequest;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    viewId: string;
  };
  query?: {
    version?: number;
  };
  url: '/tableViews/{viewId}';
};

export type UpdateTableViewsErrors = {
  /**
   * Failure
   */
  400: OhpenValidationError;
  /**
   * Table View Not Found
   */
  404: ProblemDetails;
  /**
   * Concurrent Update
   */
  409: ProblemDetails;
};

export type UpdateTableViewsError = UpdateTableViewsErrors[keyof UpdateTableViewsErrors];

export type UpdateTableViewsResponses = {
  /**
   * Success
   */
  200: TableViewResponse;
};

export type UpdateTableViewsResponse = UpdateTableViewsResponses[keyof UpdateTableViewsResponses];

export type TranslationsGetTranslationsData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: {
    language?: string;
  };
  url: '/translations';
};

export type TranslationsGetTranslationsErrors = {
  /**
   * No translations found
   */
  404: ProblemDetails;
};

export type TranslationsGetTranslationsError = TranslationsGetTranslationsErrors[keyof TranslationsGetTranslationsErrors];

export type TranslationsGetTranslationsResponses = {
  /**
   * Success
   */
  200: Array<Translation>;
};

export type TranslationsGetTranslationsResponse = TranslationsGetTranslationsResponses[keyof TranslationsGetTranslationsResponses];

export type TranslationsGetTranslationData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path: {
    term: string;
  };
  query?: {
    language?: string;
  };
  url: '/translations/{term}';
};

export type TranslationsGetTranslationErrors = {
  /**
   * Translation not found
   */
  404: ProblemDetails;
};

export type TranslationsGetTranslationError = TranslationsGetTranslationErrors[keyof TranslationsGetTranslationErrors];

export type TranslationsGetTranslationResponses = {
  /**
   * Success
   */
  200: Translation;
};

export type TranslationsGetTranslationResponse = TranslationsGetTranslationResponses[keyof TranslationsGetTranslationResponses];

export type UsersGetAllData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/users';
};

export type UsersGetAllResponses = {
  200: Array<UserResponse>;
};

export type UsersGetAllResponse = UsersGetAllResponses[keyof UsersGetAllResponses];

export type UsersGetCurrentUserPermissionsData = {
  body?: never;
  headers?: {
    /**
     * Version of the caller bff application
     */
    'Accept-Version'?: string;
  };
  path?: never;
  query?: never;
  url: '/users/me/permissions';
};

export type UsersGetCurrentUserPermissionsResponses = {
  200: {
    [key: string]: Array<PermissionAction>;
  };
};

export type UsersGetCurrentUserPermissionsResponse = UsersGetCurrentUserPermissionsResponses[keyof UsersGetCurrentUserPermissionsResponses];
